/**
 * Generated MDI alias map - DO NOT EDIT
 * 
 * Generated from @mdi/svg metadata
 * Icons: 7447, Aliases: 6476
 * 
 * Run: pnpm generate:icons to regenerate
 */

export const MDI_ALIAS_MAP: Record<string, string> = {
	"123": "numeric",
	"writing-system-arabic": "abjad-arabic",
	"writing-system-hebrew": "abjad-hebrew",
	"writing-system-devanagari": "abugida-devanagari",
	"writing-system-thai": "abugida-thai",
	"wireless": "access-point",
	"access-point-success": "access-point-check",
	"access-point-tick": "access-point-check",
	"person": "account",
	"user": "account",
	"user-alert": "account-alert",
	"account-warning": "account-alert",
	"user-warning": "account-alert",
	"person-alert": "account-alert",
	"person-warning": "account-alert",
	"user-alert-outline": "account-alert-outline",
	"account-warning-outline": "account-alert-outline",
	"user-warning-outline": "account-alert-outline",
	"person-warning-outline": "account-alert-outline",
	"person-alert-outline": "account-alert-outline",
	"account-download": "account-arrow-down",
	"account-download-outline": "account-arrow-down-outline",
	"user-arrow-left": "account-arrow-left",
	"person-arrow-left": "account-arrow-left",
	"user-arrow-left-outline": "account-arrow-left-outline",
	"person-arrow-left-outline": "account-arrow-left-outline",
	"user-arrow-right": "account-arrow-right",
	"person-arrow-right": "account-arrow-right",
	"user-arrow-right-outline": "account-arrow-right-outline",
	"person-arrow-right-outline": "account-arrow-right-outline",
	"account-upload": "account-arrow-up",
	"account-upload-outline": "account-arrow-up-outline",
	"account-online": "account-badge",
	"user-online": "account-badge",
	"user-online-outline": "account-badge-outline",
	"account-online-outline": "account-badge-outline",
	"selfie": "account-box",
	"user-box": "account-box",
	"person-box": "account-box",
	"contact": "account-box",
	"switch-account": "account-box-multiple",
	"user-box-multiple": "account-box-multiple",
	"account-boxes": "account-box-multiple",
	"user-boxes": "account-box-multiple",
	"person-box-multiple": "account-box-multiple",
	"person-boxes": "account-box-multiple",
	"selfie-outline": "account-box-outline",
	"user-box-outline": "account-box-outline",
	"portrait": "account-box-outline",
	"contact-outline": "account-box-outline",
	"person-box-outline": "account-box-outline",
	"user-cancel": "account-cancel",
	"user-block": "account-cancel",
	"person-cancel": "account-cancel",
	"person-block": "account-cancel",
	"user-cancel-outline": "account-cancel-outline",
	"user-block-outline": "account-cancel-outline",
	"person-cancel-outline": "account-cancel-outline",
	"person-block-outline": "account-cancel-outline",
	"user-check": "account-check",
	"account-tick": "account-check",
	"user-tick": "account-check",
	"person-check": "account-check",
	"person-tick": "account-check",
	"how-to-reg": "account-check",
	"account-success": "account-check",
	"account-tick-outline": "account-check-outline",
	"user-check-outline": "account-check-outline",
	"user-tick-outline": "account-check-outline",
	"person-check-outline": "account-check-outline",
	"person-tick-outline": "account-check-outline",
	"how-to-reg-outline": "account-check-outline",
	"account-success-outline": "account-check-outline",
	"user-child": "account-child",
	"person-child": "account-child",
	"guardian": "account-child",
	"user-child-circle": "account-child-circle",
	"person-child-circle": "account-child-circle",
	"guardian-circle": "account-child-circle",
	"user-circle": "account-circle",
	"person-circle": "account-circle",
	"user-circle-outline": "account-circle-outline",
	"person-circle-outline": "account-circle-outline",
	"user-clock": "account-clock",
	"account-pending": "account-clock",
	"person-clock": "account-clock",
	"user-clock-outline": "account-clock-outline",
	"account-pending-outline": "account-clock-outline",
	"person-clock-outline": "account-clock-outline",
	"account-settings": "account-cog",
	"account-settings-outline": "account-cog-outline",
	"user-convert": "account-convert",
	"person-convert": "account-convert",
	"rancher": "account-cowboy-hat",
	"rancher-outline": "account-cowboy-hat-outline",
	"account-payment": "account-credit-card",
	"cardholder": "account-credit-card",
	"account-payment-outline": "account-credit-card-outline",
	"cardholder-outline": "account-credit-card-outline",
	"user-details": "account-details",
	"person-details": "account-details",
	"person-details-outline": "account-details-outline",
	"user-details-outline": "account-details-outline",
	"user-edit": "account-edit",
	"person-edit": "account-edit",
	"account-view": "account-eye",
	"account-view-outline": "account-eye-outline",
	"account-funnel": "account-filter",
	"leads": "account-filter",
	"account-funnel-outline": "account-filter-outline",
	"leads-outline": "account-filter-outline",
	"user-group": "account-group",
	"users-group": "account-group",
	"person-group": "account-group",
	"people-group": "account-group",
	"accounts-group": "account-group",
	"user-group-outline": "account-group-outline",
	"users-group-outline": "account-group-outline",
	"person-group-outline": "account-group-outline",
	"people-group-outline": "account-group-outline",
	"accounts-group-outline": "account-group-outline",
	"worker": "account-hard-hat",
	"construction": "account-hard-hat",
	"worker-outline": "account-hard-hat-outline",
	"construction-outline": "account-hard-hat-outline",
	"user-heart": "account-heart",
	"person-heart": "account-heart",
	"user-heart-outline": "account-heart-outline",
	"person-heart-outline": "account-heart-outline",
	"account-disability": "account-injury",
	"patient": "account-injury",
	"person-injury": "account-injury",
	"account-disability-outline": "account-injury-outline",
	"patient-outline": "account-injury-outline",
	"person-injury-outline": "account-injury-outline",
	"user-key": "account-key",
	"person-key": "account-key",
	"user-key-outline": "account-key-outline",
	"person-key-outline": "account-key-outline",
	"account-security": "account-lock",
	"account-secure": "account-lock",
	"user-lock": "account-lock",
	"person-lock": "account-lock",
	"account-unlocked": "account-lock-open",
	"user-unlocked": "account-lock-open",
	"user-lock-open": "account-lock-open",
	"user-lock-open-outline": "account-lock-open-outline",
	"user-unlocked-outline": "account-lock-open-outline",
	"account-unlocked-outline": "account-lock-open-outline",
	"account-security-outline": "account-lock-outline",
	"account-secure-outline": "account-lock-outline",
	"person-lock-outline": "account-lock-outline",
	"user-lock-outline": "account-lock-outline",
	"user-minus": "account-minus",
	"person-minus": "account-minus",
	"user-minus-outline": "account-minus-outline",
	"person-minus-outline": "account-minus-outline",
	"people": "account-multiple",
	"user-multiple": "account-multiple",
	"group": "account-multiple",
	"accounts": "account-multiple",
	"users": "account-multiple",
	"person-multiple": "account-multiple",
	"user-multiple-check": "account-multiple-check",
	"account-multiple-tick": "account-multiple-check",
	"accounts-check": "account-multiple-check",
	"accounts-tick": "account-multiple-check",
	"users-check": "account-multiple-check",
	"users-tick": "account-multiple-check",
	"user-multiple-tick": "account-multiple-check",
	"person-multiple-check": "account-multiple-check",
	"person-multiple-tick": "account-multiple-check",
	"people-check": "account-multiple-check",
	"people-tick": "account-multiple-check",
	"account-multiple-success": "account-multiple-check",
	"user-multiple-check-outline": "account-multiple-check-outline",
	"account-multiple-tick-outline": "account-multiple-check-outline",
	"accounts-check-outline": "account-multiple-check-outline",
	"accounts-tick-outline": "account-multiple-check-outline",
	"users-check-outline": "account-multiple-check-outline",
	"users-tick-outline": "account-multiple-check-outline",
	"user-multiple-tick-outline": "account-multiple-check-outline",
	"person-multiple-check-outline": "account-multiple-check-outline",
	"person-multiple-tick-outline": "account-multiple-check-outline",
	"people-check-outline": "account-multiple-check-outline",
	"people-tick-outline": "account-multiple-check-outline",
	"account-multiple-success-outline": "account-multiple-check-outline",
	"user-multiple-minus": "account-multiple-minus",
	"accounts-minus": "account-multiple-minus",
	"users-minus": "account-multiple-minus",
	"people-minus": "account-multiple-minus",
	"person-multiple-minus": "account-multiple-minus",
	"accounts-minus-outline": "account-multiple-minus-outline",
	"people-minus-outline": "account-multiple-minus-outline",
	"user-multiple-minus-outline": "account-multiple-minus-outline",
	"users-minus-outline": "account-multiple-minus-outline",
	"person-multiple-minus-outline": "account-multiple-minus-outline",
	"user-multiple-outline": "account-multiple-outline",
	"people-outline": "account-multiple-outline",
	"accounts-outline": "account-multiple-outline",
	"users-outline": "account-multiple-outline",
	"user-multiple-plus": "account-multiple-plus",
	"group-add": "account-multiple-plus",
	"accounts-plus": "account-multiple-plus",
	"users-plus": "account-multiple-plus",
	"person-multiple-plus": "account-multiple-plus",
	"people-plus": "account-multiple-plus",
	"person-multiple-add": "account-multiple-plus",
	"people-add": "account-multiple-plus",
	"account-multiple-add": "account-multiple-plus",
	"accounts-add": "account-multiple-plus",
	"user-multiple-add": "account-multiple-plus",
	"users-add": "account-multiple-plus",
	"invite": "account-plus-outline",
	"group-add-outline": "account-multiple-plus-outline",
	"user-multiple-plus-outline": "account-multiple-plus-outline",
	"accounts-plus-outline": "account-multiple-plus-outline",
	"users-plus-outline": "account-multiple-plus-outline",
	"person-multiple-plus-outline": "account-multiple-plus-outline",
	"people-plus-outline": "account-multiple-plus-outline",
	"person-multiple-add-outline": "account-multiple-plus-outline",
	"people-add-outline": "account-multiple-plus-outline",
	"account-multiple-add-outline": "account-multiple-plus-outline",
	"accounts-add-outline": "account-multiple-plus-outline",
	"user-multiple-add-outline": "account-multiple-plus-outline",
	"users-add-outline": "account-multiple-plus-outline",
	"user-multiple-remove": "account-multiple-remove",
	"person-multiple-remove": "account-multiple-remove",
	"user-multiple-remove-outline": "account-multiple-remove-outline",
	"person-multiple-remove-outline": "account-multiple-remove-outline",
	"artist": "account-music",
	"artist-outline": "account-music-outline",
	"user-network": "account-network",
	"person-network": "account-network",
	"user-network-outline": "account-network-outline",
	"person-network-outline": "account-network-outline",
	"user-off": "account-off",
	"person-off": "account-off",
	"user-off-outline": "account-off-outline",
	"person-off-outline": "account-off-outline",
	"user-outline": "account-outline",
	"perm-identity": "account-outline",
	"person-outline": "account-outline",
	"register": "account-plus",
	"user-plus": "account-plus",
	"person-add": "account-plus",
	"account-add": "account-plus",
	"person-plus": "account-plus",
	"user-add": "account-plus",
	"person-add-outline": "account-plus-outline",
	"register-outline": "account-plus-outline",
	"user-plus-outline": "account-plus-outline",
	"account-add-outline": "account-plus-outline",
	"person-plus-outline": "account-plus-outline",
	"user-add-outline": "account-plus-outline",
	"user-help": "account-question",
	"account-question-mark": "account-question",
	"account-help": "account-question",
	"user-question": "account-question",
	"person-question": "account-question",
	"person-help": "account-question",
	"account-question-mark-outline": "account-question-outline",
	"user-help-outline": "account-question-outline",
	"account-help-outline": "account-question-outline",
	"user-question-outline": "account-question-outline",
	"person-question-outline": "account-question-outline",
	"person-help-outline": "account-question-outline",
	"user-remove": "account-remove",
	"person-remove": "account-remove",
	"user-remove-outline": "account-remove-outline",
	"person-remove-outline": "account-remove-outline",
	"account-student": "account-school",
	"account-graduation": "account-school",
	"account-student-outline": "account-school-outline",
	"account-graduation-outline": "account-school-outline",
	"user-search": "account-search",
	"person-search": "account-search",
	"user-search-outline": "account-search-outline",
	"person-search-outline": "account-search-outline",
	"user-settings": "account-settings",
	"person-settings": "account-settings",
	"user-star": "account-star",
	"person-star": "account-star",
	"account-favorite": "account-star",
	"user-star-outline": "account-star-outline",
	"person-star-outline": "account-star-outline",
	"user-supervisor": "account-supervisor",
	"person-supervisor": "account-supervisor",
	"user-supervisor-circle": "account-supervisor-circle",
	"person-supervisor-circle": "account-supervisor-circle",
	"user-switch": "account-switch",
	"accounts-switch": "account-switch",
	"users-switch": "account-switch",
	"person-switch": "account-switch",
	"people-switch": "account-switch",
	"account-cache": "account-sync",
	"account-cache-outline": "account-sync-outline",
	"person-tie": "account-tie",
	"user-tie": "account-tie",
	"account-pilot": "account-tie-hat",
	"account-pilot-outline": "account-tie-hat-outline",
	"business-woman": "account-tie-woman",
	"record-voice-over": "account-voice",
	"speak": "chat",
	"talk": "account-voice",
	"speaking": "account-voice",
	"talking": "account-voice",
	"account-service": "account-wrench",
	"account-service-outline": "account-wrench-outline",
	"ads": "advertisements",
	"ads-off": "advertisements-off",
	"ac-unit": "air-conditioner",
	"water-filter": "air-filter",
	"filter": "air-filter",
	"air-dehumidifier": "air-humidifier-off",
	"hot-air-balloon": "airballoon",
	"hot-air-balloon-outline": "airballoon-outline",
	"aeroplane": "airplane",
	"airplanemode-active": "airplane",
	"flight": "airplane",
	"local-airport": "airplane",
	"flight-mode": "airplane",
	"plane": "airplane",
	"airplace-success": "airplane-check",
	"airplane-tick": "airplane-check",
	"airplane-schedule": "airplane-clock",
	"airplane-time": "airplane-clock",
	"airplane-date": "airplane-clock",
	"airplane-settings": "airplane-cog",
	"aeroplane-landing": "airplane-landing",
	"flight-land": "airplane-landing",
	"plane-landing": "airplane-landing",
	"airplane-location": "airplane-marker",
	"airplane-gps": "airplane-marker",
	"aeroplane-off": "airplane-off",
	"airplanemode-inactive": "airplane-off",
	"flight-mode-off": "airplane-off",
	"plane-off": "airplane-off",
	"airplane-find": "airplane-search",
	"aeroplane-takeoff": "airplane-takeoff",
	"flight-takeoff": "airplane-takeoff",
	"plane-takeoff": "airplane-takeoff",
	"airplane-take-off": "airplane-takeoff",
	"access-alarms": "alarm",
	"alarm-clock": "alarm",
	"alarm-on": "alarm-check",
	"alarm-tick": "alarm-check",
	"alarm-clock-check": "alarm-check",
	"alarm-clock-tick": "alarm-check",
	"alarm-success": "alarm-check",
	"alarms": "alarm-multiple",
	"alarm-clock-multiple": "alarm-multiple",
	"alarm-clocks": "alarm-multiple",
	"alarm-clock-off": "alarm-off",
	"add-alarm": "alarm-plus",
	"alarm-clock-plus": "alarm-plus",
	"alarm-clock-add": "alarm-plus",
	"alarm-add": "alarm-plus",
	"alarm-clock-snooze": "alarm-snooze",
	"vinyl": "album",
	"record": "radiobox-marked",
	"warning": "alert",
	"report-problem": "alert",
	"warning-box": "alert-box",
	"warning-box-outline": "alert-box-outline",
	"warning-circle": "alert-circle",
	"error": "alert-circle",
	"alert-circle-success": "alert-circle-check",
	"alert-circle-success-outline": "alert-circle-check-outline",
	"warning-circle-outline": "alert-circle-outline",
	"error-outline": "alert-circle-outline",
	"git-issue": "alert-circle-outline",
	"new-releases": "alert-decagram",
	"warning-decagram": "alert-decagram",
	"warning-decagram-outline": "alert-decagram-outline",
	"warning-octagon": "alert-octagon",
	"report": "poll",
	"stop-alert": "alert-octagon",
	"warning-octagon-outline": "alert-octagon-outline",
	"stop-alert-outline": "alert-octagon-outline",
	"warning-octagram": "alert-octagram",
	"warning-octagram-outline": "alert-octagram-outline",
	"warning-outline": "alert-outline",
	"align-horizontal-centre": "align-horizontal-center",
	"align-vertical-centre": "align-vertical-center",
	"infinity": "all-inclusive",
	"forever": "all-inclusive",
	"infinity-box": "all-inclusive-box",
	"forever-box": "all-inclusive-box",
	"forever-box-outline": "all-inclusive-box-outline",
	"infinity-box-outline": "all-inclusive-box-outline",
	"hand": "allergy",
	"rash": "allergy",
	"germ": "allergy",
	"alphabet-a": "alpha-a",
	"letter-a": "alpha-a",
	"alphabet-a-box": "alpha-a-box",
	"letter-a-box": "alpha-a-box",
	"alphabet-a-box-outline": "alpha-a-box-outline",
	"letter-a-box-outline": "alpha-a-box-outline",
	"alphabet-a-circle": "alpha-a-circle",
	"letter-a-circle": "alpha-a-circle",
	"alphabet-a-circle-outline": "alpha-a-circle-outline",
	"letter-a-circle-outline": "alpha-a-circle-outline",
	"alphabet-b": "alpha-b",
	"letter-b": "alpha-b",
	"alphabet-b-box": "alpha-b-box",
	"letter-b-box": "alpha-b-box",
	"alphabet-b-box-outline": "alpha-b-box-outline",
	"letter-b-box-outline": "alpha-b-box-outline",
	"alphabet-b-circle": "alpha-b-circle",
	"letter-b-circle": "alpha-b-circle",
	"alphabet-b-circle-outline": "alpha-b-circle-outline",
	"letter-b-circle-outline": "alpha-b-circle-outline",
	"alphabet-c": "alpha-c",
	"letter-c": "alpha-c",
	"alphabet-c-box": "alpha-c-box",
	"letter-c-box": "alpha-c-box",
	"alphabet-c-box-outline": "alpha-c-box-outline",
	"letter-c-box-outline": "alpha-c-box-outline",
	"alphabet-c-circle": "alpha-c-circle",
	"letter-c-circle": "alpha-c-circle",
	"alphabet-c-circle-outline": "alpha-c-circle-outline",
	"letter-c-circle-outline": "alpha-c-circle-outline",
	"alphabet-d": "alpha-d",
	"letter-d": "alpha-d",
	"drive": "alpha-d",
	"alphabet-d-box": "alpha-d-box",
	"letter-d-box": "alpha-d-box",
	"alphabet-d-box-outline": "alpha-d-box-outline",
	"letter-d-box-outline": "alpha-d-box-outline",
	"alphabet-d-circle": "alpha-d-circle",
	"letter-d-circle": "alpha-d-circle",
	"alphabet-d-circle-outline": "alpha-d-circle-outline",
	"letter-d-circle-outline": "alpha-d-circle-outline",
	"alphabet-e": "alpha-e",
	"letter-e": "alpha-e",
	"alphabet-e-box": "alpha-e-box",
	"letter-e-box": "alpha-e-box",
	"alphabet-e-box-outline": "alpha-e-box-outline",
	"letter-e-box-outline": "alpha-e-box-outline",
	"alphabet-e-circle": "alpha-e-circle",
	"letter-e-circle": "alpha-e-circle",
	"alphabet-e-circle-outline": "alpha-e-circle-outline",
	"letter-e-circle-outline": "alpha-e-circle-outline",
	"alphabet-f": "alpha-f",
	"letter-f": "alpha-f",
	"alphabet-f-box": "alpha-f-box",
	"letter-f-box": "alpha-f-box",
	"alphabet-f-box-outline": "alpha-f-box-outline",
	"letter-f-box-outline": "alpha-f-box-outline",
	"alphabet-f-circle": "alpha-f-circle",
	"letter-f-circle": "alpha-f-circle",
	"alphabet-f-circle-outline": "alpha-f-circle-outline",
	"letter-f-circle-outline": "alpha-f-circle-outline",
	"alphabet-g": "alpha-g",
	"letter-g": "alpha-g",
	"alphabet-g-box": "alpha-g-box",
	"letter-g-box": "alpha-g-box",
	"alphabet-g-box-outline": "alpha-g-box-outline",
	"letter-g-box-outline": "alpha-g-box-outline",
	"alphabet-g-circle": "alpha-g-circle",
	"letter-g-circle": "alpha-g-circle",
	"alphabet-g-circle-outline": "alpha-g-circle-outline",
	"letter-g-circle-outline": "alpha-g-circle-outline",
	"alphabet-h": "alpha-h",
	"letter-h": "alpha-h",
	"alphabet-h-box": "alpha-h-box",
	"letter-h-box": "alpha-h-box",
	"alphabet-h-box-outline": "alpha-h-box-outline",
	"letter-h-box-outline": "alpha-h-box-outline",
	"alphabet-h-circle": "alpha-h-circle",
	"letter-h-circle": "alpha-h-circle",
	"alphabet-h-circle-outline": "alpha-h-circle-outline",
	"letter-h-circle-outline": "alpha-h-circle-outline",
	"helipad": "alpha-h-circle-outline",
	"alphabet-i": "alpha-i",
	"letter-i": "alpha-i",
	"roman-numeral-1": "alpha-i",
	"alphabet-i-box": "alpha-i-box",
	"letter-i-box": "alpha-i-box",
	"alphabet-i-box-outline": "alpha-i-box-outline",
	"letter-i-box-outline": "alpha-i-box-outline",
	"alphabet-i-circle": "alpha-i-circle",
	"letter-i-circle": "alpha-i-circle",
	"alphabet-i-circle-outline": "alpha-i-circle-outline",
	"letter-i-circle-outline": "alpha-i-circle-outline",
	"alphabet-j": "alpha-j",
	"letter-j": "alpha-j",
	"alphabet-j-box": "alpha-j-box",
	"letter-j-box": "alpha-j-box",
	"alphabet-j-box-outline": "alpha-j-box-outline",
	"letter-j-box-outline": "alpha-j-box-outline",
	"alphabet-j-circle": "alpha-j-circle",
	"letter-j-circle": "alpha-j-circle",
	"alphabet-j-circle-outline": "alpha-j-circle-outline",
	"letter-j-circle-outline": "alpha-j-circle-outline",
	"alphabet-k": "alpha-k",
	"letter-k": "alpha-k",
	"alphabet-k-box": "alpha-k-box",
	"letter-k-box": "alpha-k-box",
	"alphabet-k-box-outline": "alpha-k-box-outline",
	"letter-k-box-outline": "alpha-k-box-outline",
	"alphabet-k-circle": "alpha-k-circle",
	"letter-k-circle": "alpha-k-circle",
	"alphabet-k-circle-outline": "alpha-k-circle-outline",
	"letter-k-circle-outline": "alpha-k-circle-outline",
	"alphabet-l": "alpha-l",
	"letter-l": "alpha-l",
	"alphabet-l-box": "alpha-l-box",
	"letter-l-box": "alpha-l-box",
	"alphabet-l-box-outline": "alpha-l-box-outline",
	"letter-l-box-outline": "alpha-l-box-outline",
	"alphabet-l-circle": "alpha-l-circle",
	"letter-l-circle": "alpha-l-circle",
	"alphabet-l-circle-outline": "alpha-l-circle-outline",
	"letter-l-circle-outline": "alpha-l-circle-outline",
	"alphabet-m": "alpha-m",
	"letter-m": "alpha-m",
	"alphabet-m-box": "alpha-m-box",
	"letter-m-box": "alpha-m-box",
	"alphabet-m-box-outline": "alpha-m-box-outline",
	"letter-m-box-outline": "alpha-m-box-outline",
	"alphabet-m-circle": "alpha-m-circle",
	"letter-m-circle": "alpha-m-circle",
	"alphabet-m-circle-outline": "alpha-m-circle-outline",
	"letter-m-circle-outline": "alpha-m-circle-outline",
	"alphabet-n": "alpha-n",
	"letter-n": "alpha-n",
	"neutral": "alpha-n",
	"alphabet-n-box": "alpha-n-box",
	"letter-n-box": "alpha-n-box",
	"alphabet-n-box-outline": "alpha-n-box-outline",
	"letter-n-box-outline": "alpha-n-box-outline",
	"alphabet-n-circle": "alpha-n-circle",
	"letter-n-circle": "alpha-n-circle",
	"alphabet-n-circle-outline": "alpha-n-circle-outline",
	"letter-n-circle-outline": "alpha-n-circle-outline",
	"alphabet-o": "alpha-o",
	"letter-o": "alpha-o",
	"alphabet-o-box": "alpha-o-box",
	"letter-o-box": "alpha-o-box",
	"alphabet-o-box-outline": "alpha-o-box-outline",
	"letter-o-box-outline": "alpha-o-box-outline",
	"alphabet-o-circle": "alpha-o-circle",
	"letter-o-circle": "alpha-o-circle",
	"alphabet-o-circle-outline": "alpha-o-circle-outline",
	"letter-o-circle-outline": "alpha-o-circle-outline",
	"alphabet-p": "alpha-p",
	"letter-p": "alpha-p",
	"park": "alpha-p",
	"alphabet-p-box": "alpha-p-box",
	"letter-p-box": "alpha-p-box",
	"alphabet-p-box-outline": "alpha-p-box-outline",
	"letter-p-box-outline": "alpha-p-box-outline",
	"alphabet-p-circle": "alpha-p-circle",
	"letter-p-circle": "alpha-p-circle",
	"alphabet-p-circle-outline": "alpha-p-circle-outline",
	"letter-p-circle-outline": "alpha-p-circle-outline",
	"alphabet-q": "alpha-q",
	"letter-q": "alpha-q",
	"alphabet-q-box": "alpha-q-box",
	"letter-q-box": "alpha-q-box",
	"alphabet-q-box-outline": "alpha-q-box-outline",
	"letter-q-box-outline": "alpha-q-box-outline",
	"alphabet-q-circle": "alpha-q-circle",
	"letter-q-circle": "alpha-q-circle",
	"alphabet-q-circle-outline": "alpha-q-circle-outline",
	"letter-q-circle-outline": "alpha-q-circle-outline",
	"alphabet-r": "alpha-r",
	"letter-r": "alpha-r",
	"reverse": "alpha-r",
	"alphabet-r-box": "alpha-r-box",
	"letter-r-box": "alpha-r-box",
	"alphabet-r-box-outline": "alpha-r-box-outline",
	"letter-r-box-outline": "alpha-r-box-outline",
	"alphabet-r-circle": "alpha-r-circle",
	"letter-r-circle": "alpha-r-circle",
	"alphabet-r-circle-outline": "alpha-r-circle-outline",
	"letter-r-circle-outline": "alpha-r-circle-outline",
	"alphabet-s": "alpha-s",
	"letter-s": "alpha-s",
	"alphabet-s-box": "alpha-s-box",
	"letter-s-box": "alpha-s-box",
	"alphabet-s-box-outline": "alpha-s-box-outline",
	"letter-s-box-outline": "alpha-s-box-outline",
	"alphabet-s-circle": "alpha-s-circle",
	"letter-s-circle": "alpha-s-circle",
	"alphabet-s-circle-outline": "alpha-s-circle-outline",
	"letter-s-circle-outline": "alpha-s-circle-outline",
	"alphabet-t": "alpha-t",
	"letter-t": "alpha-t",
	"alphabet-t-box": "alpha-t-box",
	"letter-t-box": "alpha-t-box",
	"alphabet-t-box-outline": "alpha-t-box-outline",
	"letter-t-box-outline": "alpha-t-box-outline",
	"alphabet-t-circle": "alpha-t-circle",
	"letter-t-circle": "alpha-t-circle",
	"alphabet-t-circle-outline": "alpha-t-circle-outline",
	"letter-t-circle-outline": "alpha-t-circle-outline",
	"alphabet-u": "alpha-u",
	"letter-u": "alpha-u",
	"alphabet-u-box": "alpha-u-box",
	"letter-u-box": "alpha-u-box",
	"alphabet-u-box-outline": "alpha-u-box-outline",
	"letter-u-box-outline": "alpha-u-box-outline",
	"alphabet-u-circle": "alpha-u-circle",
	"letter-u-circle": "alpha-u-circle",
	"alphabet-u-circle-outline": "alpha-u-circle-outline",
	"letter-u-circle-outline": "alpha-u-circle-outline",
	"alphabet-v": "alpha-v",
	"letter-v": "alpha-v",
	"roman-numeral-5": "alpha-v",
	"alphabet-v-box": "alpha-v-box",
	"letter-v-box": "alpha-v-box",
	"alphabet-v-box-outline": "alpha-v-box-outline",
	"letter-v-box-outline": "alpha-v-box-outline",
	"alphabet-v-circle": "alpha-v-circle",
	"letter-v-circle": "alpha-v-circle",
	"alphabet-v-circle-outline": "alpha-v-circle-outline",
	"letter-v-circle-outline": "alpha-v-circle-outline",
	"alphabet-w": "alpha-w",
	"letter-w": "alpha-w",
	"alphabet-w-box": "alpha-w-box",
	"letter-w-box": "alpha-w-box",
	"alphabet-w-box-outline": "alpha-w-box-outline",
	"letter-w-box-outline": "alpha-w-box-outline",
	"alphabet-w-circle": "alpha-w-circle",
	"letter-w-circle": "alpha-w-circle",
	"alphabet-w-circle-outline": "alpha-w-circle-outline",
	"letter-w-circle-outline": "alpha-w-circle-outline",
	"alphabet-x": "alpha-x",
	"letter-x": "alpha-x",
	"roman-numeral-10": "alpha-x",
	"alphabet-x-box": "alpha-x-box",
	"letter-x-box": "alpha-x-box",
	"alphabet-x-box-outline": "alpha-x-box-outline",
	"letter-x-box-outline": "alpha-x-box-outline",
	"alphabet-x-circle": "alpha-x-circle",
	"letter-x-circle": "alpha-x-circle",
	"alphabet-x-circle-outline": "alpha-x-circle-outline",
	"letter-x-circle-outline": "alpha-x-circle-outline",
	"alphabet-y": "alpha-y",
	"letter-y": "alpha-y",
	"alphabet-y-box": "alpha-y-box",
	"letter-y-box": "alpha-y-box",
	"alphabet-y-box-outline": "alpha-y-box-outline",
	"letter-y-box-outline": "alpha-y-box-outline",
	"alphabet-y-circle": "alpha-y-circle",
	"letter-y-circle": "alpha-y-circle",
	"alphabet-y-circle-outline": "alpha-y-circle-outline",
	"letter-y-circle-outline": "alpha-y-circle-outline",
	"alphabet-z": "alpha-z",
	"letter-z": "alpha-z",
	"alphabet-z-box": "alpha-z-box",
	"letter-z-box": "alpha-z-box",
	"alphabet-z-box-outline": "alpha-z-box-outline",
	"letter-z-box-outline": "alpha-z-box-outline",
	"alphabet-z-circle": "alpha-z-circle",
	"letter-z-circle": "alpha-z-circle",
	"alphabet-z-circle-outline": "alpha-z-circle-outline",
	"letter-z-circle-outline": "alpha-z-circle-outline",
	"writing-system-aurebesh": "alphabet-aurebesh",
	"writing-system-cyrillic": "alphabet-cyrillic",
	"writing-system-greek": "alphabet-greek",
	"writing-system-latin": "alphabet-latin",
	"writing-system-piqad": "alphabet-piqad",
	"writing-system-tengwar": "alphabet-tengwar",
	"letters": "alphabetical-variant",
	"a-b-c": "alphabetical-variant",
	"abc": "alphabetical-variant",
	"letters-off": "alphabetical-variant-off",
	"abc-off": "alphabetical-variant-off",
	"a-b-c-off": "alphabetical-variant-off",
	"bullets": "ammunition",
	"and": "ampersand",
	"math-compass-variant": "android-studio",
	"auto-awesome-motion": "animation",
	"apple-mobileme": "apple-icloud",
	"iframe": "application",
	"iframe-array": "application-array",
	"iframe-array-outline": "application-array-outline",
	"iframe-braces": "application-braces",
	"iframe-braces-outline": "application-braces-outline",
	"iframe-brackets": "application-brackets",
	"iframe-brackets-outline": "application-brackets-outline",
	"iframe-cog": "application-cog",
	"application-settings": "application-cog-outline",
	"iframe-cog-outline": "application-cog-outline",
	"iframe-edit": "application-edit",
	"iframe-edit-outline": "application-edit-outline",
	"iframe-export-outline": "application-export",
	"iframe-import-outline": "application-import",
	"web-asset": "application-outline",
	"iframe-outline": "application-outline",
	"iframe-parentheses": "application-parentheses",
	"iframe-parentheses-outline": "application-parentheses-outline",
	"iframe-settings": "application-settings",
	"iframe-settings-outline": "application-settings-outline",
	"iframe-variable": "application-variable",
	"iframe-variable-outline": "application-variable-outline",
	"box": "package",
	"box-alert": "archive-alert",
	"box-alert-outline": "archive-alert-outline",
	"box-arrow-down": "archive-arrow-down-outline",
	"this-side-down": "package-down",
	"this-side-down-outline": "archive-arrow-down-outline",
	"box-arrow-up": "archive-arrow-up",
	"this-side-up": "package-up",
	"box-arrow-up-outline": "archive-arrow-up-outline",
	"this-side-up-outline": "archive-arrow-up-outline",
	"box-cancel": "archive-cancel",
	"box-cancel-outline": "archive-cancel-outline",
	"box-check": "archive-check",
	"archive-success": "archive-check",
	"box-success": "archive-check",
	"box-check-outline": "archive-check-outline",
	"archive-success-outline": "archive-check-outline",
	"box-success-outline": "archive-check-outline",
	"box-clock": "archive-clock",
	"box-time": "archive-clock",
	"archive-time": "archive-clock",
	"box-clock-outline": "archive-clock-outline",
	"box-time-outline": "archive-clock-outline",
	"archive-time-outline": "archive-clock-outline",
	"box-cog": "archive-cog",
	"box-cog-outline": "archive-cog-outline",
	"box-edit": "archive-edit",
	"box-edit-outline": "archive-edit-outline",
	"archive-view": "archive-eye",
	"box-eye": "archive-eye",
	"box-view": "archive-eye",
	"archive-view-outline": "archive-eye-outline",
	"box-eye-outline": "archive-eye-outline",
	"box-view-outline": "archive-eye-outline",
	"box-lock": "archive-lock",
	"box-lock-open": "archive-lock-open",
	"box-lock-open-outline": "archive-lock-open-outline",
	"box-lock-outline": "archive-lock-outline",
	"archive-location": "archive-marker",
	"box-marker": "archive-marker",
	"box-location": "archive-marker",
	"archive-location-outline": "archive-marker-outline",
	"box-marker-outline": "archive-marker-outline",
	"box-location-outline": "archive-marker-outline",
	"box-minus": "archive-minus",
	"box-minus-outline": "archive-minus-outline",
	"box-music": "archive-music",
	"box-music-outline": "archive-music-outline",
	"box-off": "archive-off",
	"box-off-outline": "archive-off-outline",
	"box-outline": "feature-search-outline",
	"archive-add": "archive-plus",
	"box-plus": "archive-plus",
	"box-add": "archive-plus",
	"archive-add-outline": "archive-plus-outline",
	"box-plus-outline": "archive-plus-outline",
	"box-add-outline": "archive-plus-outline",
	"box-refresh": "archive-refresh",
	"box-refresh-outline": "archive-refresh-outline",
	"box-remove": "archive-remove",
	"box-remove-outline": "archive-remove-outline",
	"box-search": "feature-search",
	"box-search-outline": "feature-search-outline",
	"box-settings": "archive-settings",
	"box-settings-outline": "archive-settings-outline",
	"archive-favorite": "archive-star",
	"box-star": "archive-star",
	"box-favorite": "archive-star",
	"archive-favorite-outline": "archive-star-outline",
	"box-star-outline": "archive-star-outline",
	"box-favorite-outline": "archive-star-outline",
	"box-sync": "archive-sync",
	"box-sync-outline": "archive-sync-outline",
	"arrow-down-left": "arrow-bottom-left",
	"arrow-down-left-bold-outline": "arrow-bottom-left-bold-outline",
	"arrow-down-left-thick": "arrow-bottom-left-thick",
	"arrow-bottom-left-bold": "arrow-bottom-left-thick",
	"arrow-down-left-bold": "arrow-bottom-left-thick",
	"arrow-down-right": "arrow-bottom-right",
	"arrow-down-right-bold-outline": "arrow-bottom-right-bold-outline",
	"arrow-down-right-thick": "arrow-bottom-right-thick",
	"arrow-bottom-right-bold": "arrow-bottom-right-thick",
	"arrow-down-right-bold": "arrow-bottom-right-thick",
	"arrow-compress": "arrow-collapse",
	"arrow-compress-all": "arrow-collapse-all",
	"arrow-compress-down": "arrow-collapse-down",
	"arrow-compress-left": "arrow-collapse-left",
	"arrow-compress-right": "arrow-collapse-right",
	"arrow-compress-up": "arrow-collapse-up",
	"compress": "arrow-collapse-vertical",
	"proxy": "arrow-decision",
	"proxy-auto": "arrow-decision-auto",
	"proxy-auto-outline": "arrow-decision-auto-outline",
	"proxy-outline": "arrow-decision-outline",
	"arrow-downward": "arrow-down",
	"arrow-bottom": "arrow-down",
	"arrow-bottom-bold": "arrow-down-thick",
	"arrow-bottom-bold-box": "arrow-down-bold-box",
	"arrow-bottom-bold-box-outline": "arrow-down-bold-box-outline",
	"arrow-bottom-bold-circle": "arrow-down-bold-circle",
	"arrow-bottom-bold-circle-outline": "arrow-down-bold-circle-outline",
	"arrow-bottom-bold-hexagon-outline": "arrow-down-bold-hexagon-outline",
	"arrow-bottom-bold-outline": "arrow-down-bold-outline",
	"arrow-bottom-box": "arrow-down-box",
	"arrow-bottom-circle": "arrow-down-circle",
	"arrow-bottom-circle-outline": "arrow-down-circle-outline",
	"arrow-drop-down-circle": "arrow-down-drop-circle",
	"arrow-bottom-drop-circle": "arrow-down-drop-circle",
	"arrow-bottom-drop-circle-outline": "arrow-down-drop-circle-outline",
	"arrow-bottom-thick": "arrow-down-thick",
	"arrow-down-bold": "arrow-down-thick",
	"scroll-horizontal-lock": "arrow-horizontal-lock",
	"arrow-back": "arrow-left",
	"arrow-back-circle": "arrow-left-circle",
	"arrow-left-bold": "arrow-left-thick",
	"turn-left": "arrow-left-top",
	"turn-left-bold": "arrow-left-top-bold",
	"arrow-forward": "arrow-right",
	"arrow-forward-circle": "arrow-right-circle",
	"arrow-right-bold": "arrow-right-thick",
	"turn-right": "arrow-right-top",
	"turn-right-bold": "arrow-right-top-bold",
	"resize-vertical": "arrow-split-horizontal",
	"resize": "arrow-split-vertical",
	"resize-horizontal": "arrow-split-vertical",
	"arrow-up-left": "arrow-top-left",
	"arrow-up-left-bold-outline": "arrow-top-left-bold-outline",
	"arrow-up-left-thick": "arrow-top-left-thick",
	"arrow-top-left-bold": "arrow-top-left-thick",
	"arrow-up-left-bold": "arrow-top-left-thick",
	"arrow-up-right": "arrow-top-right",
	"arrow-up-right-bold-outline": "arrow-top-right-bold-outline",
	"arrow-up-right-thick": "arrow-top-right-thick",
	"arrow-top-right-bold": "arrow-top-right-thick",
	"arrow-up-right-bold": "arrow-top-right-thick",
	"u-turn-left": "arrow-u-down-left",
	"u-turn-left-bold": "arrow-u-down-left-bold",
	"u-turn-right": "arrow-u-down-right",
	"u-turn-right-bold": "arrow-u-down-right-bold",
	"undo": "arrow-u-left-top-bold",
	"redo": "arrow-u-right-top-bold",
	"arrow-upward": "arrow-up",
	"arrow-top": "arrow-up",
	"arrow-top-bold": "arrow-up-thick",
	"arrow-top-bold-box": "arrow-up-bold-box",
	"arrow-top-bold-box-outline": "arrow-up-bold-box-outline",
	"arrow-top-bold-circle": "arrow-up-bold-circle",
	"arrow-top-bold-circle-outline": "arrow-up-bold-circle-outline",
	"arrow-top-bold-hexagon-outline": "arrow-up-bold-hexagon-outline",
	"arrow-top-bold-outline": "arrow-up-bold-outline",
	"arrow-top-circle": "arrow-up-circle",
	"arrow-top-circle-outline": "arrow-up-circle-outline",
	"arrow-top-drop-circle": "arrow-up-drop-circle",
	"arrow-top-drop-circle-outline": "arrow-up-drop-circle-outline",
	"arrow-top-thick": "arrow-up-thick",
	"arrow-up-bold": "arrow-up-thick",
	"scroll-vertical-lock": "arrow-vertical-lock",
	"canvas": "artboard",
	"frame": "artboard",
	"required": "asterisk",
	"required-circle": "asterisk-circle-outline",
	"alternate-email": "at",
	"orbit": "atom-variant",
	"paperclip-horizontal": "attachment",
	"attachment-tick": "paperclip-check",
	"paperclip-check": "attachment-check",
	"paperclip-tick": "paperclip-check",
	"paperclip-lock": "attachment-lock",
	"paperclip-minus": "attachment-minus",
	"paperclip-subtract": "paperclip-minus",
	"attachment-subtract": "paperclip-minus",
	"paperclip-off": "attachment-off",
	"paperclip-plus": "attachment-plus",
	"paperclip-add": "paperclip-plus",
	"attachment-add": "paperclip-plus",
	"paperclip-remove": "attachment-remove",
	"quad": "atv",
	"trike": "atv",
	"two-wheeler": "atv",
	"all-terrain-vehicle": "atv",
	"av-receiver": "audio-video",
	"av-receiver-off": "audio-video-off",
	"aurora-borealis": "aurora",
	"aurora-australis": "aurora",
	"northern-lights": "aurora",
	"southern-lights": "aurora",
	"polar-lights": "aurora",
	"magic": "auto-fix",
	"wand": "auto-fix",
	"auto-fix-high": "auto-fix",
	"clockwise-arrows": "autorenew",
	"circular-arrows": "sync",
	"circle-arrows": "sync",
	"sync": "cached",
	"clockwise-arrows-off": "autorenew-off",
	"circular-arrows-off": "autorenew-off",
	"circle-arrows-off": "autorenew-off",
	"sync-off": "autorenew-off",
	"marquise": "awning",
	"sun-shade": "awning",
	"marquise-outline": "awning-outline",
	"sun-shade-outline": "awning-outline",
	"accelerometer": "rotate-orbit",
	"gyro": "rotate-orbit",
	"vertical-rotate-clockwise": "axis-z-rotate-clockwise",
	"vertical-rotate-counterclockwise": "axis-z-rotate-counterclockwise",
	"stroller": "baby-carriage",
	"pram": "baby-carriage",
	"carriage": "baby-buggy",
	"child-friendly": "baby-carriage",
	"buggy": "baby-carriage",
	"child-friendly-off": "baby-carriage-off",
	"stroller-off": "baby-carriage-off",
	"pram-off": "baby-carriage-off",
	"buggy-off": "baby-carriage-off",
	"emoji-baby": "baby-face",
	"emoticon-baby": "baby-face",
	"emoji-baby-outline": "baby-face-outline",
	"emoticon-baby-outline": "baby-face-outline",
	"hamburger-menu-back": "backburger",
	"erase": "backspace",
	"clear": "close",
	"erase-outline": "backspace-outline",
	"clear-outline": "close-outline",
	"clear-reverse": "backspace-reverse",
	"erase-reverse": "backspace-reverse",
	"clear-reverse-outline": "backspace-reverse-outline",
	"erase-reverse-outline": "backspace-reverse-outline",
	"settings-backup-restore": "backup-restore",
	"user-badge": "badge-account",
	"person-badge": "badge-account",
	"user-badge-alert": "badge-account-alert",
	"person-badge-alert": "badge-account-alert",
	"account-badge-warning": "badge-account-alert",
	"user-badge-warning": "badge-account-alert",
	"person-badge-warning": "badge-account-alert",
	"user-badge-alert-outline": "badge-account-alert-outline",
	"person-badge-alert-outline": "badge-account-alert-outline",
	"account-badge-warning-outline": "badge-account-alert-outline",
	"user-badge-warning-outline": "badge-account-alert-outline",
	"person-badge-warning-outline": "badge-account-alert-outline",
	"user-badge-outline": "badge-account-outline",
	"person-badge-outline": "badge-account-outline",
	"shuttlecock": "badminton",
	"carry-on-luggage": "bag-carry-on",
	"carry-on-bag-tick": "bag-carry-on-check",
	"carry-on-bag-check": "bag-carry-on-check",
	"carry-on-luggage-off": "bag-carry-on-off",
	"luggage": "bag-checked",
	"backpack": "bag-personal",
	"backpack-off": "bag-personal-off",
	"backpack-off-outline": "bag-personal-off-outline",
	"backpack-outline": "bag-personal-outline",
	"bag-personal-add": "bag-personal-plus",
	"backpack-add": "bag-personal-plus",
	"backpack-plus": "bag-personal-plus",
	"backpack-plus-outline": "bag-personal-plus-outline",
	"backpack-add-outline": "bag-personal-plus-outline",
	"bag-personal-add-outline": "bag-personal-plus-outline",
	"property-tag": "bag-personal-tag",
	"property-tag-outline": "bag-personal-tag-outline",
	"bread": "baguette",
	"bakery": "baguette",
	"french-baguette": "baguette",
	"loaf": "baguette",
	"terrace": "balcony",
	"patio": "balcony",
	"veranda": "balcony",
	"party-balloon": "balloon",
	"vote": "ballot",
	"vote-outline": "ballot-outline",
	"vote-recount": "ballot-recount",
	"vote-recount-outline": "ballot-recount-outline",
	"band-aid": "bandage",
	"plaster": "bandage",
	"account-balance": "bank",
	"museum": "bank",
	"museum-outline": "bank-outline",
	"bank-add": "bank-plus",
	"barcode-scanner": "barcode-scan",
	"grain": "barley",
	"wheat": "barley",
	"gluten": "barley",
	"gluten-free": "barley-off",
	"grain-off": "barley-off",
	"wheat-off": "barley-off",
	"farm": "tractor",
	"oil-barrel": "barrel",
	"energy": "transmission-tower",
	"fossil-fuel": "barrel",
	"oil-barrel-outline": "barrel-outline",
	"fossil-fuel-outline": "barrel-outline",
	"energy-outline": "lightning-bolt-outline",
	"shopping-basket": "basket",
	"skip": "debug-step-over",
	"skip-fill": "basket-fill",
	"shopping-basket-minus": "basket-minus",
	"skip-minus": "basket-minus",
	"shopping-basket-minus-outline": "basket-minus-outline",
	"skip-minus-outline": "basket-minus-outline",
	"shopping-basket-off": "basket-off",
	"skip-off": "basket-off",
	"shopping-basket-off-outline": "basket-off-outline",
	"skip-off-outline": "basket-off-outline",
	"shopping-basket-outline": "basket-outline",
	"skip-outline": "basket-outline",
	"shopping-basket-plus": "basket-plus",
	"skip-plus": "basket-plus",
	"shopping-basket-plus-outline": "basket-plus-outline",
	"skip-plus-outline": "basket-plus-outline",
	"shopping-basket-remove": "basket-remove",
	"skip-remove": "basket-remove",
	"shopping-basket-remove-outline": "basket-remove-outline",
	"skip-remove-outline": "basket-remove-outline",
	"youtube-sports": "basketball",
	"battery-full": "battery",
	"battery-std": "battery",
	"battery-100": "battery",
	"battery-warning": "battery-alert",
	"battery-warning-bluetooth": "battery-alert-bluetooth",
	"battery-bluetooth-100": "battery-bluetooth",
	"battery-bluetooth-full": "battery-bluetooth",
	"battery-charging-full": "battery-charging",
	"battery-charging-wireless-full": "battery-charging-wireless",
	"battery-charging-wireless-100": "battery-charging-wireless",
	"battery-charging-wireless-warning": "battery-charging-wireless-alert",
	"battery-charging-wireless-empty": "battery-charging-wireless-outline",
	"battery-charging-wireless-0": "battery-charging-wireless-outline",
	"battery-full-clock": "battery-clock",
	"battery-100-clock": "battery-clock",
	"batter-0-clock": "battery-clock-outline",
	"battery-empty-clock": "battery-clock-outline",
	"battery-0": "battery-outline",
	"battery-empty": "battery-outline",
	"battery-saver": "battery-sync",
	"battery-add": "battery-plus-variant",
	"battery-recycle": "battery-sync",
	"battery-eco": "battery-sync",
	"battery-saver-outline": "battery-sync-outline",
	"battery-eco-outline": "battery-sync-outline",
	"battery-recycle-outline": "battery-sync-outline",
	"parasol": "beach",
	"hotel": "bed",
	"guest-room": "bed",
	"bed-schedule": "bed-clock",
	"bed-time": "bed-clock",
	"sleep-schedule": "bed-clock",
	"sleep-time": "bed-clock",
	"bedroom": "bed-single",
	"bedroom-outline": "bed-single-outline",
	"hotel-outline": "bed-outline",
	"guest-room-outline": "bed-outline",
	"fly": "bee",
	"insect": "bee",
	"fly-flower": "bee-flower",
	"nature": "bee-flower",
	"honey-outline": "beehive-outline",
	"apiarists": "beekeeper",
	"apiculturists": "beekeeper",
	"honey-farmer": "beekeeper",
	"pint": "beer",
	"pub": "glass-mug-variant",
	"bar": "glass-wine",
	"drink": "glass-wine",
	"cup-full": "beer",
	"drink-outline": "cup-outline",
	"cup-full-outline": "beer-outline",
	"pint-outline": "beer-outline",
	"pub-outline": "beer-outline",
	"bar-outline": "beer-outline",
	"notifications": "bell",
	"bell-warning": "bell-alert",
	"bell-notification": "bell-badge",
	"bell-notification-outline": "bell-badge-outline",
	"bell-settings": "bell-cog",
	"notification-settings": "bell-cog",
	"bell-settings-outline": "bell-cog-outline",
	"notification-settings-outline": "bell-cog-outline",
	"notifications-off": "bell-off",
	"notifications-none": "bell-outline",
	"add-alert": "bell-plus",
	"bell-add": "bell-plus",
	"bell-add-outline": "bell-plus-outline",
	"add-alert-outline": "bell-plus-outline",
	"notifications-active": "bell-ring",
	"notifications-paused": "bell-sleep",
	"human-biathlon": "biathlon",
	"bike": "bicycle",
	"cycling": "bike",
	"bike-basket": "bicycle-basket",
	"bike-cargo": "bicycle-cargo",
	"bike-electric": "bicycle-electric",
	"bicycle-high-wheel": "bicycle-penny-farthing",
	"bicycle-antique": "bicycle-penny-farthing",
	"bicycle": "bike",
	"directions-bike": "bike",
	"velocity": "run-fast",
	"bike-pedal-flat": "bike-pedal",
	"pool": "billiards",
	"eight-ball": "billiards",
	"pool-table": "billiards-rack",
	"pool-rack": "billiards-rack",
	"snooker-rack": "billiards-rack",
	"pool-triangle": "billiards-rack",
	"billiards-triangle": "billiards-rack",
	"snooker-triangle": "billiards-rack",
	"food-processor": "blender",
	"food-processor-outline": "blender-outline",
	"roller-shade-closed": "blinds",
	"window-closed": "roller-shade-closed",
	"blinds-open": "roller-shade",
	"mini-blinds": "blinds-horizontal-closed",
	"window-open": "roller-shade",
	"roller-shade-open": "blinds-open",
	"window": "curtains",
	"bluetooth-searching": "bluetooth-audio",
	"bluetooth-connected": "bluetooth-connect",
	"bluetooth-disabled": "bluetooth-off",
	"settings-bluetooth": "bluetooth-settings",
	"blur-on": "blur",
	"blur-circular": "blur-radial",
	"git-repository": "book",
	"dictionary": "book-alphabet",
	"book-schedule": "book-clock-outline",
	"book-time": "book-clock-outline",
	"book-settings": "book-cog",
	"book-settings-outline": "book-cog-outline",
	"bible": "book-cross",
	"book-favorite": "book-heart",
	"book-love": "book-heart",
	"book-favorite-outline": "book-heart-outline",
	"book-love-outline": "book-heart-outline",
	"encyclopedia": "book-information-variant",
	"book-secure": "book-lock",
	"book-unsecure": "book-lock-open",
	"book-secure-outline": "book-lock-outline",
	"book-location": "book-marker",
	"book-location-outline": "book-marker-outline",
	"books-minus": "book-minus-multiple",
	"books": "book-multiple",
	"audio-book": "book-music",
	"chrome-reader-mode": "book-open",
	"import-contacts": "book-open-blank-variant",
	"auto-stories": "book-open-page-variant",
	"book-add": "book-plus",
	"books-plus": "book-plus-multiple",
	"book-multiple-add": "book-plus-multiple",
	"books-add": "book-plus-multiple",
	"books-remove": "book-remove-multiple",
	"class": "book-variant",
	"turned-in": "bookmark",
	"collections-bookmark": "bookmark-box-multiple",
	"library-bookmark": "bookmark-box-multiple",
	"collections-bookmark-outline": "bookmark-box-multiple-outline",
	"library-bookmark-outline": "bookmark-box-multiple-outline",
	"bookmark-tick": "bookmark-check",
	"bookmark-success": "bookmark-check",
	"bookmark-success-outline": "bookmark-check-outline",
	"bookmark-border": "bookmark-outline",
	"turned-in-not": "bookmark-outline",
	"bookmark-add": "bookmark-plus",
	"bookmark-add-outline": "bookmark-plus-outline",
	"boom-arm": "boom-gate",
	"boom-barrier": "boom-gate",
	"arm-barrier": "boom-gate",
	"barrier": "sign-caution",
	"automatic-gate": "boom-gate",
	"boom-arm-alert": "boom-gate-alert",
	"boom-barrier-alert": "boom-gate-alert",
	"arm-barrier-alert": "boom-gate-alert",
	"barrier-alert": "boom-gate-alert",
	"automatic-gate-alert": "boom-gate-alert",
	"boom-arm-alert-outline": "boom-gate-alert-outline",
	"boom-barrier-alert-outline": "boom-gate-alert-outline",
	"arm-barrier-alert-outline": "boom-gate-alert-outline",
	"barrier-alert-outline": "boom-gate-alert-outline",
	"automatic-gate-alert-outline": "boom-gate-alert-outline",
	"boom-arm-down": "boom-gate-arrow-down",
	"boom-barrier-down": "boom-gate-arrow-down",
	"arm-barrier-down": "boom-gate-arrow-down",
	"barrier-down": "boom-gate-arrow-down",
	"automatic-gate-down": "boom-gate-arrow-down",
	"boom-arm-down-outline": "boom-gate-arrow-down-outline",
	"boom-barrier-down-outline": "boom-gate-arrow-down-outline",
	"arm-barrier-down-outline": "boom-gate-arrow-down-outline",
	"barrier-down-outline": "boom-gate-arrow-down-outline",
	"automatic-gate-down-outline": "boom-gate-arrow-down-outline",
	"boom-arm-up": "boom-gate-up",
	"boom-barrier-up": "boom-gate-up",
	"arm-barrier-up": "boom-gate-up",
	"barrier-up": "boom-gate-up",
	"automatic-gate-up": "boom-gate-up",
	"boom-arm-up-outline": "boom-gate-up-outline",
	"boom-barrier-up-outline": "boom-gate-up-outline",
	"arm-barrier-up-outline": "boom-gate-up-outline",
	"barrier-up-outline": "boom-gate-up-outline",
	"automatic-gate-up-outline": "boom-gate-up-outline",
	"boom-arm-outline": "boom-gate-outline",
	"boom-barrier-outline": "boom-gate-outline",
	"arm-barrier-outline": "boom-gate-outline",
	"barrier-outline": "boom-gate-outline",
	"automatic-gate-outline": "boom-gate-outline",
	"border-colour": "border-color",
	"border-clear": "border-none",
	"border-outer": "border-outside",
	"border-round-corners": "border-radius",
	"bottle-coke": "bottle-soda",
	"bottle-pop": "bottle-soda",
	"bottle-coke-classic": "bottle-soda-classic",
	"bottle-pop-classic": "bottle-soda-classic",
	"bottle-coke-outline": "bottle-soda-outline",
	"bottle-pop-outline": "bottle-soda-outline",
	"flask": "bottle-tonic",
	"flask-outline": "bottle-tonic-outline",
	"health-potion": "bottle-tonic-plus",
	"health-potion-outline": "bottle-tonic-plus-outline",
	"poison": "bottle-tonic-skull",
	"moonshine": "bottle-tonic-skull",
	"poison-outline": "bottle-tonic-skull-outline",
	"moonshine-outline": "bottle-tonic-skull-outline",
	"mixing-bowl": "bowl-mix",
	"mixing-bowl-outline": "bowl-mix-outline",
	"stanley-knife": "box-cutter",
	"touch-reading": "braille",
	"hand-reading": "braille",
	"work": "briefcase",
	"briefcase-person": "briefcase-account",
	"briefcase-user": "briefcase-account",
	"briefcase-person-outline": "briefcase-account-outline",
	"briefcase-user-outline": "briefcase-account-outline",
	"briefcase-transfer": "briefcase-arrow-up-down",
	"briefcase-exchange": "briefcase-arrow-up-down",
	"briefcase-swap": "briefcase-arrow-up-down",
	"briefcase-exchange-outline": "briefcase-arrow-up-down-outline",
	"briefcase-transfer-outline": "briefcase-arrow-up-down-outline",
	"briefcase-swap-outline": "briefcase-arrow-up-down-outline",
	"briefcase-tick": "briefcase-check",
	"briefcase-view": "briefcase-eye",
	"briefcase-view-outline": "briefcase-eye-outline",
	"work-outline": "briefcase-outline",
	"briefcase-add": "briefcase-plus",
	"briefcase-add-outline": "briefcase-plus-outline",
	"theme-light-dark": "compare",
	"brightness-low": "brightness-5",
	"brightness-medium": "brightness-6",
	"brightness-high": "brightness-7",
	"discount": "sale",
	"sale": "percent",
	"signal": "broadcast",
	"signal-off": "broadcast-off",
	"paintbrush": "brush-variant",
	"paintbrush-outline": "brush-outline",
	"sideboard": "buffet",
	"bug-report": "bug",
	"bug-tick": "bug-check",
	"bug-tick-outline": "bug-check-outline",
	"bug-start": "bug-play",
	"car-horn": "bugle",
	"notice-board": "bulletin-board",
	"announcement": "message-alert",
	"megaphone": "bullhorn-variant",
	"loudspeaker": "bullhorn-variant",
	"announcement-outline": "message-alert-outline",
	"megaphone-outline": "bullhorn-variant-outline",
	"loudspeaker-outline": "bullhorn-variant-outline",
	"target": "bullseye",
	"target-arrow": "bullseye-arrow",
	"directions-bus": "bus",
	"bus-warning": "bus-alert",
	"departure-board": "bus-clock",
	"bus-location": "bus-marker",
	"bus-stop": "bus-marker",
	"fleet": "bus-multiple",
	"education": "school",
	"counterclockwise-arrows": "sync",
	"birthday-cake": "cake-variant",
	"birthday-cake-outline": "cake-variant-outline",
	"event": "calendar",
	"insert-invitation": "calendar",
	"calendar-user": "calendar-account",
	"calendar-user-outline": "calendar-account-outline",
	"event-alert": "calendar-alert",
	"calendar-warning": "calendar-alert",
	"reschedule": "calendar-arrow-right",
	"calendar-today": "calendar-blank",
	"event-blank-outline": "calendar-blank-outline",
	"event-available": "calendar-check",
	"calendar-task": "calendar-check",
	"calendar-tick": "calendar-check",
	"event-tick": "calendar-check",
	"event-check": "calendar-check",
	"event-available-outline": "calendar-check-outline",
	"event-check-outline": "calendar-check-outline",
	"event-tick-outline": "calendar-check-outline",
	"calendar-task-outline": "calendar-check-outline",
	"calendar-tick-outline": "calendar-check-outline",
	"event-clock": "calendar-clock",
	"event-time": "calendar-clock",
	"calendar-time": "calendar-clock",
	"event-edit": "calendar-edit",
	"event-week-end-outline": "calendar-filter-outline",
	"event-heart": "calendar-heart",
	"event-minus": "calendar-minus",
	"event-multiple": "calendar-multiple",
	"calendars": "calendar-multiple",
	"events": "calendar-multiple",
	"event-multiple-check": "calendar-multiple-check",
	"calendar-multiple-tick": "calendar-multiple-check",
	"calendars-check": "calendar-multiple-check",
	"calendars-tick": "calendar-multiple-check",
	"event-multiple-tick": "calendar-multiple-check",
	"events-check": "calendar-multiple-check",
	"events-tick": "calendar-multiple-check",
	"event-outline": "calendar-outline",
	"event-plus": "calendar-plus",
	"calendar-add": "calendar-plus",
	"event-add": "calendar-plus",
	"calendar-rsvp": "calendar-question",
	"event-question": "calendar-question",
	"calendar-help": "calendar-question",
	"calendar-help-outline": "calendar-question-outline",
	"date-range": "calendar-range",
	"calendar-week": "calendar-range",
	"event-range": "calendar-range",
	"event-range-outline": "calendar-range-outline",
	"calendar-repeat": "calendar-sync",
	"calendar-repeat-outline": "calendar-sync-outline",
	"event-busy": "calendar-remove",
	"event-remove": "calendar-remove",
	"event-busy-outline": "calendar-remove-outline",
	"event-remove-outline": "calendar-remove-outline",
	"event-search": "calendar-search",
	"event-star": "calendar-star",
	"calendar-favorite": "calendar-star",
	"calendar-auto": "calendar-star-four-points",
	"event-star-four-points": "calendar-star-four-points",
	"event-auto": "calendar-star-four-points",
	"event-note": "calendar-text",
	"event-text": "calendar-text",
	"event-text-outline": "calendar-text-outline",
	"event-note-outline": "calendar-text-outline",
	"calendar-day": "calendar-today",
	"calendar-day-outline": "calendar-today-outline",
	"event-week": "calendar-week",
	"event-week-begin": "calendar-week-begin",
	"event-week-begin-outline": "calendar-week-begin-outline",
	"event-week-outline": "calendar-week-outline",
	"merge-type": "call-merge",
	"photography": "camera",
	"camera-alt": "camera",
	"local-see": "camera",
	"photo-camera": "camera",
	"camera-user": "camera-account",
	"burst-mode": "camera-burst",
	"overhead-projector": "camera-document",
	"overhead-projector-off": "camera-document-off",
	"camera-sync": "camera-flip",
	"camera-refresh": "camera-flip",
	"camera-sync-outline": "camera-flip-outline",
	"camera-refresh-outline": "camera-flip-outline",
	"camera-location": "camera-marker",
	"camera-location-outline": "camera-marker-outline",
	"camera-metering-centre": "camera-metering-center",
	"switch-camera": "camera-switch",
	"prohibited": "cancel",
	"ban": "file-cancel-outline",
	"do-not-disturb-alt": "cancel",
	"denied": "cancel",
	"block": "cancel",
	"forbid": "file-cancel-outline",
	"no": "cancel",
	"candle": "menorah",
	"candelabrum": "menorah",
	"candelabrum-fire": "menorah-fire",
	"candelabrum-flame": "menorah-fire",
	"candelabra-flame": "menorah-fire",
	"candle-fire": "menorah-fire",
	"candle-flame": "menorah-fire",
	"treat": "candy",
	"chocolate": "candy",
	"chocolate-off": "candy-off",
	"treat-off": "candy-off",
	"chocolate-off-outline": "candy-off-outline",
	"treat-off-outline": "candy-off-outline",
	"navi-off": "candy-off-outline",
	"chocolate-outline": "candy-outline",
	"treat-outline": "candy-outline",
	"navi": "candy-outline",
	"hey-listen": "candy-outline",
	"fairy": "candy-outline",
	"weed": "cannabis",
	"pot": "cannabis",
	"marijuana": "cannabis",
	"directions-car": "car",
	"drive-eta": "car",
	"time-to-leave": "car",
	"hov-lane": "cards-diamond",
	"high-occupancy-vehicle-lane": "cards-diamond",
	"carpool-lane": "cards-diamond",
	"anti-lock-brake-system": "car-brake-abs",
	"anti-lock-braking-system": "car-brake-abs",
	"car-parking-brake": "car-brake-alert",
	"car-handbrake": "car-brake-alert",
	"car-hand-brake": "car-brake-alert",
	"car-emergency-brake": "car-brake-alert",
	"car-brake-warning": "car-brake-alert",
	"car-settings": "car-cog",
	"car-police": "car-emergency",
	"electronic-stability-program": "car-esp",
	"car-suv": "car-estate",
	"car-sports-utility-vehicle": "car-estate",
	"car-rental": "car-key",
	"rent-a-car": "car-key",
	"head-light-dimmed": "car-light-dimmed",
	"low-beam": "car-light-dimmed",
	"head-light-fog": "car-light-fog",
	"head-light-high": "car-light-high",
	"high-beam": "car-light-high",
	"truck-pickup": "car-pickup",
	"car-find": "car-search",
	"car-find-outline": "car-search-outline",
	"car-location": "car-select",
	"car-transmission": "car-shift-pattern",
	"car-manual-transmission": "car-shift-pattern",
	"car-saloon": "car-side",
	"car-tyre-alert": "car-tire-alert",
	"car-tyre-warning": "car-tire-alert",
	"car-tire-warning": "car-tire-alert",
	"local-car-wash": "car-wash",
	"car-front-glass": "car-windshield",
	"car-front-glass-outline": "car-windshield-outline",
	"car-autonomous": "car-wireless",
	"car-self-driving": "car-wireless",
	"car-smart": "car-wireless",
	"car-repair": "car-wrench",
	"mechanic": "car-wrench",
	"karabiner": "carabiner",
	"rock-climbing": "carabiner",
	"holiday": "tent",
	"camping": "tent",
	"button": "card",
	"identification-card": "card-account-details",
	"user-card-details": "card-account-details",
	"id-card": "card-account-details",
	"person-card-details": "card-account-details",
	"drivers-license": "card-account-details",
	"business-card": "card-account-details",
	"identification-card-outline": "card-account-details-outline",
	"user-card-details-outline": "card-account-details-outline",
	"id-card-outline": "card-account-details-outline",
	"person-card-details-outline": "card-account-details-outline",
	"drivers-license-outline": "card-account-details-outline",
	"business-card-outline": "card-account-details-outline",
	"card-account-details-favorite": "card-account-details-star",
	"card-account-details-favorite-outline": "card-account-details-star-outline",
	"contact-mail": "card-account-mail",
	"contact-mail-outline": "card-account-mail-outline",
	"contact-phone": "card-account-phone",
	"contact-phone-outline": "card-account-phone-outline",
	"button-outline": "card-outline",
	"pageview": "card-search",
	"pageview-outline": "card-search-outline",
	"suit-clubs": "cards-club",
	"poker-club": "cards-club",
	"suit-diamonds": "cards-diamond",
	"poker-diamond": "cards-diamond",
	"hov-lane-outline": "cards-diamond-outline",
	"high-occupancy-vehicle-lane-outline": "cards-diamond-outline",
	"carpool-lane-outline": "cards-diamond-outline",
	"poker-diamond-outline": "cards-diamond-outline",
	"suit-hearts": "cards-heart",
	"poker-heart": "cards-heart",
	"suit-spades": "cards-spade",
	"poker-spade": "cards-spade",
	"trolley": "dolly",
	"local-grocery-store": "cart",
	"shopping-cart": "cart",
	"shopping-cart-arrow-down": "cart-arrow-down",
	"trolley-arrow-down": "cart-arrow-down",
	"trolley-arrow-right": "cart-arrow-right",
	"shopping-cart-arrow-right": "cart-arrow-right",
	"shopping-cart-arrow-up": "cart-arrow-up",
	"trolley-arrow-up": "cart-arrow-up",
	"cart-favorite": "cart-heart",
	"shopping-favorite": "cart-heart",
	"shopping-cart-minus": "cart-minus",
	"trolley-minus": "cart-minus",
	"trolley-off": "cart-off",
	"remove-shopping-cart": "cart-off",
	"shopping-cart-off": "cart-off",
	"trolley-outline": "cart-outline",
	"shopping-cart-outline": "cart-outline",
	"cart-discount": "cart-percent",
	"cart-sale": "cart-percent",
	"trolley-percent": "cart-percent",
	"trolley-plus": "cart-plus",
	"add-shopping-cart": "cart-plus",
	"shopping-cart-plus": "cart-plus",
	"cart-add": "cart-plus",
	"trolley-add": "cart-plus",
	"shopping-cart-add": "cart-plus",
	"trolley-remove": "cart-remove",
	"shopping-cart-remove": "cart-remove",
	"money": "cash-multiple",
	"money-100": "cash-100",
	"cash-schedule": "cash-clock",
	"payment-schedule": "cash-clock",
	"payment-clock": "cash-clock",
	"auto-pay": "cash-sync",
	"instant-deposit": "cash-fast",
	"instant-transfer": "cash-fast",
	"instant-cash": "cash-fast",
	"cod": "credit-card-marker-outline",
	"cash-on-delivery": "cash-marker",
	"cash-location": "cash-marker",
	"cash-return": "cash-refund",
	"cash-chargeback": "cash-refund",
	"till": "cash-register",
	"recurring-payment": "cash-sync",
	"scheduled-payment": "cash-sync",
	"cash-cycle": "cash-sync",
	"tape": "cassette",
	"cast-speaker": "cast-audio",
	"apple-airplay": "cast-audio-variant",
	"cast-school": "cast-education",
	"school-online": "cast-education",
	"cast-tutorial": "cast-education",
	"apple": "cast-variant",
	"airplay": "cast-variant",
	"emoji-cat": "cat",
	"emoticon-cat": "cat",
	"closed-circuit-television": "cctv",
	"security-camera": "cctv",
	"closed-circuit-television-off": "cctv-off",
	"security-camera-off": "cctv-off",
	"ceiling-fan-on": "ceiling-fan-light",
	"ceiling-lamp": "ceiling-light",
	"ceiling-lamp-multiple": "ceiling-light-multiple",
	"ceiling-lamp-multiple-outline": "ceiling-light-multiple-outline",
	"mobile-phone": "cellphone",
	"smartphone": "devices",
	"stay-current-portrait": "cellphone",
	"stay-primary-portrait": "cellphone",
	"cellphone-system-update": "cellphone-arrow-down",
	"mobile-phone-arrow-down": "cellphone-arrow-down",
	"smartphone-arrow-down": "cellphone-arrow-down",
	"cellphone-download": "cellphone-arrow-down-variant",
	"mobile-phone-basic": "cellphone-basic",
	"phonelink-setup": "cellphone-cog",
	"mobile-phone-settings-variant": "cellphone-cog",
	"smartphone-settings-variant": "cellphone-cog",
	"mobile-phone-dock": "cellphone-dock",
	"smartphone-dock": "cellphone-dock",
	"mobile-phone-information": "cellphone-information",
	"smartphone-information": "cellphone-information",
	"mobile-phone-key": "cellphone-key",
	"smartphone-key": "cellphone-key",
	"mobile-phone-link": "cellphone-link",
	"smartphone-link": "cellphone-link",
	"devices": "cellphone-link",
	"mobile-phone-link-off": "cellphone-link-off",
	"smartphone-link-off": "cellphone-link-off",
	"phonelink-off": "cellphone-link-off",
	"phonelink-lock": "cellphone-lock",
	"mobile-phone-lock": "cellphone-lock",
	"smartphone-lock": "cellphone-lock",
	"cellphone-location": "tooltip-cellphone",
	"cellphone-map": "cellphone-marker",
	"find-my-phone": "tooltip-cellphone",
	"cellphone-gps": "tooltip-cellphone",
	"mobile-phone-message": "cellphone-message",
	"smartphone-message": "cellphone-message",
	"mobile-phone-off": "cellphone-off",
	"smartphone-off": "cellphone-off",
	"mobile-off": "cellphone-off",
	"phonelink-erase": "cellphone-remove",
	"mobile-phone-erase": "cellphone-remove",
	"smartphone-erase": "cellphone-remove",
	"cellphone-erase": "cellphone-remove",
	"mobile-phone-settings": "cellphone-settings",
	"smartphone-settings": "cellphone-settings",
	"settings-cell": "cellphone-settings",
	"phonelink-ring": "cellphone-sound",
	"mobile-phone-sound": "cellphone-sound",
	"smartphone-sound": "cellphone-sound",
	"mobile-phone-text": "cellphone-text",
	"smartphone-text": "cellphone-text",
	"mobile-phone-wireless": "cellphone-wireless",
	"smartphone-wireless": "cellphone-wireless",
	"diploma": "certificate",
	"seal": "license",
	"diploma-outline": "certificate-outline",
	"seal-outline": "certificate-outline",
	"office-chair": "chair-rolling",
	"study-chair": "chair-rolling",
	"desk": "chair-school",
	"learn": "school",
	"ceiling-light": "chandelier",
	"girandole": "chandelier",
	"candelabra-lamp": "chandelier",
	"suspended-light": "chandelier",
	"super-chat-for-good": "charity",
	"report-arc": "chart-arc",
	"widget-arc": "chart-arc",
	"report-areaspline": "chart-areaspline",
	"widget-areaspline": "chart-areaspline",
	"graph-areaspline": "chart-areaspline",
	"report-areaspline-variant": "chart-areaspline-variant",
	"widget-areaspline-variant": "chart-areaspline-variant",
	"graph-areaspline-variant": "chart-areaspline-variant",
	"report-bar": "chart-bar",
	"widget-bar": "chart-bar",
	"graph-bar": "finance",
	"report-bar-stacked": "chart-bar-stacked",
	"widget-bar-stacked": "chart-bar-stacked",
	"graph-bar-stacked": "chart-bar-stacked",
	"report-bell-curve": "chart-bell-curve",
	"widget-bell-curve": "chart-bell-curve",
	"graph-bell-curve": "chart-bell-curve",
	"report-bell-curve-cumulative": "chart-bell-curve-cumulative",
	"widget-bell-curve-cumulative": "chart-bell-curve-cumulative",
	"graph-bell-curve-cumulative": "chart-bell-curve-cumulative",
	"poll-box": "chart-box",
	"report-box": "chart-box",
	"widget-box": "chart-box",
	"graph-box": "chart-box",
	"poll-box-multiple": "chart-box-multiple",
	"graph-box-multiple": "chart-box-multiple",
	"widget-box-multiple": "chart-box-multiple",
	"report-box-multiple": "chart-box-multiple",
	"graph-box-multiple-outline": "chart-box-multiple-outline",
	"widget-box-multiple-outline": "chart-box-multiple-outline",
	"report-box-multiple-outline": "chart-box-multiple-outline",
	"poll-box-multiple-outline": "chart-box-multiple-outline",
	"poll-box-outline": "chart-box-outline",
	"report-box-outline": "chart-box-outline",
	"widget-box-outline": "chart-box-outline",
	"graph-box-outline": "chart-box-outline",
	"report-box-plus-outline": "chart-box-plus-outline",
	"widget-box-plus-outline": "chart-box-plus-outline",
	"graph-box-plus-outline": "chart-box-plus-outline",
	"bubble-chart": "chart-bubble",
	"report-bubble": "chart-bubble",
	"widget-bubble": "chart-bubble",
	"chart-doughnut": "chart-donut",
	"data-usage": "chart-donut",
	"report-donut": "chart-donut",
	"widget-donut": "chart-donut",
	"chart-doughnut-variant": "chart-donut-variant",
	"report-donut-variant": "chart-donut-variant",
	"widget-donut-variant": "chart-donut-variant",
	"report-gantt": "chart-gantt",
	"timeline": "chart-gantt",
	"widget-gantt": "chart-gantt",
	"roadmap": "chart-timeline",
	"report-histogram": "chart-histogram",
	"widget-histogram": "chart-histogram",
	"graph-histogram": "chart-histogram",
	"report-line": "chart-timeline-variant",
	"widget-line": "chart-timeline-variant",
	"graph-line": "chart-timeline-variant",
	"report-line-stacked": "chart-line-stacked",
	"widget-line-stacked": "chart-line-stacked",
	"graph-line-stacked": "chart-line-stacked",
	"show-chart": "chart-line-variant",
	"report-line-variant": "chart-line-variant",
	"widget-line-variant": "chart-line-variant",
	"graph-line-variant": "chart-line-variant",
	"report-multiline": "chart-multiline",
	"widget-multiline": "chart-multiline",
	"graph-multiline": "chart-multiline",
	"report-multiple": "chart-multiple",
	"widget-multiple": "chart-multiple",
	"graph-multiple": "chart-multiple",
	"report-pie": "chart-pie",
	"widget-pie": "chart-pie",
	"graph-pie": "chart-pie",
	"report-pie-outline": "chart-pie-outline",
	"widget-pie-outline": "chart-pie-outline",
	"graph-pie-outline": "chart-pie-outline",
	"chart-production-possibility-frontier": "chart-ppf",
	"report-ppf": "chart-ppf",
	"widget-ppf": "chart-ppf",
	"graph-ppf": "chart-ppf",
	"chart-snakey": "chart-sankey",
	"report-sankey": "chart-sankey",
	"widget-sankey": "chart-sankey",
	"graph-sankey": "chart-sankey",
	"chart-snakey-variant": "chart-sankey-variant",
	"report-sankey-variant": "chart-sankey-variant",
	"widget-sankey-variant": "chart-sankey-variant",
	"graph-sankey-variant": "chart-sankey-variant",
	"report-scatter-plot": "chart-scatter-plot",
	"widget-scatter-plot": "chart-scatter-plot",
	"graph-scatter-plot": "chart-scatter-plot",
	"chart-scatterplot-hexbin": "chart-scatter-plot-hexbin",
	"report-scatter-plot-hexbin": "chart-scatter-plot-hexbin",
	"widget-scatter-plot-hexbin": "chart-scatter-plot-hexbin",
	"graph-scatter-plot-hexbin": "chart-scatter-plot-hexbin",
	"report-timeline": "chart-timeline",
	"widget-timeline": "chart-timeline",
	"graph-timeline": "chart-timeline",
	"report-timeline-variant": "chart-timeline-variant",
	"widget-timeline-variant": "chart-timeline-variant",
	"graph-timeline-variant": "chart-timeline-variant",
	"report-timeline-variant-shimmer": "chart-timeline-variant-shimmer",
	"widget-timeline-variant-shimmer": "chart-timeline-variant-shimmer",
	"graph-timeline-variant-shimmer": "chart-timeline-variant-shimmer",
	"report-line-shimmer": "chart-timeline-variant-shimmer",
	"widget-line-shimmer": "chart-timeline-variant-shimmer",
	"graph-line-shimmer": "chart-timeline-variant-shimmer",
	"report-tree": "chart-tree",
	"widget-tree": "chart-tree",
	"message": "chat",
	"message-bubble": "chat",
	"chat-warning": "chat-alert",
	"message-outline": "chat-outline",
	"message-bubble-outline": "chat-outline",
	"speak-outline": "chat-outline",
	"chat-typing": "chat-processing",
	"chat-typing-outline": "chat-processing-outline",
	"chat-help": "chat-question",
	"chat-help-outline": "chat-question-outline",
	"tick": "check",
	"done": "check",
	"success": "check",
	"tick-all": "check-all",
	"done-all": "check-all",
	"check-multiple": "check-all",
	"checks": "check-all",
	"ticks": "check-all",
	"check-thick": "check-bold",
	"success-thick": "check-bold",
	"success-bold": "check-bold",
	"tick-circle": "check-circle",
	"success-circle": "check-circle",
	"tick-circle-outline": "check-circle-outline",
	"success-circle-outline": "check-circle-outline",
	"verified": "shield-check",
	"decagram-check": "check-decagram",
	"approve": "check-decagram-outline",
	"approval": "check-decagram-outline",
	"tick-decagram": "check-decagram",
	"tick-network": "check-network",
	"tick-network-outline": "check-network-outline",
	"done-outline": "check-outline",
	"tick-outline": "check-outline",
	"sucess-outline": "check-outline",
	"chequebook": "checkbook",
	"cheque-book": "checkbook",
	"chequebook-arrow-left": "checkbook-arrow-left",
	"chequebook-arrow-right": "checkbook-arrow-right",
	"checkbox-blank-notification": "checkbox-blank-badge",
	"app-notification": "checkbox-blank-badge",
	"app-badge": "square-rounded-badge",
	"checkbox-blank-notification-outline": "checkbox-blank-badge-outline",
	"app-notification-outline": "checkbox-blank-badge-outline",
	"app-badge-outline": "square-rounded-badge-outline",
	"check-box-outline-blank": "checkbox-blank-outline",
	"maximize": "checkbox-blank-outline",
	"checkbox-indeterminate": "checkbox-intermediate",
	"checkbox-indeterminate-variant": "checkbox-intermediate-variant",
	"check-box": "checkbox-marked",
	"task-auto": "checkbox-marked-circle-auto-outline",
	"todo-auto": "checkbox-marked-circle-auto-outline",
	"todo-minus": "checkbox-marked-circle-minus-outline",
	"task-minus": "checkbox-marked-circle-minus-outline",
	"task-plus": "checkbox-marked-circle-plus-outline",
	"task-add": "checkbox-marked-circle-plus-outline",
	"todo-plus": "checkbox-marked-circle-plus-outline",
	"todo-add": "checkbox-marked-circle-plus-outline",
	"checkboxes-blank": "checkbox-multiple-blank",
	"checkboxes-blank-circle": "checkbox-multiple-blank-circle",
	"checkboxes-blank-circle-outline": "checkbox-multiple-blank-circle-outline",
	"checkboxes-blank-outline": "checkbox-multiple-blank-outline",
	"checkboxes-marked": "checkbox-multiple-marked",
	"checkboxes-marked-circle": "checkbox-multiple-marked-circle",
	"checkboxes-marked-circle-outline": "checkbox-multiple-marked-circle-outline",
	"checkboxes-marked-outline": "checkbox-multiple-marked-outline",
	"check-boxes-outline": "checkbox-multiple-outline",
	"tick-box-multiple-outline": "checkbox-multiple-outline",
	"raster": "checkerboard",
	"raster-minus": "checkerboard-minus",
	"raster-plus": "checkerboard-plus",
	"raster-remove": "checkerboard-remove",
	"swiss-cheese": "cheese",
	"toque": "chef-hat",
	"cook": "chef-hat",
	"crown": "chess-queen",
	"royalty": "chess-queen",
	"chess-horse": "chess-knight",
	"chess-castle": "chess-rook",
	"chess-tower": "chess-rook",
	"expand-more": "chevron-down",
	"keyboard-arrow-down": "chevron-down",
	"keyboard-arrow-left": "chevron-left",
	"navigate-before": "chevron-left",
	"keyboard-arrow-right": "chevron-right",
	"navigate-next": "chevron-right",
	"rank": "chevron-triple-up",
	"expand-less": "chevron-up",
	"keyboard-arrow-up": "chevron-up",
	"caret": "chevron-up",
	"chilli-hot": "chili-hot",
	"pepper": "shaker",
	"spicy": "chili-mild",
	"chilli-medium": "chili-medium",
	"chilli-mild": "chili-mild",
	"chilli-off": "chili-off",
	"pepper-off": "chili-off",
	"spicy-off": "chili-off",
	"integrated-circuit": "chip",
	"lens": "circle",
	"brightness-half": "circle-half",
	"coins": "circle-multiple",
	"toll": "circle-multiple-outline",
	"coins-outline": "circle-multiple-outline",
	"null-off": "circle-off-outline",
	"circle-transparent": "circle-opacity",
	"null": "circle-outline",
	"bullet": "square-small",
	"multiplication": "circle-small",
	"dot": "circle-small",
	"location-city": "city",
	"city-swap": "city-switch",
	"clipboard-user": "clipboard-account",
	"assignment-ind": "clipboard-account",
	"clipboard-person": "clipboard-account",
	"clipboard-user-outline": "clipboard-account-outline",
	"clipboard-person-outline": "clipboard-account-outline",
	"assignment-ind-outline": "clipboard-account-outline",
	"clipboard-warning": "clipboard-alert",
	"assignment-late": "clipboard-alert",
	"clipboard-warning-outline": "clipboard-alert-outline",
	"assignment-returned": "clipboard-arrow-down",
	"clipboard-arrow-bottom": "clipboard-arrow-down",
	"assignment-returned-outline": "clipboard-arrow-down-outline",
	"clipboard-arrow-bottom-outline": "clipboard-arrow-down-outline",
	"assignment-return": "clipboard-arrow-left",
	"clipboard-arrow-top": "clipboard-arrow-up",
	"clipboard-arrow-top-outline": "clipboard-arrow-up-outline",
	"assignment-turned-in": "clipboard-check",
	"clipboard-tick": "clipboard-check",
	"clipboard-tick-outline": "clipboard-check-outline",
	"clipboard-add": "clipboard-plus",
	"clipboard-vitals": "clipboard-pulse",
	"clipboard-vitals-outline": "clipboard-pulse-outline",
	"assignment": "clipboard-text",
	"clipboard-text-date": "clipboard-text-clock",
	"clipboard-text-time": "clipboard-text-clock",
	"clipboard-text-history": "clipboard-text-clock",
	"clipboard-text-date-outline": "clipboard-text-clock-outline",
	"clipboard-text-time-outline": "clipboard-text-clock-outline",
	"clipboard-text-history-outline": "clipboard-text-clock-outline",
	"watch-later": "clock",
	"clock-warning": "clock-alert-outline",
	"access-time": "clock-outline",
	"query-builder": "clock-outline",
	"schedule": "clock-outline",
	"clock-auto": "clock-star-four-points",
	"clock-auto-outline": "clock-star-four-points-outline",
	"multiply": "close",
	"remove": "minus",
	"cancel": "window-close",
	"times": "close",
	"multiply-box": "close-box",
	"clear-box": "close-box",
	"cancel-box": "close-box",
	"remove-box": "close-box",
	"close-boxes": "close-box-multiple",
	"library-remove": "close-box-multiple",
	"library-close": "close-box-multiple",
	"multiply-boxes": "close-box-multiple",
	"multiply-box-multiple": "close-box-multiple",
	"cancel-box-multiple": "close-box-multiple-outline",
	"remove-box-multiple": "close-box-multiple-outline",
	"close-boxes-outline": "close-box-multiple-outline",
	"library-remove-outline": "close-box-multiple-outline",
	"library-close-outline": "close-box-multiple-outline",
	"multiply-boxes-outline": "close-box-multiple-outline",
	"multiply-box-multiple-outline": "close-box-multiple-outline",
	"multiply-box-outline": "close-box-outline",
	"clear-box-outline": "close-box-outline",
	"remove-box-outline": "close-box-outline",
	"cancel-box-outline": "close-box-outline",
	"remove-circle": "minus-circle",
	"cancel-circle": "close-circle",
	"multiply-circle": "close-circle",
	"clear-circle": "close-circle",
	"remove-circle-multiple": "close-circle-multiple",
	"coins-close": "close-circle-multiple",
	"coins-remove": "close-circle-multiple",
	"clear-circle-multiple": "close-circle-multiple",
	"multiply-circle-multiple": "close-circle-multiple",
	"remove-circle-multiple-outline": "close-circle-multiple-outline",
	"coins-close-outline": "close-circle-multiple-outline",
	"coins-remove-outline": "close-circle-multiple-outline",
	"cancel-circle-multiple-outline": "close-circle-multiple-outline",
	"multiply-circle-multiple-outline": "close-circle-multiple-outline",
	"clear-circle-multiple-outline": "close-circle-multiple-outline",
	"highlight-off": "close-circle-outline",
	"multiply-circle-outline": "close-circle-outline",
	"remove-circle-outline": "minus-circle-outline",
	"clear-circle-outline": "close-circle-outline",
	"cancel-circle-outline": "close-circle-outline",
	"remove-network": "close-network",
	"cancel-network": "close-network",
	"multiply-network": "close-network",
	"clear-network": "close-network",
	"remove-network-outline": "close-network-outline",
	"cancel-network-outline": "close-network-outline",
	"multiply-network-outline": "close-network-outline",
	"clear-network-outline": "close-network-outline",
	"dangerous": "close-octagon",
	"multiply-octagon": "close-octagon",
	"remove-octagon": "close-octagon",
	"cancel-octagon": "close-octagon",
	"clear-octagon": "close-octagon",
	"stop-remove": "close-octagon",
	"remove-octagon-outline": "close-octagon-outline",
	"multiply-octagon-outline": "close-octagon-outline",
	"clear-octagon-outline": "close-octagon-outline",
	"cancel-octagon-outline": "close-octagon-outline",
	"stop-remove-outline": "close-octagon-outline",
	"remove-outline": "close-outline",
	"cancel-outline": "close-outline",
	"multiply-outline": "close-outline",
	"close-bold": "close-thick",
	"remove-thick": "close-thick",
	"remove-bold": "close-thick",
	"multiply-thick": "close-thick",
	"multiply-bold": "close-thick",
	"clear-thick": "close-thick",
	"clear-bold": "close-thick",
	"cancel-thick": "close-thick",
	"cancel-bold": "close-thick",
	"cc": "closed-caption",
	"cc-outline": "closed-caption-outline",
	"wb-cloudy": "cloud",
	"cloud-warning": "cloud-alert",
	"cloud-json": "cloud-braces",
	"cloud-done": "cloud-check-variant",
	"cloud-tick": "cloud-check-variant",
	"cloud-security": "cloud-key",
	"cloud-access": "cloud-key",
	"cloud-security-outline": "cloud-key-outline",
	"cloud-access-outline": "cloud-key-outline",
	"offline": "cloud-off-outline",
	"local": "cloud-off-outline",
	"cloud-queue": "cloud-outline",
	"humidity": "waves-arrow-up",
	"rain-chance": "cloud-percent",
	"cloud-discount": "cloud-percent",
	"cloud-discount-outline": "cloud-percent-outline",
	"humidity-outline": "cloud-percent-outline",
	"rain-chance-outline": "cloud-percent-outline",
	"cloud-xml": "cloud-tags",
	"backup": "cloud-upload",
	"backup-outline": "cloud-upload-outline",
	"luck": "horseshoe",
	"luck-outline": "clover-outline",
	"coach-light": "coach-lamp-variant",
	"carriage-lamp": "coach-lamp-variant",
	"carriage-light": "coach-lamp-variant",
	"foyer": "image-frame",
	"hallway": "image-frame",
	"entry-room": "image-frame",
	"code-block-tag": "code-block-braces",
	"code-block-json": "code-block-braces",
	"code-block-square": "code-block-brackets",
	"code-block-html": "code-block-tags",
	"code-block-xml": "code-block-tags",
	"set": "code-braces",
	"square-brackets": "code-brackets",
	"code-tags-tick": "code-tags-check",
	"tea": "coffee",
	"cup": "glass-wine",
	"free-breakfast": "coffee",
	"local-cafe": "coffee",
	"espresso-maker": "coffee-maker",
	"coffee-machine": "coffee-maker",
	"espresso-machine": "coffee-maker",
	"coffee-maker-done": "coffee-maker-check",
	"coffee-maker-complete": "coffee-maker-check",
	"coffee-maker-complete-outline": "coffee-maker-check-outline",
	"coffee-maker-done-outline": "coffee-maker-check-outline",
	"drink-off": "food-off",
	"tea-off": "coffee-off",
	"cup-off": "food-off",
	"free-breakfast-off": "coffee-off",
	"local-cafe-off": "coffee-off",
	"drink-off-outline": "cup-off-outline",
	"cup-off-outline": "coffee-off-outline",
	"tea-off-outline": "coffee-off-outline",
	"free-breakfast-off-outline": "coffee-off-outline",
	"local-cafe-off-outline": "coffee-off-outline",
	"tea-outline": "coffee-outline",
	"cup-outline": "coffee-outline",
	"free-breakfast-outline": "coffee-outline",
	"local-cafe-outline": "coffee-outline",
	"tea-to-go": "coffee-to-go",
	"drink-to-go": "coffee-to-go",
	"cup-to-go": "coffee-to-go",
	"free-breakfast-to-go": "coffee-to-go",
	"local-cafe-to-go": "coffee-to-go",
	"tea-to-go-outline": "coffee-to-go-outline",
	"cup-to-go-outline": "coffee-to-go-outline",
	"drink-to-go-outline": "coffee-to-go-outline",
	"free-breakfast-to-go-outline": "coffee-to-go-outline",
	"local-cafe-to-go-outline": "coffee-to-go-outline",
	"death": "coffin",
	"dead": "coffin",
	"settings": "tune-variant",
	"gear": "cog",
	"gear-box": "cog-box",
	"settings-applications": "cog-box",
	"settings-box": "cog-box",
	"settings-off": "cog-off",
	"settings-off-outline": "cog-off-outline",
	"gear-outline": "cog-outline",
	"settings-outline": "cog-outline",
	"settings-pause": "cog-pause",
	"gear-pause": "cog-pause",
	"settings-pause-outline": "cog-pause-outline",
	"gear-pause-outline": "cog-pause-outline",
	"settings-play": "cog-play",
	"gear-play": "cog-play",
	"settings-play-outline": "cog-play-outline",
	"gear-play-outline": "cog-play-outline",
	"settings-refresh": "cog-refresh",
	"settings-refresh-outline": "cog-refresh-outline",
	"settings-stop": "cog-stop",
	"gear-stop": "cog-stop",
	"settings-stop-outline": "cog-stop-outline",
	"gear-stop-outline": "cog-stop-outline",
	"settings-sync": "cog-sync",
	"settings-sync-outline": "cog-sync-outline",
	"settings-transfer": "cog-transfer",
	"settings-transfer-outline": "cog-transfer-outline",
	"manufacturing": "cogs",
	"auto-awesome-mosaic": "collage",
	"animation-minus": "collapse-all",
	"animation-minus-outline": "collapse-all-outline",
	"colour-helper": "color-helper",
	"comment-user": "comment-account",
	"comment-person": "comment-account",
	"comment-user-outline": "comment-account-outline",
	"comment-person-outline": "comment-account-outline",
	"comment-warning": "comment-alert",
	"comment-warning-outline": "comment-alert-outline",
	"comment-previous": "comment-arrow-left",
	"comment-previous-outline": "comment-arrow-left-outline",
	"comment-next": "comment-arrow-right",
	"comment-next-outline": "comment-arrow-right-outline",
	"comment-tick": "comment-check",
	"comment-tick-outline": "comment-check-outline",
	"comment-quick": "comment-flash",
	"comment-quick-outline": "comment-flash-outline",
	"comments": "comment-multiple",
	"comments-outline": "comment-multiple-outline",
	"comment-add": "comment-plus",
	"comment-add-outline": "comment-plus-outline",
	"comment-help": "comment-question",
	"comment-help-outline": "comment-question-outline",
	"feedback": "message-alert",
	"feedback-outline": "message-alert-outline",
	"comments-text": "comment-text-multiple",
	"comments-text-outline": "comment-text-multiple-outline",
	"explore": "compass",
	"regeneration": "compost",
	"regenerative-agriculture": "compost",
	"plug": "connection",
	"terminal": "console",
	"terminal-line": "console-line",
	"terminal-network": "console-network",
	"terminal-network-outline": "console-network-outline",
	"scissors": "content-cut",
	"clip": "content-cut",
	"floppy-disc": "content-save",
	"floppy-disk": "content-save",
	"floppy-disc-alert": "content-save-alert",
	"floppy-disc-alert-outline": "content-save-alert-outline",
	"floppy-disc-multiple": "content-save-all",
	"floppy-disc-multiple-outline": "content-save-all-outline",
	"floppy-disc-cog": "content-save-cog",
	"floppy-disc-cog-outline": "content-save-cog-outline",
	"floppy-disc-edit": "content-save-edit",
	"floppy-disc-edit-outline": "content-save-edit-outline",
	"floppy-disc-move": "content-save-move",
	"floppy-disc-move-outline": "content-save-move-outline",
	"content-save-add": "content-save-plus",
	"content-save-add-outline": "content-save-plus-outline",
	"floppy-disc-settings": "content-save-settings",
	"floppy-disc-settings-outline": "content-save-settings-outline",
	"gamepad": "controller",
	"gamepad-classic": "controller-classic",
	"gamepad-classic-outline": "controller-classic-outline",
	"gamepad-off": "controller-off",
	"biscuit": "cookie",
	"biscuit-alert": "cookie-alert",
	"biscuit-alert-outline": "cookie-alert-outline",
	"biscuit-check": "cookie-check",
	"biscuit-check-outline": "cookie-check-outline",
	"biscuit-clock": "cookie-clock",
	"biscuit-clock-outline": "cookie-clock-outline",
	"biscuit-cog": "cookie-cog",
	"biscuit-cog-outline": "cookie-cog-outline",
	"biscuit-edit": "cookie-edit",
	"biscuit-edit-outline": "cookie-edit-outline",
	"biscuit-lock": "cookie-lock",
	"biscuit-lock-outline": "cookie-lock-outline",
	"biscuit-minus": "cookie-minus",
	"biscuit-minus-outline": "cookie-minus-outline",
	"biscuit-off": "cookie-off",
	"biscuit-off-outline": "cookie-off-outline",
	"biscuit-outline": "cookie-outline",
	"biscuit-plus": "cookie-plus",
	"biscuit-plus-outline": "cookie-plus-outline",
	"biscuit-refresh": "cookie-refresh",
	"biscuit-refresh-outline": "cookie-refresh-outline",
	"biscuit-remove": "cookie-remove",
	"biscuit-remove-outline": "cookie-remove-outline",
	"biscuit-settings": "cookie-settings",
	"cookie-crumbs": "cookie-settings",
	"biscuit-crumbs": "cookie-settings",
	"biscuit-settings-outline": "cookie-settings-outline",
	"cookie-crumbs-outline": "cookie-settings-outline",
	"biscuit-crumbs-outline": "cookie-settings-outline",
	"frequency": "sine-wave",
	"amplitude": "sine-wave",
	"score": "counter",
	"numbers": "numeric",
	"odometer": "counter",
	"kitchen-counter": "countertop",
	"sink": "faucet-variant",
	"kitchen-counter-outline": "countertop-outline",
	"sink-outline": "countertop-outline",
	"emoji-cow": "cow",
	"emoticon-cow": "cow",
	"dairy-off": "cow-off",
	"dairy-free": "cow-off",
	"chip-32-bit": "cpu-32-bit",
	"chip-64-bit": "cpu-64-bit",
	"crib": "cradle-outline",
	"bassinet": "cradle-outline",
	"baby": "cradle-outline",
	"nursery": "cradle",
	"baby-room": "cradle",
	"nursery-outline": "cradle-outline",
	"baby-room-outline": "cradle-outline",
	"auto-awesome": "creation",
	"sparkles": "shimmer",
	"stars": "star-circle",
	"shimmer": "creation",
	"auto-awesome-outline": "creation-outline",
	"sparkles-outline": "creation-outline",
	"stars-outline": "creation-outline",
	"shimmer-outline": "creation-outline",
	"credit-card-icc-chip": "credit-card-chip",
	"credit-card-icc-chip-outline": "credit-card-chip-outline",
	"credit-card-swipe": "credit-card-fast",
	"credit-card-swipe-outline": "credit-card-fast-outline",
	"credit-card-location": "credit-card-marker",
	"payment-on-delivery": "credit-card-marker",
	"payment-on-delivery-outline": "credit-card-marker-outline",
	"credit-card-location-outline": "credit-card-marker-outline",
	"credit-cards": "credit-card-multiple-outline",
	"payment": "credit-card-outline",
	"credit-card-add": "credit-card-plus-outline",
	"payment-settings": "credit-card-settings-outline",
	"credit-card-contactless": "credit-card-wireless-outline",
	"cricket-bat": "cricket",
	"crop-5-4": "crop-landscape",
	"christianity": "cross",
	"religion-christian": "cross",
	"religion-christian-outline": "cross-outline",
	"christianity-outline": "cross-outline",
	"gps-not-fixed": "crosshairs",
	"location-searching": "crosshairs",
	"gps-fixed": "crosshairs-gps",
	"my-location": "crosshairs-gps",
	"crosshairs-unknown": "crosshairs-question",
	"gps-unknown": "crosshairs-question",
	"family": "human-male-male-child",
	"crowd-source": "crowd",
	"crowdsource": "crowd",
	"checkers": "crown-circle",
	"checkers-outline": "crown-circle-outline",
	"sugar-off": "cube-off-outline",
	"sugar-cube-off": "cube-off-outline",
	"sugar-free": "cube-off-outline",
	"sugar": "cube-outline",
	"sugar-cube": "cube-outline",
	"view-in-ar": "cube-scan",
	"view-in-augmented-reality": "cube-scan",
	"glass": "cup",
	"glass-off": "cup-off",
	"glass-off-outline": "cup-off-outline",
	"glass-outline": "cup-outline",
	"cup-empty": "cup-outline",
	"local-drink": "cup-water",
	"glass-water": "cup-water",
	"drink-water": "cup-water",
	"cup-liquid": "cup-water",
	"glass-liquid": "cup-water",
	"taka": "currency-bdt",
	"bangladeshi-taka": "currency-bdt",
	"brazilian-real": "currency-brl",
	"bitcoin": "currency-btc",
	"yuan": "currency-cny",
	"renminbi": "currency-cny",
	"ethereum": "currency-eth",
	"xi": "currency-eth",
	"euro": "currency-eur",
	"euro-symbol": "currency-eur",
	"pound": "currency-gbp",
	"sterling": "currency-gbp",
	"rupee": "currency-inr",
	"yen": "currency-jpy",
	"won": "currency-krw",
	"kazakhstani-tenge": "currency-kzt",
	"currency-mongolian-tugrug": "currency-mnt",
	"naira": "currency-ngn",
	"philippine-peso": "currency-php",
	"currency-riyal": "currency-rial",
	"currency-irr": "currency-rial",
	"currency-omr": "currency-rial",
	"currency-yer": "currency-rial",
	"currency-sar": "currency-rial",
	"ruble": "currency-rub",
	"currency-npr": "currency-rupee",
	"currency-pkr": "currency-rupee",
	"currency-lkr": "currency-rupee",
	"currency-inr": "currency-rupee",
	"currency-scarab": "currency-sign",
	"currency-thai-baht": "currency-thb",
	"lira": "currency-try",
	"new-taiwan-dollar": "currency-twd",
	"currency-hryvnia": "currency-uah",
	"currency-ukraine": "currency-uah",
	"attach-money": "currency-usd",
	"dollar": "currency-usd",
	"money-off": "currency-usd-off",
	"dollar-off": "currency-usd-off",
	"alternating-current": "sine-wave",
	"direct-current": "current-dc",
	"cursor-hand": "cursor-pointer",
	"drapes": "curtains",
	"drapes-closed": "curtains-closed",
	"human-dance-ballroom": "dance-ballroom",
	"kho-kho": "dance-pole",
	"human-dance-pole": "dance-pole",
	"storage": "server",
	"database-tick": "database-check",
	"database-view": "database-eye",
	"database-view-off": "database-eye-off",
	"database-view-off-outline": "database-eye-off-outline",
	"database-view-outline": "database-eye-outline",
	"database-location": "database-marker",
	"database-location-outline": "database-marker-outline",
	"database-add": "database-plus",
	"sql-query": "database-search",
	"harry-potter": "deathly-hallows",
	"jump": "debug-step-over",
	"starburst": "octagram",
	"starburst-outline": "octagram-outline",
	"trash": "delete",
	"bin": "delete",
	"rubbish": "delete",
	"garbage": "delete",
	"rubbish-bin": "trash-can",
	"trash-can": "delete",
	"garbage-can": "trash-can",
	"trash-circle": "delete-circle",
	"bin-circle": "delete-circle",
	"garbage-can-circle": "delete-circle",
	"garbage-circle": "delete-circle",
	"rubbish-bin-circle": "delete-circle",
	"rubbish-circle": "delete-circle",
	"trash-can-circle": "delete-circle",
	"bin-circle-outline": "delete-circle-outline",
	"garbage-can-circle-outline": "delete-circle-outline",
	"garbage-circle-outline": "delete-circle-outline",
	"rubbish-bin-circle-outline": "delete-circle-outline",
	"rubbish-circle-outline": "delete-circle-outline",
	"trash-can-circle-outline": "delete-circle-outline",
	"trash-circle-outline": "delete-circle-outline",
	"trash-empty": "delete-empty",
	"bin-empty": "delete-empty",
	"rubbish-empty": "delete-empty",
	"rubbish-bin-empty": "delete-empty",
	"trash-can-empty": "delete-empty",
	"garbage-empty": "delete-empty",
	"garbage-can-empty": "delete-empty",
	"garbage-outline": "delete-outline",
	"bin-outline": "delete-outline",
	"rubbish-outline": "delete-outline",
	"garbage-can-outline": "trash-can-outline",
	"rubbish-bin-outline": "trash-can-outline",
	"trash-outline": "delete-outline",
	"trash-can-outline": "delete-outline",
	"trash-restore": "delete-restore",
	"bin-restore": "delete-restore",
	"restore-from-trash": "delete-restore",
	"trash-variant": "delete-variant",
	"bin-variant": "delete-variant",
	"cup-ice": "delete-variant",
	"drink-ice": "delete-variant",
	"change-history": "delta",
	"computer-classic": "desktop-classic",
	"monitor": "devices",
	"watch": "devices",
	"smartwatch": "devices",
	"cellphone": "devices",
	"television": "devices",
	"dharma-wheel": "dharmachakra",
	"religion-buddhist": "dharmachakra",
	"buddhism": "dharmachakra",
	"hand-blood": "diabetes",
	"keypad": "dialpad",
	"circle-diameter": "diameter",
	"sphere-diameter": "diameter",
	"circle-diameter-outline": "diameter-outline",
	"sphere-diameter-outline": "diameter-outline",
	"circle-diameter-variant": "diameter-variant",
	"sphere-diameter-variant": "diameter-variant",
	"jewel": "diamond-stone",
	"nappy-outline": "diaper-outline",
	"die-1": "dice-1",
	"dice-one": "dice-1",
	"die-2": "dice-2",
	"dice-two": "dice-2",
	"die-3": "dice-3",
	"dice-three": "dice-3",
	"die-4": "dice-4",
	"dice-four": "dice-4",
	"die-5": "dice-5",
	"dice-five": "dice-5",
	"die-6": "dice-6",
	"dice-six": "dice-6",
	"die-d10": "dice-d10-outline",
	"die-d20": "dice-d20-outline",
	"die-d4": "dice-d4-outline",
	"die-d6": "dice-d6-outline",
	"die-d8": "dice-d8-outline",
	"die-multiple": "dice-multiple",
	"cd-rom": "disc",
	"dvd": "disc",
	"disc-full": "disc-alert",
	"disc-warning": "disc-alert",
	"swim-dive": "diving",
	"human-diving": "diving",
	"obelus": "division",
	"helix": "dna",
	"emoji-dog": "dog",
	"emoticon-dog": "dog",
	"guide-dog": "dog-service",
	"k9": "dog-side",
	"canine": "dog-side",
	"hand-truck": "dolly",
	"porpoise": "dolphin",
	"building": "domain",
	"company": "domain",
	"business": "handshake",
	"robber-mask": "domino-mask",
	"zorro-mask": "domino-mask",
	"door-forbidden": "door-closed-cancel",
	"door-do-not-enter": "door-closed-cancel",
	"door-unavailable": "door-closed-cancel",
	"patio-door": "door-sliding",
	"french-door": "door-sliding",
	"patio-door-lock": "door-sliding-lock",
	"french-door-lock": "door-sliding-lock",
	"patio-door-open": "door-sliding-open",
	"french-door-open": "door-sliding-open",
	"microsoft-dot-net": "dot-net",
	"perimeter": "dots-square",
	"more": "dots-horizontal",
	"ellipsis-horizontal": "dots-horizontal",
	"more-horiz": "dots-horizontal",
	"menu": "dots-vertical-circle-outline",
	"ellipsis-horizontal-circle": "dots-horizontal-circle",
	"more-circle": "dots-horizontal-circle",
	"ellipsis-horizontal-circle-outline": "dots-horizontal-circle-outline",
	"more-circle-outline": "dots-horizontal-circle-outline",
	"ellipsis-vertical": "dots-vertical",
	"more-vert": "dots-vertical",
	"ellipsis-vertical-circle": "dots-vertical-circle",
	"ellipsis-vertical-circle-outline": "dots-vertical-circle-outline",
	"file-download": "download",
	"get-app": "download",
	"downloads": "download-multiple",
	"comedy": "drama-masks",
	"tragedy": "drama-masks",
	"theatre": "theater",
	"sign": "draw-pen",
	"signature": "draw-pen",
	"weights": "dumbbell",
	"fitness-center": "weight-lifter",
	"gym": "weight-lifter",
	"barbell": "dumbbell",
	"tipper-lorry": "dump-truck",
	"audio-induction-loop": "ear-hearing-loop",
	"telecoil": "ear-hearing-loop",
	"hearing-impaired": "ear-hearing-off",
	"headphones": "earbuds",
	"headphones-off": "earbuds-off",
	"headphones-off-outline": "earbuds-off-outline",
	"headphones-outline": "earbuds-outline",
	"globe": "web",
	"public": "earth",
	"planet": "earth",
	"world": "earth",
	"globe-arrow-down": "earth-arrow-down",
	"world-arrow-down": "earth-arrow-down",
	"planet-arrow-down": "earth-arrow-down",
	"globe-arrow-left": "earth-arrow-left",
	"world-arrow-left": "earth-arrow-left",
	"planet-arrow-left": "earth-arrow-left",
	"globe-arrow-right": "earth-arrow-right",
	"world-arrow-right": "earth-arrow-right",
	"planet-arrow-right": "earth-arrow-right",
	"globe-arrow-up": "earth-arrow-up",
	"planet-arrow-up": "earth-arrow-up",
	"world-arrow-up": "earth-arrow-up",
	"globe-box": "web-box",
	"world-box": "earth-box",
	"planet-box": "earth-box",
	"globe-box-minus": "earth-box-minus",
	"world-box-minus": "earth-box-minus",
	"planet-box-minus": "earth-box-minus",
	"globe-box-off": "earth-box-off",
	"world-box-off": "earth-box-off",
	"planet-box-off": "earth-box-off",
	"globe-box-plus": "earth-box-plus",
	"world-box-plus": "earth-box-plus",
	"planet-box-plus": "earth-box-plus",
	"globe-box-remove": "earth-box-remove",
	"world-box-remove": "earth-box-remove",
	"planet-box-remove": "earth-box-remove",
	"globe-minus": "earth-minus",
	"world-minus": "earth-minus",
	"planet-minus": "earth-minus",
	"globe-off": "earth-off",
	"world-off": "earth-off",
	"planet-off": "earth-off",
	"globe-plus": "earth-plus",
	"world-plus": "earth-plus",
	"planet-plus": "earth-plus",
	"globe-remove": "earth-remove",
	"world-remove": "earth-remove",
	"planet-remove": "earth-remove",
	"paris": "eiffel-tower",
	"france": "eiffel-tower",
	"8-track": "eight-track",
	"local-post-office": "email",
	"mail": "email",
	"markunread": "email",
	"envelope": "email",
	"email-warning": "email-alert",
	"envelope-alert": "email-alert",
	"envelope-warning": "email-alert",
	"email-receive": "email-arrow-left",
	"email-receive-outline": "email-arrow-left-outline",
	"email-send": "email-fast",
	"email-arrow-right-outline": "email-arrow-right-outline",
	"envelope-box": "email-box",
	"email-tick": "email-check",
	"email-tick-outline": "email-check-outline",
	"envelope-fast": "email-fast",
	"email-quick": "email-fast",
	"email-sent": "email-fast",
	"email-send-outline": "email-fast-outline",
	"email-sent-outline": "email-fast-outline",
	"envelope-fast-outline": "email-fast-outline",
	"email-quick-outline": "email-fast-outline",
	"love-letter": "email-heart-outline",
	"envelope-heart-outline": "email-heart-outline",
	"greeting-card": "email-heart-outline",
	"envelope-secure": "email-lock",
	"email-secure": "email-lock",
	"envelope-lock": "email-lock",
	"email-secure-outline": "email-lock-outline",
	"drafts": "email-open",
	"envelope-open": "email-open",
	"love-letter-open": "email-open-heart-outline",
	"greeting-card-open": "email-open-heart-outline",
	"envelope-open-heart-outline": "email-open-heart-outline",
	"envelope-open-outline": "email-open-outline",
	"mail-outline": "email-outline",
	"envelope-outline": "email-outline",
	"email-add": "email-plus",
	"envelope-add": "email-plus",
	"envelope-plus": "email-plus",
	"email-add-outline": "email-plus-outline",
	"envelope-add-outline": "email-plus-outline",
	"envelope-plus-outline": "email-plus-outline",
	"email-certified": "email-seal",
	"mail-certified": "email-seal",
	"mail-seal": "email-seal",
	"email-verified": "email-seal",
	"mail-verified": "email-seal",
	"email-verified-outline": "email-seal-outline",
	"email-certified-outline": "email-seal-outline",
	"mail-verified-outline": "email-seal-outline",
	"mail-certified-outline": "email-seal-outline",
	"mail-seal-outline": "email-seal-outline",
	"email-refresh": "email-sync",
	"email-resend": "email-sync",
	"email-refresh-outline": "email-sync-outline",
	"email-resend-outline": "email-sync-outline",
	"envelope-variant": "email-variant",
	"smiley": "emoticon",
	"face": "emoticon",
	"emoji": "emoticon",
	"smiley-angry": "emoticon-angry",
	"face-angry": "emoticon-angry",
	"emoji-angry": "emoticon-angry",
	"smiley-angry-outline": "emoticon-angry-outline",
	"face-angry-outline": "emoticon-angry-outline",
	"emoji-angry-outline": "emoticon-angry-outline",
	"face-confused": "emoticon-confused",
	"emoji-confused": "emoticon-confused",
	"face-confused-outline": "emoticon-confused-outline",
	"emoji-confused-outline": "emoticon-confused-outline",
	"smiley-cool": "emoticon-cool",
	"face-cool": "emoticon-cool",
	"face-sunglasses": "emoticon-cool",
	"emoji-cool": "emoticon-cool",
	"smiley-cool-outline": "emoticon-cool-outline",
	"face-cool-outline": "emoticon-cool-outline",
	"face-sunglasses-outline": "emoticon-cool-outline",
	"emoji-cool-outline": "emoticon-cool-outline",
	"smiley-cry": "emoticon-cry",
	"face-cry": "emoticon-cry",
	"emoji-cry": "emoticon-cry",
	"smiley-cry-outline": "emoticon-cry-outline",
	"face-cry-outline": "emoticon-cry-outline",
	"emoji-cry-outline": "emoticon-cry-outline",
	"smiley-dead": "emoticon-dead",
	"face-dead": "emoticon-dead",
	"emoji-dead": "emoticon-dead",
	"smiley-dead-outline": "emoticon-dead-outline",
	"face-dead-outline": "emoticon-dead-outline",
	"emoji-dead-outline": "emoticon-dead-outline",
	"smiley-devil": "emoticon-devil",
	"face-devil": "emoticon-devil",
	"emoji-devil": "emoticon-devil",
	"smiley-devil-outline": "emoticon-devil-outline",
	"face-devil-outline": "emoticon-devil-outline",
	"emoji-devil-outline": "emoticon-devil-outline",
	"smiley-excited": "emoticon-excited",
	"face-excited": "emoticon-excited",
	"emoji-excited": "emoticon-excited",
	"smiley-excited-outline": "emoticon-excited-outline",
	"face-excited-outline": "emoticon-excited-outline",
	"emoji-excited-outline": "emoticon-excited-outline",
	"face-frown": "emoticon-frown",
	"emoji-frown": "emoticon-frown",
	"face-frown-outline": "emoticon-frown-outline",
	"emoji-frown-outline": "emoticon-frown-outline",
	"smiley-happy": "emoticon-happy",
	"face-happy": "emoticon-happy",
	"emoji-happy": "emoticon-happy",
	"smiley-happy-outline": "emoticon-happy-outline",
	"face-happy-outline": "emoticon-happy-outline",
	"emoji-happy-outline": "emoticon-happy-outline",
	"smiley-kiss": "emoticon-kiss",
	"face-kiss": "emoticon-kiss",
	"emoji-kiss": "emoticon-kiss",
	"smiley-kiss-outline": "emoticon-kiss-outline",
	"face-kiss-outline": "emoticon-kiss-outline",
	"emoji-kiss-outline": "emoticon-kiss-outline",
	"face-lol": "emoticon-lol",
	"emoji-lol": "emoticon-lol",
	"face-lol-outline": "emoticon-lol-outline",
	"emoji-lol-outline": "emoticon-lol-outline",
	"smiley-neutral": "emoticon-neutral",
	"face-neutral": "emoticon-neutral",
	"emoji-neutral": "emoticon-neutral",
	"smiley-neutral-outline": "emoticon-neutral-outline",
	"face-neutral-outline": "emoticon-neutral-outline",
	"emoji-neutral-outline": "emoticon-neutral-outline",
	"insert-emoticon": "emoticon-outline",
	"mood": "emoticon-outline",
	"sentiment-very-satisfied": "emoticon-outline",
	"tag-faces": "emoticon-outline",
	"smiley-outline": "emoticon-outline",
	"face-outline": "emoticon-outline",
	"emoji-outline": "emoticon-outline",
	"smiley-poop": "emoticon-poop",
	"face-poop": "emoticon-poop",
	"emoji-poop": "emoticon-poop",
	"face-poop-outline": "emoticon-poop-outline",
	"emoji-poop-outline": "emoticon-poop-outline",
	"smiley-sad": "emoticon-sad",
	"face-sad": "emoticon-sad",
	"emoji-sad": "emoticon-sad",
	"smiley-sad-outline": "emoticon-sad-outline",
	"face-sad-outline": "emoticon-sad-outline",
	"emoji-sad-outline": "emoticon-sad-outline",
	"face-sick": "emoticon-sick",
	"fever": "emoticon-sick",
	"emoji-sick": "emoticon-sick",
	"face-sick-outline": "emoticon-sick-outline",
	"fever-outline": "emoticon-sick-outline",
	"emoji-sick-outline": "emoticon-sick-outline",
	"smiley-tongue": "emoticon-tongue",
	"face-tongue": "emoticon-tongue",
	"emoji-tongue": "emoticon-tongue",
	"smiley-tongue-outline": "emoticon-tongue-outline",
	"face-tongue-outline": "emoticon-tongue-outline",
	"emoji-tongue-outline": "emoticon-tongue-outline",
	"smiley-wink": "emoticon-wink",
	"face-wink": "emoticon-wink",
	"emoji-wink": "emoticon-wink",
	"smiley-wink-outline": "emoticon-wink-outline",
	"face-wink-outline": "emoticon-wink-outline",
	"emoji-wink-outline": "emoticon-wink-outline",
	"motor": "engine",
	"motor-off": "engine-off",
	"motor-off-outline": "engine-off-outline",
	"motor-outline": "engine-outline",
	"ev-plug-ccs-combo-1": "ev-plug-ccs1",
	"ev-charger-ccs1": "ev-plug-ccs1",
	"ev-plug-ccs-combo-2": "ev-plug-ccs2",
	"ev-charger-ccs2": "ev-plug-ccs2",
	"ev-charger-chademo": "ev-plug-chademo",
	"ev-charger-tesla": "ev-plug-tesla",
	"ev-plug-j1772": "ev-plug-type1",
	"ev-charger-type1": "ev-plug-type1",
	"ev-plug-mennekes": "ev-plug-type2",
	"ev-charger-type2": "ev-plug-type2",
	"charging-station": "ev-station",
	"ev-charger": "ev-station",
	"wall-charger": "ev-station",
	"wallbox": "ev-station",
	"electric-vehicle-charger": "ev-station",
	"evse": "ev-station",
	"electric-charger": "ev-station",
	"factorial": "exclamation",
	"exclamation-bold": "exclamation-thick",
	"emergency-exit": "exit-run",
	"animation-plus": "expand-all",
	"animation-plus-outline": "expand-all-outline",
	"gpu": "expansion-card-variant",
	"graphics-processing-unit": "expansion-card-variant",
	"nic": "expansion-card",
	"network-interface-card": "expansion-card-variant",
	"nice": "expansion-card-variant",
	"power": "transmission-tower",
	"power-box": "exponent-box",
	"output": "export",
	"ios-share": "export-variant",
	"show": "eye",
	"visibility": "eye",
	"remove-red-eye": "eye",
	"view-arrow-left": "eye-arrow-left",
	"view-arrow-left-outline": "eye-arrow-left-outline",
	"view-arrow-right": "eye-arrow-right",
	"view-arrow-right-outline": "eye-arrow-right-outline",
	"eye-tick": "eye-check",
	"eye-tick-outline": "eye-check-outline",
	"eye-shut": "eye-closed",
	"visibility-hidden": "eye-closed",
	"hide": "eye-off",
	"visibility-off": "eye-off",
	"hide-outline": "eye-off-outline",
	"visibility-off-outline": "eye-off-outline",
	"show-outline": "eye-outline",
	"visibility-outline": "eye-outline",
	"eye-add": "eye-plus",
	"eye-add-outline": "eye-plus-outline",
	"view-refresh": "eye-refresh",
	"view-refresh-outline": "eye-refresh-outline",
	"pipette": "eyedropper",
	"colorize": "eyedropper-variant",
	"colourise": "eyedropper-variant",
	"pipette-variant": "eyedropper-variant",
	"customer-service": "face-agent",
	"support": "lifebuoy",
	"emoji-agent": "face-agent",
	"emoticon-agent": "face-agent",
	"face-male": "face-man",
	"emoji-man": "face-man",
	"emoticon-man": "face-man",
	"face-male-outline": "face-man-outline",
	"emoji-man-outline": "face-man-outline",
	"emoticon-man-outline": "face-man-outline",
	"face-male-profile": "face-man-profile",
	"emoji-man-profile": "face-man-profile",
	"emoticon-man-profile": "face-man-profile",
	"face-retouching-natural": "face-man-shimmer",
	"face-male-shimmer": "face-man-shimmer",
	"emoji-man-shimmer": "face-man-shimmer",
	"emoticon-man-shimmer": "face-man-shimmer",
	"face-retouching-natural-outline": "face-man-shimmer-outline",
	"face-male-shimmer-outline": "face-man-shimmer-outline",
	"emoji-man-shimmer-outline": "face-man-shimmer-outline",
	"emoticon-man-shimmer-outline": "face-man-shimmer-outline",
	"facial-recognition": "face-recognition",
	"scan": "face-recognition",
	"face-female": "face-woman",
	"emoji-woman": "face-woman",
	"emoticon-woman": "face-woman",
	"face-female-outline": "face-woman-outline",
	"emoji-woman-outline": "face-woman-outline",
	"emoticon-woman-outline": "face-woman-outline",
	"face-female-profile": "face-woman-profile",
	"emoji-woman-profile": "face-woman-profile",
	"emoticon-woman-profile": "face-woman-profile",
	"face-retouching-natural-woman": "face-woman-shimmer",
	"face-female-shimmer": "face-woman-shimmer",
	"emoji-woman-shimmer": "face-woman-shimmer",
	"emoticon-woman-shimmer": "face-woman-shimmer",
	"face-retouching-natural-woman-outline": "face-woman-shimmer-outline",
	"face-female-shimmer-outline": "face-woman-shimmer-outline",
	"emoji-woman-shimmer-outline": "face-woman-shimmer-outline",
	"emoticon-woman-shimmer-outline": "face-woman-shimmer-outline",
	"industrial": "factory",
	"fan-speed-down": "fan-chevron-down",
	"fan-speed-up": "fan-chevron-up",
	"fan-clock": "fan-clock",
	"fan-schedule": "fan-clock",
	"fan-timer": "fan-clock",
	"fan-speed-low": "fan-speed-1",
	"fan-speed-medium": "fan-speed-2",
	"fan-speed-high": "fan-speed-3",
	"kitchen-tap": "water-pump",
	"bathroom-tap": "faucet-variant",
	"quill": "feather",
	"railway": "fence",
	"train-track": "fence",
	"railway-electric": "fence-electric",
	"train-track-electric": "fence-electric",
	"sword-fight": "fencing",
	"cargo-ship": "ferry",
	"boat": "sail-boat",
	"ship": "ferry",
	"directions-boat": "ferry",
	"directions-ferry": "ferry",
	"insert-drive-file": "file",
	"draft": "file",
	"paper": "note",
	"file-user": "file-account",
	"resume": "file-account",
	"file-warning": "file-alert",
	"file-warning-outline": "file-alert-outline",
	"file-exchange": "file-arrow-up-down",
	"file-transfer": "file-swap",
	"file-swap": "file-arrow-up-down",
	"file-exchange-outline": "file-arrow-up-down-outline",
	"file-swap-outline": "file-arrow-up-down-outline",
	"file-transfer-outline": "file-swap-outline",
	"file-upload-download": "file-arrow-up-down",
	"file-upload-download-outline": "file-arrow-up-down-outline",
	"filing-cabinet": "file-cabinet",
	"file-report": "file-chart",
	"file-graph": "file-chart",
	"file-graph-outline": "file-chart-outline",
	"file-report-outline": "file-chart-outline",
	"file-tick": "file-check",
	"file-settings-cog": "file-cog",
	"file-settings-cog-outline": "file-cog-outline",
	"file-csv": "file-delimited",
	"file-csv-outline": "file-delimited-outline",
	"file-text": "file-document",
	"file-document-error": "file-document-alert",
	"file-text-alert": "file-document-alert",
	"file-text-error": "file-document-alert",
	"file-document-error-outline": "file-document-alert-outline",
	"file-text-error-outline": "file-document-alert-outline",
	"file-text-alert-outline": "file-document-alert-outline",
	"file-document-move": "file-document-arrow-right",
	"file-text-move": "file-document-arrow-right",
	"file-text-arrow-right": "file-document-arrow-right",
	"file-document-move-outline": "file-document-arrow-right-outline",
	"file-text-move-outline": "file-document-arrow-right-outline",
	"file-text-arrow-right-outline": "file-document-arrow-right-outline",
	"file-document-tick": "file-document-check",
	"file-text-tick": "file-document-check",
	"file-text-check": "file-document-check",
	"file-document-tick-outline": "file-document-check-outline",
	"file-text-tick-outline": "file-document-check-outline",
	"file-text-check-outline": "file-document-check-outline",
	"contract": "file-document-edit",
	"file-text-edit": "file-document-edit",
	"contract-outline": "file-document-edit-outline",
	"file-text-edit-outline": "file-document-edit-outline",
	"file-text-minus": "file-document-minus",
	"file-text-minus-outline": "file-document-minus-outline",
	"file-text-multiple": "file-document-multiple",
	"file-text-multiple-outline": "file-document-multiple-outline",
	"file-text-outline": "file-document-outline",
	"file-document-add": "file-document-plus",
	"file-text-add": "file-document-plus",
	"file-text-plus": "file-document-plus",
	"file-document-add-outline": "file-document-plus-outline",
	"file-text-plus-outline": "file-document-plus-outline",
	"file-text-add-outline": "file-document-plus-outline",
	"file-document-delete": "file-document-remove",
	"file-text-remove": "file-document-remove",
	"file-text-delete": "file-document-remove",
	"file-document-delete-outline": "file-document-remove-outline",
	"file-text-remove-outline": "file-document-remove-outline",
	"file-text-delete-outline": "file-document-remove-outline",
	"print-preview": "file-find",
	"find-in-page": "file-find",
	"file-image-location": "file-image-marker",
	"file-image-location-outline": "file-image-marker-outline",
	"file-image-add": "file-image-plus",
	"file-image-add-outline": "file-image-plus-outline",
	"file-jpeg-box": "file-jpg-box",
	"image-jpg-box": "file-jpg-box",
	"image-jpeg-box": "file-jpg-box",
	"file-location": "file-marker",
	"file-location-outline": "file-marker-outline",
	"files": "file-multiple",
	"paper-outline": "note-outline",
	"file-acrobat-box": "file-pdf-box",
	"adobe-acrobat": "file-pdf-box",
	"note-add": "note-plus",
	"restore-page": "file-restore",
	"file-rotate-counter-clockwise": "file-rotate-left",
	"file-rotate-ccw": "file-rotate-left",
	"file-rotate-counter-clockwise-outline": "file-rotate-left-outline",
	"file-rotate-ccw-outline": "file-rotate-left-outline",
	"file-rotate-clockwise": "file-rotate-right-outline",
	"file-move": "file-send",
	"contract-sign": "file-sign",
	"document-sign": "file-sign",
	"file-favorite": "file-star",
	"file-auto": "file-star-four-points",
	"file-auto-outline": "file-star-four-points-outline",
	"file-favorite-outline": "file-star-outline",
	"subtasks": "file-tree",
	"file-revert": "file-undo",
	"file-discard": "file-undo",
	"camera-roll": "film",
	"local-movies": "filmstrip",
	"theaters": "filmstrip",
	"library-movie": "filmstrip-box-multiple",
	"funnel": "filter",
	"funnel-check": "filter-check",
	"funnel-check-outline": "filter-check-outline",
	"funnel-settings": "filter-settings",
	"filter-settings": "filter-cog",
	"funnel-cog": "filter-cog",
	"filter-gear": "filter-cog",
	"funnel-gear": "filter-cog",
	"filter-settings-outline": "filter-cog-outline",
	"filter-gear-outline": "filter-cog-outline",
	"funnel-cog-outline": "filter-cog-outline",
	"funnel-settings-outline": "filter-settings-outline",
	"funnel-gear-outline": "filter-cog-outline",
	"funnel-minus": "filter-minus",
	"funnel-minus-outline": "filter-minus-outline",
	"funnel-multiple": "filter-multiple",
	"funnel-multiple-outline": "filter-multiple-outline",
	"funnel-outline": "filter-outline",
	"funnel-plus": "filter-plus",
	"funnel-plus-outline": "filter-plus-outline",
	"funnel-remove": "filter-remove",
	"funnel-remove-outline": "filter-remove-outline",
	"filter-list": "filter-variant",
	"chart-finance": "finance",
	"report-finance": "finance",
	"whatshot": "fire",
	"flame": "fire",
	"gas": "fire",
	"natural-gas": "meter-gas",
	"hot": "fire",
	"flame-alert": "fire-alert",
	"flame-circle": "fire-circle",
	"hot-circle": "fire-circle",
	"gas-circle": "fire-circle",
	"natural-gas-circle": "fire-circle",
	"flame-off": "fire-off",
	"fire-engine": "fire-truck",
	"mozilla-firefox": "firefox",
	"bottle-rocket": "firework",
	"aquarium": "fishbowl",
	"aquarium-outline": "fishbowl-outline",
	"assistant-photo": "flag",
	"goal": "flag-checkered",
	"flag-add": "flag-plus",
	"milestone": "sign-direction",
	"star": "hexagram",
	"lightning-bolt": "flash",
	"flash-on": "flash",
	"electricity": "transmission-tower",
	"lightning-alert": "flash-alert",
	"storm-advisory": "flash-alert",
	"lightning-alert-outline": "flash-alert-outline",
	"storm-advisory-outline": "flash-alert-outline",
	"lightning-bolt-outline": "flash-outline",
	"high-voltage": "flash-triangle",
	"high-voltage-outline": "flash-triangle-outline",
	"torch": "flashlight",
	"torch-off": "flashlight-off",
	"floor-light": "floor-lamp",
	"floor-light-dual": "floor-lamp-dual",
	"floor-light-dual-outline": "floor-lamp-dual-outline",
	"floor-light-outline": "floor-lamp-outline",
	"floor-light-torchiere": "floor-lamp-torchiere",
	"floor-light-torchiere-variant": "floor-lamp-torchiere-variant",
	"floor-light-torchiere-variant-outline": "floor-lamp-torchiere-variant-outline",
	"local-florist": "flower",
	"plant": "tree-outline",
	"local-florist-outline": "flower-outline",
	"allergy": "flower-pollen",
	"allergy-outline": "flower-pollen-outline",
	"folder-user": "folder-account",
	"folder-shared": "folder-account",
	"folder-user-outline": "folder-account-outline",
	"folder-shared-outline": "folder-account-outline",
	"folder-warning": "folder-alert",
	"folder-warning-outline": "folder-alert-outline",
	"folder-download": "folder-arrow-down",
	"folder-download-outline": "folder-arrow-down-outline",
	"folder-upload": "folder-arrow-up",
	"folder-transfer": "folder-swap",
	"folder-transfer-outline": "folder-swap-outline",
	"folder-upload-outline": "folder-arrow-up-outline",
	"folder-cog": "folder-cog",
	"folder-cog-outline": "folder-cog-outline",
	"folder-mydrive": "folder-google-drive",
	"folder-house": "folder-home",
	"folder-house-outline": "folder-home-outline",
	"folder-location": "folder-marker",
	"folder-location-outline": "folder-marker-outline",
	"folders": "folder-multiple",
	"perm-media": "folder-multiple-image",
	"folders-image": "folder-multiple-image",
	"folders-outline": "folder-multiple-outline",
	"folder-open": "folder-outline",
	"folder-media": "folder-play",
	"folder-music": "folder-play",
	"folder-video": "folder-play",
	"folder-media-outline": "folder-play-outline",
	"folder-music-outline": "folder-play-outline",
	"folder-video-outline": "folder-play-outline",
	"create-new-folder": "folder-plus",
	"folder-add": "folder-plus",
	"create-new-folder-outline": "folder-plus-outline",
	"folder-add-outline": "folder-plus-outline",
	"folder-hash": "folder-pound",
	"folder-hash-outline": "folder-pound-outline",
	"folder-help": "folder-question",
	"folder-help-outline": "folder-question-outline",
	"folder-special": "folder-star",
	"folder-favorite": "folder-star",
	"folder-favorite-multiple": "folder-star-multiple",
	"folder-favorite-multiple-outline": "folder-star-multiple-outline",
	"folder-special-outline": "folder-star-outline",
	"folder-favorite-outline": "folder-star-outline",
	"folder-settings": "folder-wrench",
	"folder-settings-outline": "folder-wrench-outline",
	"compressed-folder": "folder-zip",
	"compressed-folder-outline": "folder-zip-outline",
	"fast-food": "hamburger",
	"burger": "hamburger",
	"hamburger": "food",
	"chicken-leg": "food-drumstick",
	"turkey-leg": "food-drumstick",
	"meat": "food-steak",
	"chicken-leg-off": "food-drumstick-off",
	"turkey-leg-off": "food-drumstick-off",
	"meat-off": "food-steak-off",
	"chicken-leg-off-outline": "food-drumstick-off-outline",
	"turkey-leg-off-outline": "food-drumstick-off-outline",
	"meat-off-outline": "food-drumstick-off-outline",
	"chicken-leg-outline": "food-drumstick-outline",
	"turkey-leg-outline": "food-drumstick-outline",
	"meat-outline": "food-drumstick-outline",
	"food-fork-cup": "food-fork-drink",
	"food-muslim": "food-halal",
	"dietary-restriction": "food-kosher",
	"food-weiner": "food-hot-dog",
	"food-frankfurter": "food-hot-dog",
	"food-jewish": "food-kosher",
	"fast-food-off": "hamburger-off",
	"burger-off": "hamburger-off",
	"hamburger-off": "food-off",
	"beef": "food-steak",
	"beef-off": "food-steak-off",
	"dinner": "food-turkey",
	"thanksgiving": "turkey",
	"football-american": "football",
	"forestry": "forest",
	"pine-tree-multiple": "forest",
	"forestry-outline": "forest-outline",
	"pine-tree-multiple-outline": "forest-outline",
	"rename": "form-textbox",
	"format-align-centre": "format-align-center",
	"format-annotation-add": "format-annotation-plus",
	"format-colour-fill": "format-color-fill",
	"paint": "spray",
	"paint-bucket": "format-color-fill",
	"ink-color": "format-color-fill",
	"ink-colour": "format-color-fill",
	"format-colour-highlight": "format-color-highlight",
	"format-color-redact": "format-color-marker-cancel",
	"format-colour-text": "format-color-text",
	"format-float-centre": "format-float-center",
	"format-heading-1": "format-header-1",
	"format-heading-2": "format-header-2",
	"format-heading-3": "format-header-3",
	"format-heading-4": "format-header-4",
	"format-heading-5": "format-header-5",
	"format-heading-6": "format-header-6",
	"format-heading-decease": "format-header-decrease",
	"format-heading-equal": "format-header-equal",
	"format-heading-increase": "format-header-increase",
	"format-header-hash": "format-header-pound",
	"format-heading-pound": "format-header-pound",
	"format-heading-hash": "format-header-pound",
	"format-heading-markdown": "format-header-pound",
	"format-horizontal-align-centre": "format-horizontal-align-center",
	"arrow-horizontal-collapse": "format-horizontal-align-center",
	"format-lowercase": "format-letter-case-lower",
	"format-uppercase": "format-letter-case-upper",
	"format-kerning": "format-letter-spacing",
	"to-do": "format-list-checks",
	"format-list-group-add": "format-list-group-plus",
	"format-list-numbers": "format-list-numbered",
	"format-list-numbered-right-to-left": "format-list-numbered-rtl",
	"format-textdirection-r-to-l": "format-pilcrow-arrow-left",
	"format-textdirection-l-to-r": "format-pilcrow-arrow-right",
	"rotate-90-degrees-ccw": "format-rotate-90",
	"format-rotate-ninety": "format-rotate-90",
	"font-size": "format-size",
	"strikethrough-s": "format-strikethrough-variant",
	"exponent": "format-superscript",
	"format-underlined": "format-underline",
	"format-vertical-align-centre": "format-vertical-align-center",
	"arrow-vertical-collapse": "format-vertical-align-center",
	"message-group": "forum",
	"question-answer": "forum",
	"chat": "message-text",
	"dialogue": "forum",
	"conversation": "forum",
	"discussion": "forum",
	"discussion-minus": "forum-minus",
	"conversation-minus": "forum-minus",
	"dialogue-minus": "forum-minus",
	"chat-minus": "forum-minus",
	"forum-subtract": "forum-minus",
	"chat-subtract": "forum-minus",
	"dialogue-minus-outline": "forum-minus-outline",
	"chat-minus-outline": "forum-minus-outline",
	"forum-subtract-outline": "forum-minus-outline",
	"chat-subtract-outline": "forum-minus-outline",
	"conversation-minus-outline": "forum-minus-outline",
	"discussion-minus-outline": "forum-minus-outline",
	"chat-outline": "forum-outline",
	"dialogue-outline": "forum-outline",
	"discussion-outline": "forum-outline",
	"conversation-outline": "forum-outline",
	"chat-plus": "forum-plus",
	"forum-add": "forum-plus",
	"chat-add": "forum-plus",
	"dialogue-plus": "forum-plus",
	"conversation-plus": "forum-plus",
	"discussion-plus": "forum-plus",
	"chat-plus-outline": "forum-plus-outline",
	"chat-add-outline": "forum-plus-outline",
	"forum-add-outline": "forum-plus-outline",
	"dialogue-plus-outline": "forum-plus-outline",
	"conversation-plus-outline": "forum-plus-outline",
	"discussion-plus-outline": "forum-plus-outline",
	"forum-delete": "forum-remove",
	"chat-remove": "forum-remove",
	"chat-delete": "forum-remove",
	"dialogue-remove": "forum-remove",
	"conversation-remove": "forum-remove",
	"discussion-remove": "forum-remove",
	"forum-delete-outline": "forum-remove-outline",
	"chat-remove-outline": "forum-remove-outline",
	"chat-delete-outline": "forum-remove-outline",
	"dialogue-remove-outline": "forum-remove-outline",
	"conversation-remove-outline": "forum-remove-outline",
	"discussion-remove-outline": "forum-remove-outline",
	"chips": "french-fries",
	"finger-chips": "french-fries",
	"french-fry": "french-fries",
	"fried-potatoes": "french-fries",
	"fries": "french-fries",
	"frites": "french-fries",
	"faq": "frequently-asked-questions",
	"fridge-filled": "fridge",
	"refrigerator": "fridge",
	"kitchen": "table-furniture",
	"fridge-filled-top": "fridge-bottom",
	"refrigerator-bottom": "fridge-bottom",
	"refrigerator-outline": "fridge-outline",
	"fridge-filled-bottom": "fridge-top",
	"refrigerator-top": "fridge-top",
	"fruit-lemon": "fruit-citrus",
	"fruit-lime": "fruit-citrus",
	"fruit-ananas": "fruit-pineapple",
	"petrol": "fuel",
	"gasoline": "fuel",
	"battery": "fuel-cell",
	"ruby-horizontal": "furigana-horizontal",
	"zhuyin": "furigana-vertical",
	"ruby-vertical": "furigana-vertical",
	"games": "gamepad",
	"controller": "gamepad",
	"controller-circle": "gamepad-circle",
	"controller-circle-down": "gamepad-circle-down",
	"controller-circle-left": "gamepad-circle-left",
	"controller-circle-outline": "gamepad-circle-outline",
	"controller-circle-right": "gamepad-circle-right",
	"controller-circle-up": "gamepad-circle-up",
	"controller-down": "gamepad-down",
	"controller-left": "gamepad-left",
	"controller-outline": "gamepad-outline",
	"games-outline": "gamepad-outline",
	"controller-right": "gamepad-right",
	"controller-round": "gamepad-round",
	"controller-round-down": "gamepad-round-down",
	"controller-round-left": "gamepad-round-left",
	"controller-round-outline": "gamepad-round-outline",
	"controller-round-right": "gamepad-round-right",
	"controller-round-up": "gamepad-round-up",
	"controller-square": "gamepad-square",
	"controller-square-outline": "gamepad-square-outline",
	"controller-up": "gamepad-up",
	"controller-variant": "gamepad-variant",
	"controller-variant-outline": "gamepad-variant-outline",
	"garage-warning": "garage-alert",
	"stove-burner": "gas-burner",
	"cooktop-burner": "gas-burner",
	"grill": "gas-burner",
	"tank": "gas-cylinder",
	"oxygen-tank": "gas-cylinder",
	"gas-pump": "gas-station",
	"petrol-pump": "gas-station",
	"petrol-station": "gas-station",
	"local-gas-station": "gas-station",
	"fuel-station": "gas-station",
	"fuel-pump": "gas-station",
	"gas-pump-outline": "gas-station-outline",
	"petrol-pump-outline": "gas-station-outline",
	"petrol-station-outline": "gas-station-outline",
	"fuel-station-outline": "gas-station-outline",
	"fuel-pump-outline": "gas-station-outline",
	"logic-gate-and": "gate-and",
	"logic-gate-nand": "gate-nand",
	"logic-gate-nor": "gate-nor",
	"logic-gate-not": "gate-not",
	"logic-gate-or": "gate-or",
	"logic-gate-xnor": "gate-xnor",
	"logic-gate-xor": "gate-xor",
	"swap-driving-apps-wheel": "gauge",
	"barometer": "gauge",
	"court-hammer": "gavel",
	"venus": "gender-female",
	"mars": "gender-male",
	"mercury": "gender-male-female-variant",
	"gender-enby": "gender-non-binary",
	"power-generator": "generator-stationary",
	"electricity-generator": "generator-stationary",
	"freehand-line": "gesture",
	"interaction-double-tap": "gesture-double-tap",
	"hand-double-tap": "gesture-double-tap",
	"interaction-tap": "gesture-tap",
	"hand-tap": "gesture-tap",
	"gesture-touch": "gesture-tap",
	"gesture-touch-box": "gesture-tap-box",
	"call-to-action": "gesture-tap-button",
	"cta": "gesture-tap-button",
	"button-pointer": "gesture-tap-button",
	"gesture-touch-button": "gesture-tap-button",
	"gesture-touch-hold": "gesture-tap-hold",
	"inky": "ghost",
	"blinky": "ghost",
	"pinky": "ghost",
	"clyde": "ghost",
	"present": "gift",
	"package": "gift",
	"donate": "gift",
	"present-off": "gift-off",
	"package-off": "gift-off",
	"donate-off": "gift-off",
	"present-off-outline": "gift-off-outline",
	"package-off-outline": "gift-off-outline",
	"donate-off-outline": "gift-off-outline",
	"present-open": "gift-open",
	"package-open": "gift-open",
	"present-open-outline": "gift-open-outline",
	"package-open-outline": "gift-open-outline",
	"donate-outline": "gift-outline",
	"present-outline": "gift-outline",
	"package-outline": "gift-outline",
	"microsoft-github": "github",
	"local-bar": "glass-mug-variant",
	"cocktail": "glass-wine",
	"martini": "glass-cocktail",
	"alcohol": "liquor",
	"glass-broken": "glass-fragile",
	"beer": "liquor",
	"cart": "go-kart",
	"gog-com": "gog",
	"golf-course": "golf",
	"cable-car": "gondola",
	"google-adwords": "google-ads",
	"chromecast": "google-chrome",
	"dinosaur-pixel": "google-downasaur",
	"t-rex": "google-downasaur",
	"tyrannosaurus-rex": "google-downasaur",
	"attach-drive": "google-drive",
	"marble": "google-earth",
	"pegman": "google-street-view",
	"g-translate": "google-translate",
	"dependency": "graph-outline",
	"dependencies": "graph-outline",
	"lawn": "grass",
	"headstone": "grave-stone",
	"tombstone": "grave-stone",
	"cemetery": "grave-stone",
	"graveyard": "grave-stone",
	"glasshouse": "greenhouse",
	"hothouse": "greenhouse",
	"shed": "greenhouse",
	"grid-on": "grid",
	"bbq": "grill",
	"barbecue": "grill",
	"charcoal": "grill",
	"barbecue-outline": "grill-outline",
	"bbq-outline": "grill-outline",
	"charcoal-outline": "grill-outline",
	"hail-taxi": "hail",
	"hail-cab": "hail",
	"pumpkin-face": "halloween",
	"pumpkin-carved": "halloween",
	"jack-o-lantern": "halloween",
	"emoji-halloween": "halloween",
	"emoticon-halloween": "halloween",
	"food": "hamburger",
	"burger-check": "hamburger-check",
	"burger-minus": "hamburger-minus",
	"food-off": "hamburger-off",
	"burger-plus": "hamburger-plus",
	"burger-add": "hamburger-plus",
	"burger-remove": "hamburger-remove",
	"tools": "hammer-wrench",
	"communism": "hammer-sickle",
	"applause": "hand-clap",
	"applause-off": "hand-clap-off",
	"charity": "hand-coin",
	"donation": "hand-coin",
	"charity-outline": "hand-coin-outline",
	"donation-outline": "hand-coin-outline",
	"hand-bike": "hand-cycle",
	"hand-open": "hand-extended",
	"hand-palm": "hand-extended",
	"hand-open-outline": "hand-extended-outline",
	"hand-palm-outline": "hand-extended-outline",
	"volunteer": "hand-heart",
	"love": "hand-heart",
	"hope": "hand-heart",
	"hand-wash": "hand-water",
	"greeting": "hand-wave",
	"farewell": "hand-wave",
	"greeting-outline": "hand-wave-outline",
	"farewell-outline": "hand-wave-outline",
	"volleyball": "handball",
	"human-handball": "handball",
	"deal": "handshake",
	"help": "lifebuoy",
	"partnership": "handshake",
	"business-outline": "handshake-outline",
	"deal-outline": "handshake-outline",
	"help-outline": "help-circle-outline",
	"partnership-outline": "handshake-outline",
	"coat-hanger": "hanger",
	"clothes-hanger": "hanger",
	"closet": "wardrobe",
	"helmet": "hard-hat",
	"hdd": "harddisk",
	"hdd-plus": "harddisk-plus",
	"hdd-remove": "harddisk-remove",
	"warning-lights": "hazard-lights",
	"psychology": "head-cog",
	"psychology-outline": "head-cog-outline",
	"head-thinking": "head-dots-horizontal",
	"head-thinking-outline": "head-dots-horizontal-outline",
	"head-ache": "head-flash",
	"head-ache-outline": "head-flash-outline",
	"head-love": "head-heart",
	"head-love-outline": "head-heart-outline",
	"head-idea": "head-lightbulb",
	"head-bulb": "head-lightbulb",
	"head-idea-outline": "head-lightbulb-outline",
	"head-bulb-outline": "head-lightbulb-outline",
	"head-freeze": "head-snowflake",
	"brain-freeze": "head-snowflake",
	"head-freeze-outline": "head-snowflake-outline",
	"brain-freeze-outline": "head-snowflake-outline",
	"head-reload": "head-sync",
	"head-refresh": "head-sync",
	"head-reload-outline": "head-sync-outline",
	"head-refresh-outline": "head-sync-outline",
	"headset": "headphones",
	"headset-mic": "headset",
	"favorite": "star",
	"favourite": "heart",
	"aed": "heart-flash",
	"defibrillator": "heart-flash",
	"hearts": "heart-multiple",
	"hearts-outline": "heart-multiple-outline",
	"favorite-border": "heart-outline",
	"favourite-border": "heart-outline",
	"favorite-outline": "star-outline",
	"favourite-outline": "heart-outline",
	"heart-vitals": "heart-pulse",
	"find-love": "heart-search",
	"keep-warm": "heat-wave",
	"warmth": "heat-wave",
	"radiator-coil": "heating-coil",
	"heated-floor": "heating-coil",
	"question-mark": "help",
	"question-mark-box": "help-box",
	"quiz": "help-box-multiple",
	"question-box-multiple": "help-box-multiple",
	"quiz-outline": "help-box-multiple-outline",
	"question-box-multiple-outline": "help-box-multiple-outline",
	"question-box-outline": "help-box-outline",
	"question-mark-circle": "help-circle",
	"question-mark-circle-outline": "help-circle-outline",
	"question-network": "help-network",
	"question-network-outline": "help-network-outline",
	"question-mark-rhombus": "help-rhombus",
	"question-mark-rhombus-outline": "help-rhombus-outline",
	"hexagons": "hexagon-multiple",
	"christmas-star": "hexagram",
	"star-outline": "hexagram-outline",
	"christmas-star-outline": "hexagram-outline",
	"hd": "high-definition-box",
	"hd-box": "high-definition-box",
	"autobahn": "highway",
	"motorway": "highway",
	"human-hiking": "hiking",
	"recent": "history",
	"latest": "history",
	"clock-arrow": "update",
	"counterclockwise": "history",
	"restore-clock": "history",
	"house": "home",
	"home-user": "home-account",
	"house-account": "home-account",
	"house-user": "home-account",
	"home-warning": "home-alert",
	"house-alert": "home-alert",
	"house-warning": "home-alert",
	"house-alert-outline": "home-alert-outline",
	"home-warning-outline": "home-alert-outline",
	"house-warning-outline": "home-alert-outline",
	"chart-home": "home-analytics",
	"home-chart": "home-analytics",
	"home-report": "home-analytics",
	"house-analytics": "home-analytics",
	"house-chart": "home-analytics",
	"house-automation": "home-automation",
	"home-wireless": "home-automation",
	"house-wireless": "home-automation",
	"smart-home": "home-automation",
	"smart-house": "home-automation",
	"home-energy": "home-lightning-bolt-outline",
	"home-power": "home-lightning-bolt-outline",
	"home-electricity": "home-lightning-bolt-outline",
	"house-energy": "home-battery",
	"house-battery": "home-battery",
	"house-power": "home-battery",
	"home-energy-outline": "home-battery-outline",
	"home-power-outline": "home-battery-outline",
	"home-electricity-outline": "home-battery-outline",
	"house-battery-outline": "home-battery-outline",
	"house-power-outline": "home-battery-outline",
	"house-energy-outline": "home-battery-outline",
	"house-circle": "home-circle",
	"house-circle-outline": "home-circle-outline",
	"house-city": "home-city",
	"house-city-outline": "home-city-outline",
	"home-time": "home-clock",
	"home-schedule": "home-clock",
	"house-time": "home-clock",
	"house-clock": "home-clock",
	"house-schedule": "home-clock",
	"home-time-outline": "home-clock-outline",
	"home-schedule-outline": "home-clock-outline",
	"house-clock-outline": "home-clock-outline",
	"house-time-outline": "home-clock-outline",
	"house-schedule-outline": "home-clock-outline",
	"house-edit": "home-edit",
	"house-edit-outline": "home-edit-outline",
	"house-export-outline": "home-export-outline",
	"house-flood": "home-flood",
	"house-floor-0": "home-floor-0",
	"home-floor-zero": "home-floor-0",
	"house-floor-zero": "home-floor-0",
	"house-floor-1": "home-floor-1",
	"home-floor-one": "home-floor-1",
	"house-floor-one": "home-floor-1",
	"home-floor-first": "home-floor-1",
	"house-floor-first": "home-floor-1",
	"house-floor-2": "home-floor-2",
	"home-floor-two": "home-floor-2",
	"house-floor-two": "home-floor-2",
	"home-floor-second": "home-floor-2",
	"house-floor-second": "home-floor-2",
	"house-floor-3": "home-floor-3",
	"home-floor-three": "home-floor-3",
	"house-floor-three": "home-floor-3",
	"home-floor-third": "home-floor-3",
	"house-floor-third": "home-floor-3",
	"home-floor-attic": "home-floor-a",
	"house-floor-a": "home-floor-a",
	"house-floor-attic": "home-floor-a",
	"home-floor-basement": "home-floor-b",
	"house-floor-b": "home-floor-b",
	"house-floor-basement": "home-floor-b",
	"home-floor-ground": "home-floor-g",
	"house-floor-g": "home-floor-g",
	"house-floor-ground": "home-floor-g",
	"home-floor-loft": "home-floor-l",
	"home-floor-lower": "home-floor-l",
	"house-floor-l": "home-floor-l",
	"house-floor-loft": "home-floor-l",
	"house-floor-lower": "home-floor-l",
	"house-floor-negative-1": "home-floor-negative-1",
	"home-floor-negative-one": "home-floor-negative-1",
	"home-floor-minus-1": "home-floor-negative-1",
	"home-floor-minus-one": "home-floor-negative-1",
	"house-floor-negative-one": "home-floor-negative-1",
	"house-floor-minus-1": "home-floor-negative-1",
	"house-floor-minus-one": "home-floor-negative-1",
	"house-group": "home-group",
	"neighbourhood": "home-group",
	"estate": "home-group",
	"housing-estate": "home-group",
	"house-group-minus": "home-group-minus",
	"house-group-plus": "home-group-plus",
	"home-group-add": "home-group-plus",
	"house-group-add": "home-group-plus",
	"house-group-remove": "home-group-remove",
	"house-heart": "home-heart",
	"house-import-outline": "home-import-outline",
	"home-bulb": "home-lightbulb",
	"house-lightbulb": "home-lightbulb",
	"house-bulb": "home-lightbulb",
	"home-bulb-outline": "home-lightbulb-outline",
	"house-lightbulb-outline": "home-lightbulb-outline",
	"house-bulb-outline": "home-lightbulb-outline",
	"home-flash": "home-lightning-bolt-outline",
	"house-lightning-bolt": "home-lightning-bolt",
	"house-flash": "home-lightning-bolt",
	"house-lightning-bolt-outline": "home-lightning-bolt-outline",
	"house-flash-outline": "home-lightning-bolt-outline",
	"house-lock": "home-lock",
	"home-secure": "home-lock",
	"house-secure": "home-lock",
	"house-lock-open": "home-lock-open",
	"house-map-marker": "home-map-marker",
	"home-location": "home-map-marker",
	"house-minus": "home-minus",
	"house-minus-outline": "home-minus-outline",
	"house-modern": "home-modern",
	"house-off": "home-off",
	"house-off-outline": "home-off-outline",
	"house-outline": "home-outline",
	"home-add": "home-plus",
	"house-plus": "home-plus",
	"house-add": "home-plus",
	"house-plus-outline": "home-plus-outline",
	"house-add-outline": "home-plus-outline",
	"house-remove": "home-remove",
	"house-remove-outline": "home-remove-outline",
	"home-chimney": "home-roof",
	"home-attic": "home-roof",
	"house-roof": "home-roof",
	"house-attic": "home-roof",
	"house-chimney": "home-roof",
	"house-search": "home-search",
	"home-find": "home-search",
	"house-find": "home-search",
	"house-search-outline": "home-search-outline",
	"home-find-outline": "home-search-outline",
	"house-find-outline": "home-search-outline",
	"farm-house": "home-silo",
	"farm-home": "home-silo",
	"farm-house-outline": "home-silo-outline",
	"farm-home-outline": "home-silo-outline",
	"home-swap": "home-switch",
	"house-switch": "home-switch",
	"house-swap": "home-switch",
	"home-swap-outline": "home-switch-outline",
	"house-swap-outline": "home-switch-outline",
	"house-switch-outline": "home-switch-outline",
	"home-climate": "home-thermometer",
	"home-temperature": "home-thermometer",
	"house-thermometer": "home-thermometer",
	"house-climate": "home-thermometer",
	"house-temperature": "home-thermometer",
	"home-climate-outline": "home-thermometer-outline",
	"home-temperature-outline": "home-thermometer-outline",
	"house-thermometer-outline": "home-thermometer-outline",
	"house-climate-outline": "home-thermometer-outline",
	"house-temperature-outline": "home-thermometer-outline",
	"house-variant": "home-variant",
	"house-variant-outline": "home-variant-outline",
	"green-house": "hoop-house",
	"high-tunnel": "hoop-house",
	"equestrian": "horse-human",
	"horseback-riding": "horse-human",
	"horse-riding": "horse-human",
	"equestrian-variant": "horse-variant",
	"swiss-cross": "hospital",
	"dispensary": "hospital",
	"local-hospital": "hospital-box",
	"swiss-cross-box": "hospital-box",
	"dispensary-box": "hospital-box",
	"swiss-cross-box-outline": "hospital-box-outline",
	"dispensary-box-outline": "hospital-box-outline",
	"hospital-location": "hospital-marker",
	"accessibility": "human",
	"elderly": "human-cane",
	"human-capacity-reduce": "human-capacity-decrease",
	"human-hand-truck": "human-dolly",
	"human-trolley": "human-dolly",
	"woman": "human-female",
	"mother": "human-female-girl",
	"mom": "human-female-girl",
	"woman-child": "human-female-girl",
	"mum": "human-female-girl",
	"ballet": "human-female-dance",
	"woman-woman": "human-female-female",
	"women": "human-female-female",
	"human-hello": "human-greeting",
	"human-welcome": "human-greeting",
	"connect-without-contact": "human-greeting-proximity",
	"human-hello-variant": "human-greeting-variant",
	"man": "human-male",
	"teacher": "human-male-board",
	"teaching": "human-male-board",
	"lecture": "human-male-board",
	"college": "school",
	"blackboard": "human-male-board",
	"whiteboard": "human-male-board",
	"human-man-board": "human-male-board",
	"teach-poll": "human-male-board-poll",
	"father": "human-male-girl",
	"dad": "human-male-girl",
	"man-child": "human-male-girl",
	"wc": "human-male-female",
	"man-woman": "human-male-female",
	"mom-dad-child": "human-male-female-child",
	"man-man": "human-male-male",
	"men": "human-male-male",
	"human-genderless": "human-non-binary",
	"human-transgender": "human-non-binary",
	"pregnant-woman": "human-pregnant",
	"human-line": "human-queue",
	"human-accessible": "human-wheelchair",
	"human-blind": "human-white-cane",
	"heating": "hvac",
	"ventilation": "hvac",
	"air-conditioning": "hvac",
	"heating-off": "hvac-off",
	"ventilation-off": "hvac-off",
	"air-conditioning-off": "hvac-off",
	"hydraulic-turbine": "hydro-power",
	"water-turbine": "hydro-power",
	"watermill": "hydro-power",
	"popsicle": "ice-pop",
	"key": "identifier",
	"ideogram-chinese-japanese-korean": "ideogram-cjk",
	"writing-system-cjk": "ideogram-cjk",
	"ideogram-chinese-japanese-korean-variant": "ideogram-cjk-variant",
	"writing-system-cjk-variant": "ideogram-cjk-variant",
	"insert-photo": "image",
	"photo-album": "image-album",
	"book-image": "image-album",
	"image-filter": "image-multiple-outline",
	"broken-image": "image-broken-variant",
	"filter-b-and-w": "image-filter-black-white",
	"image-filter-centre-focus": "image-filter-center-focus",
	"image-filter-centre-focus-weak": "image-filter-center-focus-weak",
	"mountain": "image-filter-hdr",
	"landscape": "image-filter-hdr",
	"mountain-outline": "image-filter-hdr-outline",
	"landscape-outline": "image-filter-hdr-outline",
	"image-secure": "image-lock",
	"image-secure-outline": "image-lock-outline",
	"image-location": "image-marker",
	"image-location-outline": "image-marker-outline",
	"collections": "image-multiple",
	"photo-library": "image-multiple",
	"images": "image-multiple",
	"images-outline": "image-multiple-outline",
	"image-add": "image-plus",
	"image-add-outline": "image-plus-outline",
	"image-description": "image-text",
	"input": "import",
	"move-to-inbox": "inbox-arrow-down",
	"move-from-inbox": "inbox-arrow-up",
	"inboxes": "inbox-multiple",
	"inboxes-outline": "inbox-multiple-outline",
	"anonymous": "incognito",
	"spy": "incognito",
	"anonymous-circle": "incognito-circle",
	"spy-circle": "incognito-circle",
	"anonymous-circle-off": "incognito-circle-off",
	"spy-circle-off": "incognito-circle-off",
	"spy-off": "incognito-off",
	"anonymous-off": "incognito-off",
	"ignition": "induction",
	"about": "information",
	"information-circle": "information",
	"info-circle": "information",
	"about-circle": "information",
	"info": "information",
	"info-box": "information-box",
	"info-box-outline": "information-box-outline",
	"info-off": "information-off",
	"info-circle-off": "information-off",
	"information-circle-off": "information-off",
	"info-circle-off-outline": "information-off-outline",
	"information-circle-off-outline": "information-off-outline",
	"information-off-outline": "information-off-outline",
	"info-off-outline": "information-off-outline",
	"info-outline": "information-outline",
	"about-outline": "information-outline",
	"information-circle-outline": "information-outline",
	"info-circle-outline": "information-outline",
	"about-circle-outline": "information-outline",
	"info-slab-box": "information-slab-box",
	"info-slab-box-outline": "information-slab-box-outline",
	"info-slab-circle": "information-slab-circle",
	"info-slab-circle-outline": "information-slab-circle-outline",
	"info-slab-symbol": "information-slab-symbol",
	"info-symbol": "information-symbol",
	"info-variant": "information-variant",
	"about-variant": "information-variant",
	"information-serif-symbol": "information-variant",
	"info-variant-symbol": "information-variant",
	"info-variant-box": "information-variant-box",
	"information-serif-box": "information-variant-box",
	"info-serif-box": "information-variant-box",
	"info-variant-box-outline": "information-variant-box-outline",
	"information-serif-box-outline": "information-variant-box-outline",
	"info-serif-box-outline": "information-variant-box-outline",
	"information-serif-circle": "information-variant-circle",
	"info-serif-circle": "information-variant-circle",
	"info-variant-circle": "information-variant-circle",
	"information-serif-circle-outline": "information-variant-circle-outline",
	"info-variant-circle-outline": "information-variant-circle-outline",
	"info-serif-circle-outline": "information-variant-circle-outline",
	"dinner-bell": "instrument-triangle",
	"icc": "integrated-circuit-chip",
	"chip": "memory",
	"invert-colours": "invert-colors",
	"invert-colours-off": "invert-colors-off",
	"invoice-scheduled": "invoice-clock",
	"invoice-scheduled-outline": "invoice-clock-outline",
	"invoice-outbound-outline": "invoice-export-outline",
	"invoice-inbound": "invoice-import",
	"invoice-inbound-outline": "invoice-import-outline",
	"invoice-line-items": "invoice-list",
	"invoice-line-items-outline": "invoice-list-outline",
	"invoice-new": "invoice-plus",
	"invoice-new-outline": "invoice-plus-outline",
	"invoice-text-scheduled": "invoice-text-clock",
	"invoice-text-scheduled-outline": "invoice-text-clock-outline",
	"invoice-text-new": "invoice-text-plus",
	"invoice-text-new-outline": "invoice-text-plus-outline",
	"internet-protocol": "ip",
	"internet-protocol-outline": "ip-outline",
	"apple-ipod": "ipod",
	"flatiron": "iron",
	"smoothing-iron": "iron",
	"flatiron-outline": "iron-outline",
	"smoothing-iron-outline": "iron-outline",
	"wrestling": "kabaddi",
	"human-kabaddi": "kabaddi",
	"marsupial": "koala",
	"martial-arts": "karate",
	"kickboxing": "karate",
	"human-karate": "karate",
	"human-kayaking": "kayaking",
	"tea-kettle": "kettle",
	"kettle-full": "kettle",
	"tea-kettle-full": "kettle",
	"tea-kettle-alert": "kettle-alert",
	"kettle-full-alert": "kettle-alert",
	"tea-kettle-full-alert": "kettle-alert",
	"tea-kettle-alert-outline": "kettle-alert-outline",
	"kettle-empty-alert": "kettle-alert-outline",
	"tea-kettle-empty-alert": "kettle-alert-outline",
	"tea-kettle-off": "kettle-off",
	"tea-kettle-full-off": "kettle-off",
	"kettle-full-off": "kettle-off",
	"tea-kettle-off-outline": "kettle-off-outline",
	"kettle-empty-off": "kettle-off-outline",
	"tea-kettle-empty-off": "kettle-off-outline",
	"tea-kettle-outline": "kettle-outline",
	"kettle-empty": "kettle-outline",
	"tea-kettle-empty": "kettle-outline",
	"tea-kettle-steam": "kettle-steam",
	"kettle-full-steam": "kettle-steam",
	"tea-kettle-full-steam": "kettle-steam",
	"tea-kettle-steam-outline": "kettle-steam-outline",
	"kettle-empty-steam": "kettle-steam-outline",
	"tea-kettle-empty-steam": "kettle-steam-outline",
	"vpn-key": "key",
	"foreign-key": "key-link",
	"sql-foreign-key": "key-link",
	"key-add": "key-plus",
	"primary-key": "key-star",
	"sql-primary-key": "key-star",
	"key-favorite": "key-star",
	"keyboard-clear": "keyboard-backspace",
	"keyboard-erase": "keyboard-backspace",
	"keyboard-capslock": "keyboard-caps",
	"keyboard-hide": "keyboard-close",
	"keyboard-hide-outline": "keyboard-close-outline",
	"sikh": "khanda",
	"silverware-knife": "knife",
	"cutlery-knife": "knife",
	"dagger": "knife-military",
	"volume-knob": "knob",
	"volume-control": "knob",
	"dial": "knob",
	"tuner": "knob",
	"switch": "swap-horizontal",
	"adjuster": "knob",
	"emoji-koala": "koala",
	"emoticon-koala": "koala",
	"bugfood": "ladybug",
	"ladybird": "ladybug",
	"lights": "lamps",
	"lights-outline": "lamps-outline",
	"local-area-network": "lan",
	"local-area-network-connect": "lan-connect",
	"local-area-network-disconnect": "lan-disconnect",
	"local-area-network-pending": "lan-pending",
	"avalanche": "landslide",
	"mudslide": "landslide",
	"avalanche-outline": "landslide-outline",
	"mudslide-outline": "landslide-outline",
	"xaml": "language-xaml",
	"microsoft-xaml": "language-xaml",
	"computer": "laptop",
	"teleconference": "monitor-account",
	"virtual-meeting": "monitor-account",
	"video-chat": "monitor-account",
	"layers-clear": "layers-off",
	"green-circle": "leaf-circle",
	"organic": "leaf-circle",
	"green-circle-outline": "leaf-circle-outline",
	"organic-outline": "leaf-circle-outline",
	"proximity-sensor": "leak",
	"proximity-sensor-off": "leak-off",
	"podium": "lectern",
	"dais": "lectern",
	"rostrum": "lectern",
	"lecturn": "lectern",
	"light-strip": "led-strip",
	"light-strip-variant": "led-strip-variant",
	"light-strip-variant-off": "led-strip-variant-off",
	"local-library": "library",
	"local-library-outline": "library-outline",
	"ribbon": "seal-variant",
	"prize": "seal-variant",
	"award": "seal-variant",
	"life-preserver": "lifebuoy",
	"overboard": "lifebuoy",
	"floodlight-down": "light-flood-down",
	"floodlight-up": "light-flood-up",
	"can-light": "light-recessed",
	"pot-light": "light-recessed",
	"high-hat-light": "light-recessed",
	"hi-hat-light": "light-recessed",
	"downlight": "light-recessed",
	"toggle-switch": "light-switch",
	"rocker-switch": "light-switch",
	"toggle-switch-off": "light-switch-off",
	"rocker-switch-off": "toggle-switch-variant-off",
	"idea": "lightbulb-outline",
	"bulb": "lightbulb",
	"lightbulb-error": "lightbulb-alert",
	"lightbulb-error-outline": "lightbulb-alert-outline",
	"lightbulb-automatic": "lightbulb-auto",
	"lightbulb-motion": "lightbulb-auto",
	"lightbulb-automatic-outline": "lightbulb-auto-outline",
	"lightbulb-motion-outline": "lightbulb-auto-outline",
	"bulb-cfl": "lightbulb-cfl",
	"bulb-cfl-off": "lightbulb-cfl-off",
	"bulb-cfl-spiral": "lightbulb-cfl-spiral",
	"bulb-cfl-spiral-off": "lightbulb-cfl-spiral-off",
	"bulb-group": "lightbulb-group",
	"bulb-group-off": "lightbulb-group-off",
	"bulb-group-off-outline": "lightbulb-group-off-outline",
	"bulb-group-outline": "lightbulb-group-outline",
	"lightbulbs": "lightbulb-multiple",
	"bulb-multiple": "lightbulb-multiple",
	"bulbs": "lightbulb-multiple",
	"lightbulbs-off": "lightbulb-multiple-off",
	"bulb-multiple-off": "lightbulb-multiple-off",
	"bulbs-off": "lightbulb-multiple-off",
	"lightbulbs-off-outline": "lightbulb-multiple-off-outline",
	"bulb-multiple-off-outline": "lightbulb-multiple-off-outline",
	"bulbs-off-outline": "lightbulb-multiple-off-outline",
	"lightbulbs-outline": "lightbulb-multiple-outline",
	"bulb-multiple-outline": "lightbulb-multiple-outline",
	"bulbs-outline": "lightbulb-multiple-outline",
	"night-light": "lightbulb-night",
	"nite-light": "lightbulb-night",
	"lightbulb-moon-star": "lightbulb-night",
	"night-light-outline": "lightbulb-night-outline",
	"nite-light-outline": "lightbulb-night-outline",
	"lightbulb-moon-star-outline": "lightbulb-night-outline",
	"bulb-off": "lightbulb-off",
	"bulb-off-outline": "lightbulb-off-outline",
	"bulb-on": "lightbulb-on",
	"lightbulb-dimmer-100": "lightbulb-on",
	"lightbulb-dimmer-10": "lightbulb-on-10",
	"lightbulb-dimmer-20": "lightbulb-on-20",
	"lightbulb-dimmer-30": "lightbulb-on-30",
	"lightbulb-dimmer-40": "lightbulb-on-40",
	"lightbulb-dimmer-50": "lightbulb-on-50",
	"lightbulb-dimmer-60": "lightbulb-on-60",
	"lightbulb-dimmer-70": "lightbulb-on-70",
	"lightbulb-dimmer-80": "lightbulb-on-80",
	"lightbulb-dimmer-90": "lightbulb-on-90",
	"bulb-on-outline": "lightbulb-on-outline",
	"bulb-outline": "lightbulb-outline",
	"lightbulb-help": "lightbulb-question",
	"lightbulb-help-outline": "lightbulb-question-outline",
	"lightbulb-halogen": "lightbulb-spot",
	"lightbulb-gu10": "lightbulb-spot",
	"lightbulb-halogen-off": "lightbulb-spot-off",
	"lightbulb-gu10-off": "lightbulb-spot-off",
	"lightbulb-edison": "lightbulb-variant",
	"lightbulb-filament": "lightbulb-variant",
	"lightbulb-edison-outline": "lightbulb-variant-outline",
	"lightbulb-filament-outline": "lightbulb-variant-outline",
	"beacon": "lighthouse-on",
	"thunder": "lightning-bolt",
	"storm": "lightning-bolt",
	"amp": "lightning-bolt-circle",
	"offline-bolt": "lightning-bolt-circle",
	"flash-circle": "lightning-bolt-circle",
	"electricity-circle": "lightning-bolt-circle",
	"energy-circle": "lightning-bolt-circle",
	"thunder-circle": "lightning-bolt-circle",
	"storm-circle": "lightning-bolt-circle",
	"thunder-outline": "lightning-bolt-outline",
	"storm-outline": "lightning-bolt-outline",
	"electricity-outline": "meter-electric-outline",
	"underwear": "lingerie",
	"bra": "lingerie",
	"panties": "lingerie",
	"insert-link": "link",
	"block-chain": "link-lock",
	"link-add": "link-plus",
	"tux": "linux",
	"ink-spot": "liquid-spot",
	"puddle": "liquid-spot",
	"water": "waves",
	"blood": "water",
	"spill": "liquid-spot",
	"oil": "liquid-spot",
	"dirty": "liquid-spot",
	"booze": "liquor",
	"beverages": "liquor",
	"whiskey": "liquor",
	"rum": "liquor",
	"wine": "liquor",
	"tequila": "liquor",
	"spirits": "liquor",
	"form": "list-box",
	"form-outline": "list-box-outline",
	"presence-enter": "location-enter",
	"presence-exit": "location-exit",
	"https": "lock",
	"password": "lock",
	"secure": "lock",
	"protected": "lock",
	"encryption": "lock",
	"lock-warning": "lock-alert",
	"password-alert": "lock-alert",
	"encryption-alert": "lock-alert",
	"password-warning": "lock-alert",
	"encryption-warning": "lock-alert",
	"lock-warning-outline": "lock-alert-outline",
	"password-alert-outline": "lock-alert-outline",
	"encryption-alert-outline": "lock-alert-outline",
	"password-warning-outline": "lock-alert-outline",
	"encryption-warning-outline": "lock-alert-outline",
	"password-check": "lock-check",
	"password-secure": "lock-check",
	"encryption-check": "lock-check",
	"encryption-secure": "lock-check",
	"password-verified": "lock-check",
	"encryption-verified": "lock-check",
	"password-check-outline": "lock-check-outline",
	"password-secure-outline": "lock-check-outline",
	"encryption-check-outline": "lock-check-outline",
	"encryption-secure-outline": "lock-check-outline",
	"password-verified-outline": "lock-check-outline",
	"encryption-verified-outline": "lock-check-outline",
	"confidential-mode": "lock-clock",
	"password-clock": "lock-clock",
	"password-expiration": "lock-clock",
	"encryption-expiration": "lock-clock",
	"password-minus": "lock-minus",
	"encryption-minus": "lock-minus-outline",
	"password-minus-outline": "lock-minus-outline",
	"password-off": "lock-off",
	"not-protected": "lock-off",
	"unsecure": "lock-off",
	"encryption-off": "lock-off",
	"password-off-outline": "lock-off-outline",
	"unsecure-outline": "lock-off-outline",
	"not-protected-outline": "lock-off-outline",
	"encryption-off-outline": "lock-off-outline",
	"unlocked": "lock-open",
	"decrypted": "lock-open",
	"unlocked-alert": "lock-open-alert",
	"decrypted-alert": "lock-open-alert",
	"lock-open-warning": "lock-open-alert",
	"unlocked-warning": "lock-open-alert",
	"decrypted-warning": "lock-open-alert",
	"unlocked-alert-outline": "lock-open-alert-outline",
	"lock-open-warning-outline": "lock-open-alert-outline",
	"decrypted-alert-outline": "lock-open-alert-outline",
	"unlocked-warning-outline": "lock-open-alert-outline",
	"decrypted-warning-outline": "lock-open-alert-outline",
	"unlocked-check": "lock-open-check",
	"decrypted-check": "lock-open-check",
	"unlocked-check-outline": "lock-open-check-outline",
	"decrypted-check-outline": "lock-open-check-outline",
	"unlocked-minus": "lock-open-minus",
	"decrypted-minus": "lock-open-minus",
	"unlocked-minus-outline": "lock-open-minus-outline",
	"decrypted-minus-outline": "lock-open-minus-outline",
	"unlocked-outline": "lock-open-outline",
	"decrypted-outline": "lock-open-outline",
	"unlocked-plus": "lock-open-plus",
	"decrypted-plus": "lock-open-plus",
	"lock-open-add": "lock-open-plus",
	"unlocked-add": "lock-open-plus",
	"decrypted-add": "lock-open-plus",
	"unlocked-plus-outline": "lock-open-plus-outline",
	"lock-open-add-outline": "lock-open-plus-outline",
	"unlocked-add-outline": "lock-open-plus-outline",
	"decrypted-plus-outline": "lock-open-plus-outline",
	"decrypted-add-outline": "lock-open-plus-outline",
	"unlocked-remove": "lock-open-remove",
	"decrypted-remove": "lock-open-remove",
	"unlocked-remove-outline": "lock-open-remove-outline",
	"decrypted-remove-outline": "lock-open-remove-outline",
	"unlocked-variant": "lock-open-variant",
	"decrypted-variant": "lock-open-variant",
	"unlocked-variant-outline": "lock-open-variant-outline",
	"decrypted-variant-outline": "lock-open-variant-outline",
	"password-outline": "lock-outline",
	"secure-outline": "lock-outline",
	"https-outline": "lock-outline",
	"protected-outline": "lock-outline",
	"encryption-outline": "lock-outline",
	"lock-rate": "lock-percent",
	"lock-rate-open": "lock-percent-open",
	"lock-rate-open-outline": "lock-percent-open-outline",
	"lock-rate-open-variant": "lock-percent-open-variant",
	"lock-rate-open-variant-outline": "lock-percent-open-variant-outline",
	"lock-rate-outline": "lock-percent-outline",
	"enhanced-encryption": "lock-plus",
	"lock-add": "lock-plus",
	"encryption-add": "lock-plus",
	"password-add": "lock-plus",
	"password-plus": "lock-plus",
	"encryption-plus": "lock-plus",
	"lock-add-outline": "lock-plus-outline",
	"password-plus-outline": "lock-plus-outline",
	"password-add-outline": "lock-plus-outline",
	"encryption-plus-outline": "lock-plus-outline",
	"encryption-add-outline": "lock-plus-outline",
	"forgot-password": "lock-question",
	"password-question": "lock-question",
	"encryption-question": "lock-question",
	"password-remove": "lock-remove",
	"encryption-remove": "lock-remove",
	"password-remove-outline": "lock-remove-outline",
	"encryption-remove-outline": "lock-remove-outline",
	"password-reset": "lock-reset",
	"encryption-reset": "lock-reset",
	"lockers": "locker-multiple",
	"log-in": "login",
	"sign-in": "login",
	"log-in-variant": "login-variant",
	"sign-in-variant": "login-variant",
	"log-out": "logout",
	"sign-out": "logout",
	"log-out-variant": "logout-variant",
	"sign-out-variant": "logout-variant",
	"rainbow": "looks",
	"hand-sanitizer": "lotion-plus",
	"hand-sanitizer-outline": "lotion-plus-outline",
	"zoom-plus": "loupe",
	"circle-plus-outline": "loupe",
	"magnify": "loupe",
	"ammunition-pistol": "magazine-pistol",
	"ammunition-rifle": "magazine-rifle",
	"staff-shimmer": "magic-staff",
	"magic-wand": "magic-staff",
	"search": "magnify",
	"search-expand": "magnify-expand",
	"zoom-out": "magnify-minus",
	"search-minus": "magnify-minus",
	"zoom-out-cursor": "magnify-minus-cursor",
	"zoom-out-outline": "magnify-minus-outline",
	"search-minus-outline": "magnify-minus-outline",
	"zoom-in": "magnify-plus",
	"magnify-add": "magnify-plus",
	"search-plus": "magnify-plus",
	"search-add": "magnify-plus",
	"zoom-in-cursor": "magnify-plus-cursor",
	"magnify-add-cursor": "magnify-plus-cursor",
	"zoom-in-outline": "magnify-plus-outline",
	"magnify-add-outline": "magnify-plus-outline",
	"search-plus-outline": "magnify-plus-outline",
	"search-add-outline": "magnify-plus-outline",
	"map-tick": "map-check",
	"map-tick-outline": "map-check-outline",
	"timezone": "map-clock",
	"timezone-outline": "map-clock-outline",
	"location": "map-marker",
	"address-marker": "map-marker",
	"location-on": "map-marker",
	"place": "map-marker",
	"room": "map-marker",
	"location-alert": "map-marker-alert",
	"location-warning": "map-marker-alert",
	"location-alert-outline": "map-marker-alert-outline",
	"location-warning-outline": "map-marker-alert-outline",
	"map-marker-tick": "map-marker-check",
	"where-to-vote": "map-marker-check",
	"location-check": "map-marker-check",
	"location-check-outline": "map-marker-check-outline",
	"where-to-vote-outline": "map-marker-check-outline",
	"explore-nearby": "map-marker-circle",
	"location-circle": "map-marker-circle",
	"location-distance": "map-marker-distance",
	"location-down": "map-marker-down",
	"location-left": "map-marker-left",
	"location-left-outline": "map-marker-left-outline",
	"location-minus": "map-marker-minus",
	"location-minus-outline": "map-marker-minus-outline",
	"map-markers": "map-marker-multiple",
	"location-multiple": "map-marker-multiple",
	"locations": "map-marker-multiple",
	"locations-outline": "map-marker-multiple-outline",
	"location-multiple-outline": "map-marker-multiple-outline",
	"map-markers-outline": "map-marker-multiple-outline",
	"location-off": "map-marker-off",
	"location-off-outline": "map-marker-off-outline",
	"location-outline": "map-marker-outline",
	"address-marker-outline": "map-marker-outline",
	"location-on-outline": "map-marker-outline",
	"place-outline": "map-marker-outline",
	"location-path": "map-marker-path",
	"location-plus": "map-marker-plus",
	"map-marker-add": "map-marker-plus",
	"location-add": "map-marker-plus",
	"map-marker-add-outline": "map-marker-plus-outline",
	"location-plus-outline": "map-marker-plus-outline",
	"location-add-outline": "map-marker-plus-outline",
	"location-question": "map-marker-question",
	"location-question-outline": "map-marker-question-outline",
	"location-radius": "map-marker-radius",
	"location-radius-outline": "map-marker-radius-outline",
	"location-remove": "map-marker-remove",
	"location-remove-outline": "map-marker-remove-outline",
	"location-remove-variant-outline": "map-marker-remove-variant",
	"location-right": "map-marker-right",
	"location-right-outline": "map-marker-right-outline",
	"map-marker-favorite": "map-marker-star",
	"location-star": "map-marker-star",
	"location-favorite": "map-marker-star",
	"map-marker-favorite-outline": "map-marker-star-outline",
	"location-star-outline": "map-marker-star-outline",
	"location-favorite-outline": "map-marker-star-outline",
	"location-up": "map-marker-up",
	"map-add": "map-plus",
	"highlighter": "marker",
	"beenhere": "marker-check",
	"marker-tick": "marker-check",
	"maths-compass": "math-compass",
	"math-cosine": "math-cos",
	"maths-cos": "math-cos",
	"code-or": "math-norm",
	"parallel": "math-norm",
	"code-or-box": "math-norm-box",
	"parallel-box": "math-norm-box",
	"math-sine": "math-sin",
	"maths-sin": "math-sin",
	"math-tangent": "math-tan",
	"maths-tan": "math-tan",
	"first-aid-kit": "medical-bag",
	"medicine": "pill-multiple",
	"covid-test": "medical-cotton-swab",
	"pill-bottle": "medication",
	"medicine-bottle": "medication",
	"bottle-plus": "medication",
	"pill-bottle-outline": "medication-outline",
	"medicine-bottle-outline": "medication-outline",
	"bottle-plus-outline": "medication-outline",
	"human-meditation": "meditation",
	"chip-arrow-down": "memory-arrow-down",
	"candelabra": "menorah",
	"menorah-flame": "menorah-fire",
	"candelabra-fire": "menorah-fire",
	"hamburger-menu": "menu",
	"hamburger-close": "menu-close",
	"arrow-drop-down": "menu-down",
	"caret-down": "menu-down",
	"caret-down-outline": "menu-down-outline",
	"arrow-left": "menu-left",
	"hamburger-open": "menu-open",
	"arrow-right": "menu-right",
	"arrow-drop-up": "menu-up",
	"caret-up": "menu-up",
	"caret-up-outline": "menu-up-outline",
	"chat-bubble": "message",
	"message-warning": "message-alert",
	"sms-failed": "message-alert",
	"message-warning-outline": "message-alert-outline",
	"sms-failed-outline": "message-alert-outline",
	"message-unread": "message-badge",
	"message-notification": "message-badge",
	"message-unread-outline": "message-badge-outline",
	"message-notification-outline": "message-badge-outline",
	"speaker-notes": "message-bulleted",
	"speaker-notes-off": "message-bulleted-off",
	"rate-review": "message-draw",
	"message-quick": "message-flash",
	"message-quick-outline": "message-flash-outline",
	"mms": "message-image",
	"message-secure": "message-lock",
	"chat-bubble-outline": "message-outline",
	"message-add": "message-plus",
	"sms": "message-processing",
	"textsms": "message-processing",
	"mode-comment": "message-reply",
	"comment": "message-reply-text",
	"insert-comment": "message-reply-text",
	"message-text-secure": "message-text-lock",
	"voice-chat": "message-video",
	"power-meter": "meter-electric",
	"power-meter-outline": "meter-electric-outline",
	"natural-gas-outline": "meter-gas-outline",
	"tempo": "metronome",
	"bpm": "metronome",
	"beats-per-minute": "metronome",
	"tempo-tick": "metronome-tick",
	"bpm-tick": "metronome-tick",
	"beats-per-minute-tick": "metronome-tick",
	"keyboard-voice": "microphone",
	"tts": "microphone-message",
	"text-to-speech": "speaker-message",
	"tts-off": "microphone-message-off",
	"text-to-speech-off": "microphone-message-off",
	"microphone-remove": "microphone-minus",
	"mic-off": "microphone-off",
	"mic-none": "microphone-outline",
	"microphone-add": "microphone-plus",
	"microphone-help": "microphone-question",
	"microphone-help-outline": "microphone-question-outline",
	"settings-voice": "microphone-settings",
	"microsoft-edge": "microsoft-edge",
	"visualstudio": "microsoft-visual-studio",
	"vs-code": "microsoft-visual-studio-code",
	"microsoft-windows": "microsoft-windows",
	"xbox-live": "microsoft-xbox",
	"microsoft": "microsoft-xbox",
	"microsoft-xbox-gamepad": "microsoft-xbox-controller",
	"xbox-controller-battery-warning": "microsoft-xbox-controller-battery-alert",
	"microsoft-xbox-gamepad-battery-alert": "microsoft-xbox-controller-battery-alert",
	"microsoft-xbox-gamepad-battery-charging": "microsoft-xbox-controller-battery-charging",
	"microsoft-xbox-gamepad-battery-empty": "microsoft-xbox-controller-battery-empty",
	"microsoft-xbox-gamepad-battery-full": "microsoft-xbox-controller-battery-full",
	"microsoft-xbox-gamepad-battery-low": "microsoft-xbox-controller-battery-low",
	"microsoft-xbox-gamepad-battery-medium": "microsoft-xbox-controller-battery-medium",
	"microsoft-xbox-gamepad-battery-unknown": "microsoft-xbox-controller-battery-unknown",
	"microsoft-xbox-gamepad-off": "microsoft-xbox-controller-off",
	"microwave-oven": "microwave",
	"microsoft-minecraft": "minecraft",
	"horizontal-line": "minus",
	"minimize": "minus",
	"indeterminate-check-box": "minus-box",
	"library-minus": "minus-box-multiple",
	"library-minus-outline": "minus-box-multiple-outline",
	"checkbox-indeterminate-outline": "minus-box-outline",
	"do-not-disturb-on": "minus-circle",
	"do-not-enter": "minus-circle",
	"pill-tablet": "minus-circle",
	"pharmaceutical": "pill",
	"coins-minus": "minus-circle-multiple",
	"coins-minus-outline": "minus-circle-multiple-outline",
	"do-not-disturb-off": "minus-circle-off",
	"remove-circle-off": "minus-circle-off",
	"do-not-enter-off": "minus-circle-off",
	"do-not-disturb-off-outline": "minus-circle-off-outline",
	"remove-circle-off-outline": "minus-circle-off-outline",
	"do-not-enter-off-outline": "minus-circle-off-outline",
	"do-not-enter-outline": "minus-circle-outline",
	"do-not-disturb-outline": "minus-circle-outline",
	"pill-tablet-outline": "minus-circle-outline",
	"medicine-outline": "minus-circle-outline",
	"mma": "mixed-martial-arts",
	"glove": "mixed-martial-arts",
	"carbon-monoxide": "molecule-co",
	"gas-co": "molecule-co",
	"periodic-table-carbon-dioxide": "molecule-co2",
	"gas-co2": "molecule-co2",
	"desktop-windows": "monitor",
	"monitor-download": "monitor-arrow-down-variant",
	"monitor-mobile-phone": "monitor-cellphone",
	"monitor-smartphone": "monitor-cellphone",
	"important-devices": "monitor-cellphone-star",
	"monitor-mobile-phone-star": "monitor-cellphone-star",
	"monitor-smartphone-star": "monitor-cellphone-star",
	"monitor-cellphone-favorite": "monitor-cellphone-star",
	"monitors": "monitor-multiple",
	"monitor-clean": "monitor-shimmer",
	"monitor-crt": "monitor-small",
	"monitor-favorite": "monitor-star",
	"scooter": "moped",
	"vespa": "moped",
	"delivery-dining": "moped",
	"scooter-electric": "moped-electric",
	"vespa-electric": "moped-electric",
	"delivery-dining-electric": "moped-electric",
	"scooter-electric-outline": "moped-electric-outline",
	"vespa-electric-outline": "moped-electric-outline",
	"delivery-dining-electric-outline": "moped-electric-outline",
	"scooter-outline": "moped-outline",
	"vespa-outline": "moped-outline",
	"delivery-dining-outline": "moped-outline",
	"chemist": "mortar-pestle-plus",
	"local-pharmacy": "mortar-pestle-plus",
	"mortar-pestle": "mortar-pestle-plus",
	"islam": "star-crescent",
	"muslim": "mosque-outline",
	"breast-feed": "mother-nurse",
	"motion-detector": "motion-sensor",
	"motorcycle": "motorbike",
	"motorcycle-electric": "motorbike-electric",
	"motorcycle-off": "motorbike-off",
	"slate": "movie",
	"clapperboard": "movie",
	"film": "movie",
	"movie-creation": "movie-open-outline",
	"slate-check": "movie-check",
	"clapperboard-check": "movie-check",
	"film-check": "movie-check",
	"slate-check-outline": "movie-check-outline",
	"clapperboard-check-outline": "movie-check-outline",
	"film-check-outline": "movie-check-outline",
	"slate-cog": "movie-cog",
	"clapperboard-cog": "movie-cog",
	"film-cog": "movie-cog",
	"slate-cog-outline": "movie-cog-outline",
	"clapperboard-cog-outline": "movie-cog-outline",
	"film-cog-outline": "movie-cog-outline",
	"slate-edit": "movie-edit",
	"clapperboard-edit": "movie-edit",
	"film-edit": "movie-edit",
	"slate-edit-outline": "movie-edit-outline",
	"clapperboard-edit-outline": "movie-edit-outline",
	"film-edit-outline": "movie-edit-outline",
	"slate-minus": "movie-minus",
	"clapperboard-minus": "movie-minus",
	"film-minus": "movie-minus",
	"slate-minus-outline": "movie-minus-outline",
	"clapperboard-minus-outline": "movie-minus-outline",
	"film-minus-outline": "movie-minus-outline",
	"slate-off": "movie-off",
	"clapperboard-off": "movie-off",
	"film-off": "movie-off",
	"slate-off-outline": "movie-off-outline",
	"clapperboard-off-outline": "movie-off-outline",
	"film-off-outline": "movie-off-outline",
	"slate-open": "movie-open",
	"clapperboard-open": "movie-open",
	"film-open": "movie-open",
	"slate-open-check": "movie-open-check",
	"clapperboard-open-check": "movie-open-check",
	"film-open-check": "movie-open-check",
	"slate-open-check-outline": "movie-open-check-outline",
	"clapperboard-open-check-outline": "movie-open-check-outline",
	"film-open-check-outline": "movie-open-check-outline",
	"slate-open-cog": "movie-open-cog",
	"clapperboard-open-cog": "movie-open-cog",
	"film-open-cog": "movie-open-cog",
	"slate-open-cog-outline": "movie-open-cog-outline",
	"clapperboard-open-cog-outline": "movie-open-cog-outline",
	"film-open-cog-outline": "movie-open-cog-outline",
	"slate-open-edit": "movie-open-edit",
	"clapperboard-open-edit": "movie-open-edit",
	"film-open-edit": "movie-open-edit",
	"slate-open-edit-outline": "movie-open-edit-outline",
	"clapperboard-open-edit-outline": "movie-open-edit-outline",
	"film-open-edit-outline": "movie-open-edit-outline",
	"slate-open-minus": "movie-open-minus",
	"clapperboard-open-minus": "movie-open-minus",
	"film-open-minus": "movie-open-minus",
	"slate-open-minus-outline": "movie-open-minus-outline",
	"clapperboard-open-minus-outline": "movie-open-minus-outline",
	"film-open-minus-outline": "movie-open-minus-outline",
	"slate-open-off": "movie-open-off",
	"clapperboard-open-off": "movie-open-off",
	"film-open-off": "movie-open-off",
	"slate-open-off-outline": "movie-open-off-outline",
	"clapperboard-open-off-outline": "movie-open-off-outline",
	"film-open-off-outline": "movie-open-off-outline",
	"slate-open-outline": "movie-open-outline",
	"clapperboard-open-outline": "movie-open-outline",
	"film-open-outline": "movie-open-outline",
	"slate-open-play": "movie-open-play",
	"clapperboard-open-play": "movie-open-play",
	"film-open-play": "movie-open-play",
	"slate-open-play-outline": "movie-open-play-outline",
	"clapperboard-open-play-outline": "movie-open-play-outline",
	"film-open-play-outline": "movie-open-play-outline",
	"clapperboard-open-plus": "movie-open-plus",
	"slate-open-plus": "movie-open-plus",
	"flim-open-plus": "movie-open-plus",
	"slate-open-plus-outline": "movie-open-plus-outline",
	"clapperboard-open-plus-outline": "movie-open-plus-outline",
	"film-open-plus-outline": "movie-open-plus-outline",
	"slate-open-remove": "movie-open-remove",
	"clapperboard-open-remove": "movie-open-remove",
	"film-open-remove": "movie-open-remove",
	"slate-open-remove-outline": "movie-open-remove-outline",
	"clapperboard-open-remove-outline": "movie-open-remove-outline",
	"film-open-remove-outline": "movie-open-remove-outline",
	"slate-open-settings": "movie-open-settings",
	"clapperboard-open-settings": "movie-open-settings",
	"film-open-settings": "movie-open-settings",
	"slate-open-settings-outline": "movie-open-settings-outline",
	"clapperboard-open-settings-outline": "movie-open-settings-outline",
	"film-open-settings-outline": "movie-open-settings-outline",
	"slate-open-star": "movie-open-star",
	"clapperboard-open-star": "movie-open-star",
	"film-open-star": "movie-open-star",
	"movie-open-favorite": "movie-open-star",
	"slate-open-star-outline": "movie-open-star-outline",
	"clapperboard-open-star-outline": "movie-open-star-outline",
	"film-open-star-outline": "movie-open-star-outline",
	"movie-open-favorite-outline": "movie-open-star-outline",
	"slate-outline": "movie-outline",
	"clapperboard-outline": "movie-outline",
	"film-outline": "movie-outline",
	"slate-play": "movie-play",
	"clapperboard-play": "movie-play",
	"film-play": "movie-play",
	"slate-play-outline": "movie-play-outline",
	"clapperboard-play-outline": "movie-play-outline",
	"film-play-outline": "movie-play-outline",
	"slate-plus": "movie-plus",
	"clapperboard-plus": "movie-plus",
	"film-plus": "movie-plus",
	"slate-plus-outline": "movie-plus-outline",
	"clapperboard-plus-outline": "movie-plus-outline",
	"film-plus-outline": "movie-plus-outline",
	"slate-remove": "movie-remove",
	"clapperboard-remove": "movie-remove",
	"film-remove": "movie-remove",
	"slate-remove-outline": "movie-remove-outline",
	"clapperboard-remove-outline": "movie-remove-outline",
	"film-remove-outline": "movie-remove-outline",
	"film-reel": "movie-roll",
	"slate-settings": "movie-settings",
	"clapperboard-settings": "movie-settings",
	"film-settings": "movie-settings",
	"slate-settings-outline": "movie-settings-outline",
	"clapperboard-settings-outline": "movie-settings-outline",
	"film-settings-outline": "movie-settings-outline",
	"slate-star": "movie-star",
	"clapperboard-star": "movie-star",
	"film-star": "movie-star",
	"movie-favorite": "movie-star",
	"slate-star-outline": "movie-star-outline",
	"clapperboard-star-outline": "movie-star-outline",
	"film-star-outline": "movie-star-outline",
	"movie-favorite-outline": "movie-star-outline",
	"multiplex": "multicast",
	"broadcast": "multicast",
	"audio": "volume-medium",
	"video": "multimedia",
	"image": "multimedia",
	"music": "multimedia",
	"movie": "multimedia",
	"picture": "multimedia",
	"fungus": "mushroom",
	"fungus-outline": "mushroom-outline",
	"library-music": "music-box-multiple",
	"library-music-outline": "music-box-multiple-outline",
	"note-circle": "music-circle",
	"note-circle-outline": "music-circle-outline",
	"music-c-clef": "music-clef-alto",
	"music-clef-tenor": "music-clef-alto",
	"music-clef-soprano": "music-clef-alto",
	"music-clef-baritone": "music-clef-alto",
	"music-f-clef": "music-clef-bass",
	"music-g-clef": "music-clef-treble",
	"music-note-add": "music-note-plus",
	"network-attached-storage": "nas",
	"arrow-compass": "navigation",
	"syringe": "needle",
	"injection": "needle",
	"shot": "needle",
	"drug": "pill",
	"immunization": "needle",
	"syringe-off": "needle-off",
	"injection-off": "needle-off",
	"medicine-off": "pill-off",
	"shot-off": "needle-off",
	"drug-off": "pill-off",
	"immunization-off": "needle-off",
	"pharmaceutical-off": "pill-off",
	"network-point-of-sale": "network-pos",
	"network-cash-box": "network-pos",
	"network-strength-1-warning": "network-strength-1-alert",
	"network-strength-2-warning": "network-strength-2-alert",
	"network-strength-3-warning": "network-strength-3-alert",
	"network-strength-4-warning": "network-strength-4-alert",
	"network-strength-4-settings": "network-strength-4-cog",
	"data-settings": "network-strength-4-cog",
	"network-strength-0": "network-strength-outline",
	"fiber-new": "new-box",
	"near-field-communication": "nfc",
	"near-field-communication-tap": "nfc-tap",
	"near-field-communication-variant": "nfc-variant",
	"near-field-communication-off": "nfc-variant-off",
	"nintendo-switch-online": "nintendo-switch",
	"nintendo-wii": "nintendo-wii",
	"nintendo-wiiu": "nintendo-wiiu",
	"food-ramen": "noodles",
	"asian-noodles": "noodles",
	"sticky-note": "note",
	"post-it-note": "note",
	"paper-alert": "note-alert",
	"sticky-note-alert": "note-alert",
	"post-it-note-alert": "note-alert",
	"paper-alert-outline": "note-alert-outline",
	"post-it-note-alert-outline": "note-alert-outline",
	"sticky-note-alert-outline": "note-alert-outline",
	"paper-check": "note-check",
	"sticky-note-check": "note-check",
	"post-it-note-check": "note-check",
	"paper-check-outline": "note-check-outline",
	"sticky-note-check-outline": "note-check-outline",
	"post-it-note-check-outline": "note-check-outline",
	"paper-edit": "note-edit",
	"sticky-note-edit": "note-edit",
	"post-it-note-edit": "note-edit",
	"paper-edit-outline": "note-edit-outline",
	"sticky-note-edit-outline": "note-edit-outline",
	"post-it-note-edit-outline": "note-edit-outline",
	"paper-minus": "note-minus",
	"sticky-note-minus": "note-minus",
	"post-it-note-minus": "note-minus",
	"paper-minus-outline": "note-minus-outline",
	"sticky-note-minus-outline": "note-minus-outline",
	"post-it-note-minus-outline": "note-minus-outline",
	"notes": "text",
	"papers": "note-multiple",
	"sticky-notes": "note-multiple",
	"post-it-notes": "note-multiple",
	"notes-outline": "note-multiple-outline",
	"papers-outline": "note-multiple-outline",
	"sticky-notes-outline": "note-multiple-outline",
	"post-it-notes-outline": "note-multiple-outline",
	"paper-off": "note-off",
	"sticky-note-off": "note-off",
	"post-it-note-off": "note-off",
	"paper-off-outline": "note-off-outline",
	"sticky-note-off-outline": "note-off-outline",
	"post-it-note-off-outline": "note-off-outline",
	"sticky-note-outline": "note-outline",
	"post-it-note-outline": "note-outline",
	"paper-plus": "note-plus",
	"paper-add": "note-plus",
	"sticky-note-plus": "note-plus",
	"sticky-note-add": "note-plus",
	"post-it-note-plus": "note-plus",
	"post-it-note-add": "note-plus",
	"note-add-outline": "note-plus-outline",
	"paper-plus-outline": "note-plus-outline",
	"paper-add-outline": "note-plus-outline",
	"sticky-note-plus-outline": "note-plus-outline",
	"sticky-note-add-outline": "note-plus-outline",
	"post-it-note-plus-outline": "note-plus-outline",
	"post-it-note-add-outline": "note-plus-outline",
	"paper-remove": "note-remove",
	"sticky-note-remove": "note-remove",
	"post-it-note-remove": "note-remove",
	"paper-search": "note-search",
	"sticky-note-search": "note-search",
	"post-it-note-search": "note-search",
	"paper-search-outline": "note-search-outline",
	"sticky-note-search-outline": "note-search-outline",
	"post-it-note-search-outline": "note-search-outline",
	"paper-text": "note-text",
	"sticky-note-text": "note-text",
	"post-it-note-text": "note-text",
	"paper-text-outline": "note-text-outline",
	"sticky-note-text-outline": "note-text-outline",
	"post-it-note-text-outline": "note-text-outline",
	"journal": "notebook",
	"planner": "notebook",
	"diary": "notebook",
	"notebook-favorite": "notebook-heart",
	"notebook-love": "notebook-heart",
	"notebook-favorite-outline": "notebook-heart-outline",
	"notebook-love-outline": "notebook-heart-outline",
	"journal-multiple": "notebook-multiple",
	"planner-multiple": "notebook-multiple",
	"journal-outline": "notebook-outline",
	"planner-outline": "notebook-outline",
	"nuclear": "nuke",
	"atomic-bomb": "nuke",
	"1-2-3": "numeric",
	"one-two-three": "numeric",
	"number-0": "numeric-0",
	"numeric-zero": "numeric-0",
	"numeric-zero-box": "numeric-0-box",
	"number-0-box": "numeric-0-box",
	"numeric-zero-box-multiple-outline": "numeric-0-box-multiple-outline",
	"numeric-0-boxes-outline": "numeric-0-box-multiple-outline",
	"number-0-box-multiple-outline": "numeric-0-box-multiple-outline",
	"numeric-zero-box-outline": "numeric-0-box-outline",
	"number-0-box-outline": "numeric-0-box-outline",
	"numeric-zero-circle": "numeric-0-circle",
	"number-0-circle": "numeric-0-circle",
	"number-zero-circle": "numeric-0-circle",
	"numeric-zero-circle-outline": "numeric-0-circle-outline",
	"number-0-circle-outline": "numeric-0-circle-outline",
	"number-zero-circle-outline": "numeric-0-circle-outline",
	"number-1": "numeric-1",
	"numeric-one": "numeric-1",
	"looks-one": "numeric-1-box",
	"numeric-one-box": "numeric-1-box",
	"number-1-box": "numeric-1-box",
	"filter-1": "numeric-1-box-multiple-outline",
	"numeric-one-box-multiple-outline": "numeric-1-box-multiple-outline",
	"numeric-1-boxes-outline": "numeric-1-box-multiple-outline",
	"number-1-box-multiple-outline": "numeric-1-box-multiple-outline",
	"numeric-one-box-outline": "numeric-1-box-outline",
	"number-1-box-outline": "numeric-1-box-outline",
	"numeric-one-circle": "numeric-1-circle",
	"number-1-circle": "numeric-1-circle",
	"number-one-circle": "numeric-1-circle",
	"numeric-one-circle-outline": "numeric-1-circle-outline",
	"number-1-circle-outline": "numeric-1-circle-outline",
	"number-one-circle-outline": "numeric-1-circle-outline",
	"number-2": "numeric-2",
	"numeric-two": "numeric-2",
	"looks-two": "numeric-2-box",
	"numeric-two-box": "numeric-2-box",
	"number-2-box": "numeric-2-box",
	"filter-2": "numeric-2-box-multiple-outline",
	"numeric-two-box-multiple-outline": "numeric-2-box-multiple-outline",
	"numeric-2-boxes-outline": "numeric-2-box-multiple-outline",
	"number-2-box-multiple-outline": "numeric-2-box-multiple-outline",
	"numeric-two-box-outline": "numeric-2-box-outline",
	"number-2-box-outline": "numeric-2-box-outline",
	"numeric-two-circle": "numeric-2-circle",
	"number-2-circle": "numeric-2-circle",
	"number-two-circle": "numeric-2-circle",
	"numeric-two-circle-outline": "numeric-2-circle-outline",
	"number-2-circle-outline": "numeric-2-circle-outline",
	"number-two-circle-outline": "numeric-2-circle-outline",
	"number-3": "numeric-3",
	"numeric-three": "numeric-3",
	"looks-3": "numeric-3-box",
	"numeric-three-box": "numeric-3-box",
	"number-3-box": "numeric-3-box",
	"filter-3": "numeric-3-box-multiple-outline",
	"numeric-three-box-multiple-outline": "numeric-3-box-multiple-outline",
	"numeric-3-boxes-outline": "numeric-3-box-multiple-outline",
	"number-3-box-multiple-outline": "numeric-3-box-multiple-outline",
	"numeric-three-box-outline": "numeric-3-box-outline",
	"number-3-box-outline": "numeric-3-box-outline",
	"numeric-three-circle": "numeric-3-circle",
	"number-3-circle": "numeric-3-circle",
	"number-three-circle": "numeric-3-circle",
	"numeric-three-circle-outline": "numeric-3-circle-outline",
	"number-3-circle-outline": "numeric-3-circle-outline",
	"number-three-circle-outline": "numeric-3-circle-outline",
	"number-4": "numeric-4",
	"numeric-four": "numeric-4",
	"looks-4": "numeric-4-box",
	"numeric-four-box": "numeric-4-box",
	"number-4-box": "numeric-4-box",
	"filter-4": "numeric-4-box-multiple-outline",
	"numeric-four-box-multiple-outline": "numeric-4-box-multiple-outline",
	"numeric-4-boxes-outline": "numeric-4-box-multiple-outline",
	"number-4-box-multiple-outline": "numeric-4-box-multiple-outline",
	"numeric-four-box-outline": "numeric-4-box-outline",
	"number-4-box-outline": "numeric-4-box-outline",
	"numeric-four-circle": "numeric-4-circle",
	"number-4-circle": "numeric-4-circle",
	"number-four-circle": "numeric-4-circle",
	"numeric-four-circle-outline": "numeric-4-circle-outline",
	"number-4-circle-outline": "numeric-4-circle-outline",
	"number-four-circle-outline": "numeric-4-circle-outline",
	"number-5": "numeric-5",
	"numeric-five": "numeric-5",
	"looks-5": "numeric-5-box",
	"numeric-five-box": "numeric-5-box",
	"number-5-box": "numeric-5-box",
	"filter-5": "numeric-5-box-multiple-outline",
	"numeric-five-box-multiple-outline": "numeric-5-box-multiple-outline",
	"numeric-5-boxes-outline": "numeric-5-box-multiple-outline",
	"number-5-box-multiple-outline": "numeric-5-box-multiple-outline",
	"numeric-five-box-outline": "numeric-5-box-outline",
	"number-5-box-outline": "numeric-5-box-outline",
	"numeric-five-circle": "numeric-5-circle",
	"number-5-circle": "numeric-5-circle",
	"number-five-circle": "numeric-5-circle",
	"numeric-five-circle-outline": "numeric-5-circle-outline",
	"number-5-circle-outline": "numeric-5-circle-outline",
	"number-five-circle-outline": "numeric-5-circle-outline",
	"number-6": "numeric-6",
	"numeric-six": "numeric-6",
	"looks-6": "numeric-6-box",
	"numeric-six-box": "numeric-6-box",
	"number-6-box": "numeric-6-box",
	"filter-6": "numeric-6-box-multiple-outline",
	"numeric-six-box-multiple-outline": "numeric-6-box-multiple-outline",
	"numeric-6-boxes-outline": "numeric-6-box-multiple-outline",
	"number-6-box-multiple-outline": "numeric-6-box-multiple-outline",
	"numeric-six-box-outline": "numeric-6-box-outline",
	"number-6-box-outline": "numeric-6-box-outline",
	"numeric-six-circle": "numeric-6-circle",
	"number-6-circle": "numeric-6-circle",
	"number-six-circle": "numeric-6-circle",
	"numeric-six-circle-outline": "numeric-6-circle-outline",
	"number-6-circle-outline": "numeric-6-circle-outline",
	"number-six-circle-outline": "numeric-6-circle-outline",
	"number-7": "numeric-7",
	"numeric-seven": "numeric-7",
	"numeric-seven-box": "numeric-7-box",
	"number-7-box": "numeric-7-box",
	"filter-7": "numeric-7-box-multiple-outline",
	"numeric-seven-box-multiple-outline": "numeric-7-box-multiple-outline",
	"numeric-7-boxes-outline": "numeric-7-box-multiple-outline",
	"number-7-box-multiple-outline": "numeric-7-box-multiple-outline",
	"numeric-seven-box-outline": "numeric-7-box-outline",
	"number-7-box-outline": "numeric-7-box-outline",
	"numeric-seven-circle": "numeric-7-circle",
	"number-7-circle": "numeric-7-circle",
	"number-seven-circle": "numeric-7-circle",
	"numeric-seven-circle-outline": "numeric-7-circle-outline",
	"number-7-circle-outline": "numeric-7-circle-outline",
	"number-seven-circle-outline": "numeric-7-circle-outline",
	"number-8": "numeric-8",
	"numeric-eight": "numeric-8",
	"numeric-eight-box": "numeric-8-box",
	"number-8-box": "numeric-8-box",
	"filter-8": "numeric-8-box-multiple-outline",
	"numeric-eight-box-multiple-outline": "numeric-8-box-multiple-outline",
	"numeric-8-boxes-outline": "numeric-8-box-multiple-outline",
	"number-8-box-multiple-outline": "numeric-8-box-multiple-outline",
	"numeric-eight-box-outline": "numeric-8-box-outline",
	"number-8-box-outline": "numeric-8-box-outline",
	"numeric-eight-circle": "numeric-8-circle",
	"number-8-circle": "numeric-8-circle",
	"number-eight-circle": "numeric-8-circle",
	"numeric-eight-circle-outline": "numeric-8-circle-outline",
	"number-8-circle-outline": "numeric-8-circle-outline",
	"number-eight-circle-outline": "numeric-8-circle-outline",
	"number-9": "numeric-9",
	"numeric-nine": "numeric-9",
	"numeric-nine-box": "numeric-9-box",
	"number-9-box": "numeric-9-box",
	"filter-9": "numeric-9-box-multiple-outline",
	"numeric-nine-box-multiple-outline": "numeric-9-box-multiple-outline",
	"numeric-9-boxes-outline": "numeric-9-box-multiple-outline",
	"number-9-box-multiple-outline": "numeric-9-box-multiple-outline",
	"numeric-nine-box-outline": "numeric-9-box-outline",
	"number-9-box-outline": "numeric-9-box-outline",
	"numeric-nine-circle": "numeric-9-circle",
	"number-9-circle": "numeric-9-circle",
	"number-nine-circle": "numeric-9-circle",
	"numeric-nine-circle-outline": "numeric-9-circle-outline",
	"number-9-circle-outline": "numeric-9-circle-outline",
	"number-nine-circle-outline": "numeric-9-circle-outline",
	"numeric-nine-plus-box": "numeric-9-plus-box",
	"number-9-plus-box": "numeric-9-plus-box",
	"filter-9-plus": "numeric-9-plus-box-multiple-outline",
	"numeric-nine-plus-box-multiple-outline": "numeric-9-plus-box-multiple-outline",
	"numeric-9-plus-boxes-outline": "numeric-9-plus-box-multiple-outline",
	"number-9-plus-box-multiple-outline": "numeric-9-plus-box-multiple-outline",
	"numeric-nine-plus-box-outline": "numeric-9-plus-box-outline",
	"number-9-plus-box-outline": "numeric-9-plus-box-outline",
	"numeric-nine-plus-circle": "numeric-9-plus-circle",
	"number-9-plus-circle": "numeric-9-plus-circle",
	"number-nine-plus-circle": "numeric-9-plus-circle",
	"numeric-nine-plus-circle-outline": "numeric-9-plus-circle-outline",
	"number-9-plus-circle-outline": "numeric-9-plus-circle-outline",
	"number-nine-plus-circle-outline": "numeric-9-plus-circle-outline",
	"decrement": "numeric-negative-1",
	"minus-one": "numeric-negative-1",
	"numbers-off": "numeric-off",
	"123-off": "numeric-off",
	"one-two-three-off": "numeric-off",
	"increment": "numeric-positive-1",
	"plus-one": "numeric-positive-1",
	"open-container-initiative": "oci",
	"optical-character-recognition": "ocr",
	"stop": "octagon",
	"stop-outline": "octagon-outline",
	"starburst-edit": "octagram-edit",
	"starburst-edit-outline": "octagram-edit-outline",
	"starburst-plus": "octagram-plus",
	"starburst-minus-outline": "octagram-minus-outline",
	"ok-ru": "odnoklassniki",
	"office-building-settings": "office-building-cog",
	"office-building-settings-outline": "office-building-cog-outline",
	"office-building-location": "office-building-marker",
	"office-building-location-outline": "office-building-marker-outline",
	"wish": "oil-lamp",
	"genie-lamp": "oil-lamp",
	"religion-hindu": "om",
	"hinduism": "om",
	"ohm": "omega",
	"electrical-resistance": "omega",
	"1up": "one-up",
	"extra-life": "one-up",
	"1password": "onepassword",
	"open-in-browser": "open-in-app",
	"external-link": "open-in-new",
	"camera-flip": "orbit-variant",
	"order-checkbox-ascending": "order-bool-ascending-variant",
	"order-checkbox-descending": "order-bool-descending",
	"outdoor-light": "outdoor-lamp",
	"fullscreen": "overscan",
	"package-delivered": "package-check",
	"archive": "package-down",
	"box-down": "package-down",
	"unarchive": "package-up",
	"box-up": "package-up",
	"box-variant": "package-variant",
	"box-variant-closed": "package-variant-closed",
	"package-variant-closed-delivered": "package-variant-closed-check",
	"package-variant-closed-subtract": "package-variant-closed-minus",
	"box-variant-closed-minus": "package-variant-closed-minus",
	"box-variant-closed-subtract": "package-variant-closed-minus",
	"box-variant-closed-plus": "package-variant-closed-plus",
	"package-variant-closed-add": "package-variant-closed-plus",
	"box-variant-closed-add": "package-variant-closed-plus",
	"box-variant-closed-remove": "package-variant-closed-remove",
	"box-variant-minus": "package-variant-minus",
	"package-variant-subtract": "package-variant-minus",
	"box-variant-subtract": "package-variant-minus",
	"box-variant-plus": "package-variant-plus",
	"package-variant-add": "package-variant-plus",
	"box-variant-add": "package-variant-plus",
	"box-variant-remove": "package-variant-remove",
	"first-page": "page-first",
	"chevron-left-first": "page-first",
	"last-page": "page-last",
	"chevron-right-last": "page-last",
	"page-layout-marginals": "page-layout-header-footer",
	"read-more": "page-next",
	"read-more-outline": "page-next-outline",
	"bucket": "pail",
	"bucket-minus": "pail-minus",
	"bucket-minus-outline": "pail-minus-outline",
	"bucket-off": "pail-off",
	"bucket-off-outline": "pail-off-outline",
	"bucket-outline": "pail-outline",
	"bucket-plus": "pail-plus",
	"bucket-plus-outline": "pail-plus-outline",
	"bucket-remove": "pail-remove",
	"bucket-remove-outline": "pail-remove-outline",
	"color-lens": "palette",
	"colour-lens": "palette",
	"art": "palette",
	"color": "palette",
	"paint-outline": "palette-swatch-outline",
	"style": "palette-swatch-variant",
	"material": "palette-swatch-variant",
	"style-outline": "palette-swatch-outline",
	"pan-down-left": "pan-bottom-left",
	"pan-down-right": "pan-bottom-right",
	"pan-up-left": "pan-top-left",
	"pan-up-right": "pan-top-right",
	"emoji-panda": "panda",
	"emoticon-panda": "panda",
	"panorama-fish-eye": "panorama-fisheye",
	"panorama-360": "panorama-sphere",
	"panorama-360-outline": "panorama-sphere-outline",
	"panorama-vr": "panorama-variant",
	"image-vr": "panorama-variant",
	"picture-vr": "panorama-variant",
	"picture-360": "panorama-variant",
	"image-360": "panorama-variant",
	"panorama-vr-outline": "panorama-variant-outline",
	"image-vr-outline": "panorama-variant-outline",
	"picture-vr-outline": "panorama-variant-outline",
	"picture-360-outline": "panorama-variant-outline",
	"image-360-outline": "panorama-variant-outline",
	"lavatory-roll": "paper-roll",
	"bathroom-tissue": "paper-roll",
	"toilet-paper": "paper-roll",
	"kitchen-roll": "paper-roll",
	"paper-towels": "paper-roll",
	"receipt-roll": "paper-roll",
	"lavatory-roll-outline": "paper-roll-outline",
	"bathroom-tissue-outline": "paper-roll-outline",
	"kitchen-roll-outline": "paper-roll-outline",
	"paper-towels-outline": "paper-roll-outline",
	"toilet-paper-outline": "paper-roll-outline",
	"receipt-roll-outline": "paper-roll-outline",
	"attachment-vertical": "paperclip",
	"attach-file": "paperclip",
	"attachment-check": "paperclip-check",
	"attachment-lock": "paperclip-lock",
	"attachment-minus": "paperclip-minus",
	"attachment-off": "paperclip-off",
	"attachment-plus": "paperclip-plus",
	"attachment-remove": "paperclip-remove",
	"parasail": "paragliding",
	"paraglide": "paragliding",
	"car-park": "parking",
	"local-parking": "parking",
	"celebration": "party-popper",
	"passport-electronic": "passport-biometric",
	"food-italian": "pasta",
	"spaghetti": "pasta",
	"pause-circle-filled": "pause-circle",
	"stop-pause": "pause-octagon",
	"stop-pause-outline": "pause-octagon-outline",
	"pets": "paw",
	"allergen": "peanut",
	"food-allergy": "peanut",
	"allergen-off": "peanut-off",
	"food-allergy-off": "peanut-off",
	"allergen-off-outline": "peanut-off-outline",
	"food-allergy-off-outline": "peanut-off-outline",
	"allergen-outline": "peanut-outline",
	"food-allergy-outline": "peanut-outline",
	"pen-add": "pen-plus",
	"edit": "pencil",
	"create": "pencil",
	"mode-edit": "pencil",
	"edit-box": "pencil-box",
	"library-edit": "pencil-box-multiple",
	"library-edit-outline": "pencil-box-multiple-outline",
	"edit-box-outline": "pencil-box-outline",
	"edit-circle": "pencil-circle",
	"edit-circle-outline": "pencil-circle-outline",
	"edit-off": "pencil-off",
	"edit-off-outline": "pencil-off-outline",
	"edit-outline": "pencil-outline",
	"create-outline": "pencil-outline",
	"mode-edit-outline": "pencil-outline",
	"pencil-add": "pencil-plus",
	"pencil-add-outline": "pencil-plus-outline",
	"design": "pencil-ruler",
	"emoji-penguin": "penguin",
	"emoticon-penguin": "penguin",
	"linux": "penguin",
	"discount-box": "percent-box",
	"sale-box": "percent-box",
	"discount-box-outline": "percent-box-outline",
	"sale-box-outline": "percent-box-outline",
	"discount-circle": "percent-circle",
	"sale-circle": "percent-circle",
	"discount-circle-outline": "percent-circle-outline",
	"sale-circle-outline": "percent-circle-outline",
	"discount-outline": "sale-outline",
	"sale-outline": "percent-outline",
	"perspective-decrease": "perspective-less",
	"perspective-increase": "perspective-more",
	"acid": "ph",
	"base": "ph",
	"potential-of-hydrogen": "ph",
	"power-of-hydrogen": "ph",
	"call": "phone",
	"local-phone": "phone",
	"telephone": "phone",
	"phone-bluetooth-speaker": "phone-bluetooth",
	"telephone-bluetooth": "phone-bluetooth",
	"phone-block": "phone-cancel",
	"phone-schedule": "phone-clock",
	"phone-time": "phone-clock",
	"phone-keypad": "phone-dial",
	"phone-keypad-outline": "phone-dial-outline",
	"phone-forwarded": "phone-forward",
	"telephone-forward": "phone-forward",
	"call-end": "phone-hangup",
	"telephone-hangup": "phone-hangup",
	"telephone-in-talk": "phone-in-talk",
	"telephone-in-talk-outline": "phone-in-talk-outline",
	"telephone-incoming": "phone-incoming",
	"telephone-locked": "phone-lock",
	"phone-locked": "phone-lock",
	"telephone-lock": "phone-lock",
	"telephone-outline": "phone-outline",
	"call-outline": "phone-outline",
	"add-call": "phone-plus",
	"phone-redial": "phone-sync",
	"phone-redial-outline": "phone-sync-outline",
	"settings-phone": "phone-settings",
	"emoji-pig": "pig",
	"emoticon-pig": "pig",
	"capsule": "pill",
	"medication": "pill-multiple",
	"drugs": "pill-multiple",
	"capsule-off": "pill-off",
	"historic": "pillar",
	"column": "pillar",
	"keep": "pin",
	"keep-off": "pin-off",
	"keep-off-outline": "pin-off-outline",
	"keep-outline": "pin-outline",
	"forest": "pine-tree",
	"wildfire": "pine-tree-fire",
	"controlled-burn": "pine-tree-fire",
	"toys": "pinwheel",
	"toys-outline": "pinwheel-outline",
	"monkey-wrench": "pipe-wrench",
	"gun": "pistol",
	"pizzeria": "pizza",
	"local-pizza": "pizza",
	"airport-shuttle": "plane-train",
	"airport-taxi": "plane-car",
	"airplane-car": "plane-car",
	"airplane-train": "plane-train",
	"play-arrow": "play",
	"slideshow": "play-box-outline",
	"play-circle-filled": "play-circle",
	"media-network": "play-network",
	"media-network-outline": "play-network-outline",
	"subscriptions": "playlist-check",
	"playlist-add-check": "playlist-check",
	"playlist-tick": "playlist-check",
	"playlist-note": "playlist-music",
	"queue-music": "playlist-music",
	"playlist-note-outline": "playlist-music-outline",
	"queue-music-outline": "playlist-music-outline",
	"playlist-add": "playlist-plus",
	"playlist-favorite": "playlist-star",
	"add": "plus",
	"add-box": "plus-box",
	"add-to-photos": "plus-box-multiple",
	"library-add": "plus-box-multiple",
	"queue": "tray-remove",
	"library-plus": "plus-box-multiple",
	"add-circle": "plus-circle",
	"coins-plus": "plus-circle-multiple",
	"control-point-duplicate": "plus-circle-multiple-outline",
	"plus-circles-outline": "plus-circle-multiple-outline",
	"coins-plus-outline": "plus-circle-multiple-outline",
	"add-circle-outline": "plus-circle-outline",
	"control-point": "plus-circle-outline",
	"circles-add": "plus-circle-outline",
	"plus-secure": "plus-lock",
	"add-network": "plus-network",
	"add-network-outline": "plus-network-outline",
	"add-thick": "plus-thick",
	"add-bold": "plus-thick",
	"plus-bold": "plus-thick",
	"podium-third": "podium-bronze",
	"podium-first": "podium-gold",
	"podium-second": "podium-silver",
	"casino-chip": "poker-chip",
	"gambling-chip": "poker-chip",
	"bar-chart": "poll",
	"performance": "poll",
	"analytics": "poll",
	"swimming-pool": "pool",
	"pool-temperature": "pool-thermometer",
	"blog": "post",
	"post-light": "post-lamp",
	"blog-outline": "post-outline",
	"hashtag": "pound",
	"hashtag-box": "pound-box",
	"hashtag-box-outline": "pound-box-outline",
	"power-settings-new": "power",
	"shutdown": "power",
	"battery-backup": "power-plug-battery",
	"battery-backup-outline": "power-plug-battery-outline",
	"power-off": "power-plug-off",
	"settings-power": "power-settings",
	"plug-socket": "power-socket",
	"plug-socket-au": "power-socket-au",
	"power-socket-type-i": "power-socket-au",
	"power-socket-cn": "power-socket-au",
	"power-socket-ar": "power-socket-au",
	"power-socket-nz": "power-socket-au",
	"power-socket-pg": "power-socket-au",
	"power-socket-australia": "power-socket-au",
	"power-socket-china": "power-socket-au",
	"power-socket-argentina": "power-socket-au",
	"power-socket-new-zealand": "power-socket-au",
	"power-socket-papua-new-guinea": "power-socket-au",
	"plug-socket-ch": "power-socket-ch",
	"power-socket-type-j": "power-socket-ch",
	"plug-socket-type-j": "power-socket-ch",
	"power-socket-switzerland": "power-socket-ch",
	"plug-socket-switzerland": "power-socket-ch",
	"plug-socket-eu": "power-socket-eu",
	"power-socket-europe": "power-socket-eu",
	"plug-socket-uk": "power-socket-uk",
	"power-socket-type-g": "power-socket-uk",
	"power-socket-ie": "power-socket-uk",
	"power-socket-hk": "power-socket-uk",
	"power-socket-my": "power-socket-uk",
	"power-socket-cy": "power-socket-uk",
	"power-socket-mt": "power-socket-uk",
	"power-socket-sg": "power-socket-uk",
	"power-socket-united-kingdom": "power-socket-uk",
	"power-socket-ireland": "power-socket-uk",
	"power-socket-hong-kong": "power-socket-uk",
	"power-socket-malaysia": "power-socket-uk",
	"power-socket-cyprus": "power-socket-uk",
	"power-socket-malta": "power-socket-uk",
	"power-socket-singapore": "power-socket-uk",
	"plug-socket-us": "power-socket-us",
	"power-socket-ca": "power-socket-us",
	"power-socket-mx": "power-socket-us",
	"power-socket-type-b": "power-socket-us",
	"power-socket-united-states": "power-socket-us",
	"power-socket-japan": "power-socket-us",
	"power-socket-canada": "power-socket-us",
	"power-socket-mexico": "power-socket-us",
	"local-printshop": "printer",
	"local-print-shop": "printer",
	"printer-warning": "printer-alert",
	"paper-jam": "printer-alert",
	"printer-preview": "printer-search",
	"printer-view": "printer-eye",
	"printer-point-of-sale": "printer-pos",
	"printer-receipt": "printer-pos",
	"printer-point-of-sale-alert": "printer-pos-alert",
	"printer-receipt-alert": "printer-pos-alert",
	"printer-point-of-sale-alert-outline": "printer-pos-alert-outline",
	"printer-receipt-alert-outline": "printer-pos-alert-outline",
	"printer-point-of-sale-cancel": "printer-pos-cancel",
	"printer-receipt-cancel": "printer-pos-cancel",
	"printer-point-of-sale-cancel-outline": "printer-pos-cancel-outline",
	"printer-receipt-cancel-outline": "printer-pos-cancel-outline",
	"printer-point-of-sale-check": "printer-pos-check",
	"printer-receipt-check": "printer-pos-check",
	"printer-point-of-sale-check-outline": "printer-pos-check-outline",
	"printer-receipt-check-outline": "printer-pos-check-outline",
	"printer-point-of-sale-cog": "printer-pos-cog",
	"printer-receipt-cog": "printer-pos-cog",
	"printer-point-of-sale-cog-outline": "printer-pos-cog-outline",
	"printer-receipt-cog-outline": "printer-pos-cog-outline",
	"printer-point-of-sale-edit": "printer-pos-edit",
	"printer-receipt-edit": "printer-pos-edit",
	"printer-point-of-sale-edit-outline": "printer-pos-edit-outline",
	"printer-receipt-edit-outline": "printer-pos-edit-outline",
	"printer-point-of-sale-minus": "printer-pos-minus",
	"printer-receipt-minus": "printer-pos-minus",
	"printer-point-of-sale-minus-outline": "printer-pos-minus-outline",
	"printer-receipt-minus-outline": "printer-pos-minus-outline",
	"printer-point-of-sale-network": "printer-pos-network",
	"printer-receipt-network": "printer-pos-network",
	"printer-point-of-sale-network-outline": "printer-pos-network-outline",
	"printer-receipt-network-outline": "printer-pos-network-outline",
	"printer-point-of-sale-off": "printer-pos-off",
	"printer-receipt-off": "printer-pos-off",
	"printer-point-of-sale-off-outline": "printer-pos-off-outline",
	"printer-receipt-off-outline": "printer-pos-off-outline",
	"printer-point-of-sale-outline": "printer-pos-outline",
	"printer-receipt-outline": "printer-pos-outline",
	"printer-point-of-sale-pause": "printer-pos-pause",
	"printer-receipt-pause": "printer-pos-pause",
	"printer-point-of-sale-pause-outline": "printer-pos-pause-outline",
	"printer-receipt-pause-outline": "printer-pos-pause-outline",
	"printer-point-of-sale-play": "printer-pos-play",
	"printer-receipt-play": "printer-pos-play",
	"printer-point-of-sale-play-outline": "printer-pos-play-outline",
	"printer-receipt-play-outline": "printer-pos-play-outline",
	"printer-point-of-sale-plus": "printer-pos-plus",
	"printer-receipt-plus": "printer-pos-plus",
	"printer-point-of-sale-plus-outline": "printer-pos-plus-outline",
	"printer-receipt-plus-outline": "printer-pos-plus-outline",
	"printer-point-of-sale-refresh": "printer-pos-refresh",
	"printer-receipt-refresh": "printer-pos-refresh",
	"printer-point-of-sale-refresh-outline": "printer-pos-refresh-outline",
	"printer-receipt-refresh-outline": "printer-pos-refresh-outline",
	"printer-point-of-sale-remove": "printer-pos-remove",
	"printer-receipt-remove": "printer-pos-remove",
	"printer-point-of-sale-remove-outline": "printer-pos-remove-outline",
	"printer-receipt-remove-outline": "printer-pos-remove-outline",
	"printer-point-of-sale-star": "printer-pos-star",
	"printer-receipt-star": "printer-pos-star",
	"printer-favorite": "printer-pos-star",
	"printer-primary": "printer-pos-star",
	"printer-point-of-sale-star-outline": "printer-pos-star-outline",
	"printer-receipt-star-outline": "printer-pos-star-outline",
	"printer-point-of-sale-stop": "printer-pos-stop",
	"printer-receipt-stop": "printer-pos-stop",
	"printer-point-of-sale-stop-outline": "printer-pos-stop-outline",
	"printer-receipt-stop-outline": "printer-pos-stop-outline",
	"printer-point-of-sale-sync": "printer-pos-sync",
	"printer-receipt-sync": "printer-pos-sync",
	"printer-point-of-sale-sync-outline": "printer-pos-sync-outline",
	"printer-receipt-sync-outline": "printer-pos-sync-outline",
	"printer-point-of-sale-wrench": "printer-pos-wrench",
	"printer-receipt-wrench": "printer-pos-wrench",
	"printer-point-of-sale-wrench-outline": "printer-pos-wrench-outline",
	"printer-receipt-wrench-outline": "printer-pos-wrench-outline",
	"printer-magnify": "printer-search",
	"low-priority": "priority-low",
	"progress-warning": "progress-alert",
	"progress-tick": "progress-check",
	"progress-auto": "progress-star-four-points",
	"progress-spanner": "progress-wrench",
	"publish-disabled": "publish-off",
	"vitals": "pulse",
	"extension": "toy-brick-search-outline",
	"jigsaw": "puzzle",
	"jigsaw-outline": "puzzle-outline",
	"extension-outline": "toy-brick-marker-outline",
	"puzzle-favorite": "puzzle-star",
	"puzzle-favorite-outline": "puzzle-star-outline",
	"drone": "quadcopter",
	"high-quality": "quality-high",
	"hq": "quality-high",
	"low-quality": "quality-low",
	"lq": "quality-low",
	"medium-quality": "quality-medium",
	"mq": "quality-medium",
	"bunny": "rabbit-variant",
	"hare": "rabbit-variant",
	"easter": "rabbit-variant",
	"cruelty-free": "rabbit-variant",
	"easter-outline": "rabbit-variant-outline",
	"bunny-outline": "rabbit-variant-outline",
	"hare-outline": "rabbit-variant-outline",
	"cruelty-free-outline": "rabbit-variant-outline",
	"lacrosse": "racquetball",
	"squash": "racquetball",
	"track-changes": "radar",
	"heater": "radiator",
	"heater-disabled": "radiator-disabled",
	"heater-off": "radiator-off",
	"radiation": "radioactive",
	"radiation-circle": "radioactive-circle",
	"radiation-circle-outline": "radioactive-circle-outline",
	"radiation-off": "radioactive-off",
	"radio-button-unchecked": "radiobox-blank",
	"radio-button-indeterminate": "radiobox-indeterminate-variant",
	"radiobox-intermediate-variant": "radiobox-indeterminate-variant",
	"radio-button-checked": "radiobox-marked",
	"x-ray-box": "radiology-box",
	"x-ray-box-outline": "radiology-box-outline",
	"circle-radius": "radius",
	"sphere-radius": "radius",
	"circle-radius-outline": "radius-outline",
	"sphere-radius-outline": "radius-outline",
	"railroad-crossing-light": "railroad-light",
	"train-crossing-light": "railroad-light",
	"level-crossing-signals": "railroad-light",
	"raspberrypi": "raspberry-pi",
	"cloth": "receipt",
	"fabric": "receipt",
	"swatch": "receipt",
	"receipt-pending": "receipt-clock-outline",
	"cloth-outline": "receipt-outline",
	"fabric-outline": "receipt-outline",
	"swatch-outline": "receipt-outline",
	"invoice-outline": "receipt-text-outline",
	"receipt-text-add": "receipt-text-plus-outline",
	"fiber-manual-record": "record",
	"arrow": "undo-variant",
	"loop": "sync",
	"auto-start": "refresh-auto",
	"automatic-start": "refresh-auto",
	"auto-stop": "refresh-auto",
	"automatic-stop": "refresh-auto",
	"automatic": "refresh-auto",
	"refresh-automatic": "refresh-auto",
	"regular-expression": "regex",
	"image-aspect-ratio": "relative-scale",
	"car-engine-start": "reload",
	"rotate-clockwise": "reload",
	"settings-remote": "remote",
	"repost": "repeat-variant",
	"repeat-one": "repeat-once",
	"twitter-retweet": "repeat-variant",
	"drag": "resize-bottom-right",
	"rotate-counter-clockwise": "restore",
	"fast-rewind": "rewind",
	"diamond": "rhombus",
	"diamond-outline": "rhombus-outline",
	"collection": "rhombus-split",
	"emoji-robot": "robot",
	"emoticon-robot": "robot",
	"emoji-robot-angry": "robot-angry",
	"emoticon-robot-angry": "robot-angry",
	"emoji-robot-angry-outline": "robot-angry-outline",
	"emoticon-robot-angry-outline": "robot-angry-outline",
	"emoji-robot-confused": "robot-confused",
	"emoticon-robot-confused": "robot-confused",
	"emoji-robot-confused-outline": "robot-confused-outline",
	"emoticon-robot-confused-outline": "robot-confused-outline",
	"emoji-robot-dead": "robot-dead",
	"emoticon-robot-dead": "robot-dead",
	"emoji-robot-dead-outline": "robot-dead-outline",
	"emoticon-robot-dead-outline": "robot-dead-outline",
	"emoticon-robot-excited": "robot-excited",
	"emoji-robot-excited": "robot-excited",
	"emoji-robot-excited-outline": "robot-excited-outline",
	"emoticon-robot-excited-outline": "robot-excited-outline",
	"emoji-robot-happy": "robot-happy",
	"emoticon-robot-happy": "robot-happy",
	"emoji-robot-happy-outline": "robot-happy-outline",
	"emoticon-robot-happy-outline": "robot-happy-outline",
	"autonomous": "robot-industrial",
	"assembly": "robot-industrial",
	"emoji-robot-love": "robot-love",
	"emoticon-robot-love": "robot-love",
	"lawn-mower": "robot-mower",
	"lawn-mower-outline": "robot-mower-outline",
	"emoji-robot-off": "robot-off",
	"emoticon-robot-off": "robot-off",
	"emoji-robot-outline": "robot-outline",
	"emoticon-robot-outline": "robot-outline",
	"roomba": "robot-vacuum",
	"robot-vacuum-error": "robot-vacuum-alert",
	"neato": "robot-vacuum-variant",
	"robot-vacuum-variant-error": "robot-vacuum-variant-alert",
	"mouse": "rodent",
	"rat": "rodent",
	"blinds-closed": "roller-shade-closed",
	"rollup-js": "rollupjs",
	"call-bell": "room-service",
	"call-bell-outline": "room-service-outline",
	"3d-rotation": "rotate-3d-variant",
	"arrow-rotate-left": "rotate-left",
	"arrow-rotate-right": "rotate-right",
	"wireless-router": "router-network-wireless",
	"sign-routes": "routes",
	"human-rowing": "rowing",
	"rss-feed": "rss",
	"rss-feed-box": "rss-box",
	"carpet": "rug",
	"rugby-ball": "rugby",
	"square": "ruler-square",
	"carpentry": "ruler-square",
	"architecture": "ruler-square",
	"mason": "ruler-square-compass",
	"masonic": "ruler-square-compass",
	"freemasonry": "ruler-square-compass",
	"directions-run": "run",
	"human-run": "run",
	"human-run-fast": "run-fast",
	"recreational-vehicle": "rv-truck",
	"campervan": "rv-truck",
	"safety-glasses": "safety-goggles",
	"sailing": "sail-boat",
	"sail-boat-crash": "sail-boat-sink",
	"sail-boat-wreck": "sail-boat-sink",
	"justice": "scale-balance",
	"legal": "scale-balance",
	"aroma": "scent",
	"fragrance": "scent",
	"smell": "scent",
	"odor": "scent",
	"aroma-off": "scent-off",
	"smell-off": "scent-off",
	"fragrance-off": "scent-off",
	"odor-off": "scent-off",
	"graduation-cap": "school",
	"university": "school",
	"academic-cap": "school",
	"academic-cap-outline": "school-outline",
	"college-outline": "school-outline",
	"graduation-cap-outline": "school-outline",
	"university-outline": "school-outline",
	"education-outline": "school-outline",
	"learn-outline": "school-outline",
	"screen-lock-rotation": "screen-rotation-lock",
	"scroll": "script",
	"scroll-outline": "script-outline",
	"scroll-text": "script-text",
	"scroll-text-outline": "script-text-outline",
	"sd-card": "sd",
	"sd-storage": "sd",
	"search-globe": "search-web",
	"global-search": "search-web",
	"internet-search": "search-web",
	"event-seat": "seat",
	"chair": "seat",
	"chair-accent": "sofa-single",
	"home-theater": "seat-outline",
	"home-theatre": "seat-outline",
	"airline-seat-flat": "seat-flat",
	"airline-seat-flat-angled": "seat-flat-angled",
	"airline-seat-individual-suite": "seat-individual-suite",
	"airline-seat-legroom-extra": "seat-legroom-extra",
	"airline-seat-legroom-normal": "seat-legroom-normal",
	"airline-seat-legroom-reduced": "seat-legroom-reduced",
	"event-seat-outline": "seat-outline",
	"chair-outline": "seat-outline",
	"chair-accent-outline": "sofa-single-outline",
	"airline-seat-recline-extra": "seat-recline-extra",
	"airline-seat-recline-normal": "seat-recline-normal",
	"seat-belt": "seatbelt",
	"safety-belt": "seatbelt",
	"shield": "security",
	"uac": "security",
	"user-access-control": "security",
	"administrator": "shield-crown",
	"shield-network": "security-network",
	"uac-network": "security-network",
	"administrator-network": "security-network",
	"seed-add": "seed-plus",
	"seed-add-outline": "seed-plus-outline",
	"playground-seesaw": "seesaw",
	"select-colour": "select-color",
	"selection-invert": "select-inverse",
	"select-location": "select-marker",
	"select-multiple-location": "select-multiple-marker",
	"selection-location": "selection-marker",
	"selection-multiple-location": "selection-multiple-marker",
	"rdf": "semantic-web",
	"resource-description-framework": "semantic-web",
	"owl": "semantic-web",
	"web-ontology-language": "semantic-web",
	"w3c": "semantic-web",
	"paper-airplane": "send",
	"paper-plane": "send",
	"send-secure": "send-lock",
	"paper-airplane-outline": "send-outline",
	"paper-plane-outline": "send-outline",
	"paper-plane-variant": "send-variant",
	"paper-airplane-variant": "send-variant",
	"paper-airplane-variant-outline": "send-variant-outline",
	"paper-plane-variant-outline": "send-variant-outline",
	"vga": "serial-port",
	"server-remove": "server-minus",
	"server-remove-outline": "server-minus-outline",
	"server-add": "server-plus",
	"server-add-outline": "server-plus-outline",
	"server-shield": "server-security",
	"set-union": "set-all",
	"set-or": "set-all",
	"full-outer-join": "set-all",
	"sql-full-outer-join": "set-all",
	"set-centre": "set-center",
	"set-intersection": "set-center",
	"set-and": "set-center",
	"inner-join": "set-center",
	"sql-inner-join": "set-center",
	"set-centre-right": "set-center-right",
	"outer-join-right": "set-center-right",
	"sql-right-outer-join": "set-center-right",
	"difference-left": "set-left",
	"set-left-centre": "set-left-center",
	"outer-join-left": "set-left-center",
	"sql-left-outer-join": "set-left-center",
	"exclusion": "set-left-right",
	"set-xor": "set-left-right",
	"set-null": "set-none",
	"set-not": "set-none",
	"venn-diagram": "set-none",
	"difference-right": "set-right",
	"fish-food": "shaker",
	"salt": "shaker-outline",
	"fish-food-outline": "shaker-outline",
	"category": "shape",
	"theme": "shape",
	"shape-circle-add": "shape-circle-plus",
	"theme-outline": "shape-outline",
	"category-outline": "shape-outline",
	"shape-add": "shape-plus",
	"category-plus": "shape-plus",
	"shape-add-outline": "shape-plus-outline",
	"category-plus-outline": "shape-plus-outline",
	"shape-polygon-add": "shape-polygon-plus",
	"shape-rectangle-add": "shape-rectangle-plus",
	"shape-square-add": "shape-square-plus",
	"forward": "share",
	"forward-off": "share-off",
	"forward-off-outline": "share-off-outline",
	"forward-outline": "share-outline",
	"jaws": "shark",
	"jaws-off": "shark-off",
	"emoji-sheep": "sheep",
	"emoticon-sheep": "sheep",
	"security-account": "shield-account",
	"shield-user": "shield-account",
	"shield-person": "shield-account",
	"alarm-arm-home": "shield-home-outline",
	"security-account-outline": "shield-account-outline",
	"shield-user-outline": "shield-account-outline",
	"shield-person-outline": "shield-account-outline",
	"alarm-arm-home-outline": "shield-account-outline",
	"shield-aeroplane": "shield-airplane",
	"shield-plane": "shield-airplane",
	"plane-shield": "shield-airplane",
	"shield-aeroplane-outline": "shield-airplane-outline",
	"shield-plane-outline": "shield-airplane-outline",
	"shield-warning": "shield-alert",
	"shield-warning-outline": "shield-alert-outline",
	"antivirus": "shield-bug",
	"antivirus-outline": "shield-bug-outline",
	"car-security": "shield-car",
	"car-insurance": "shield-car",
	"verified-user": "shield-check",
	"shield-tick": "shield-check",
	"shield-tick-outline": "shield-check-outline",
	"shield-templar": "shield-cross",
	"shield-christianity": "shield-cross",
	"shield-templar-outline": "shield-cross-outline",
	"shield-christianity-outline": "shield-cross-outline",
	"administrator-outline": "shield-crown-outline",
	"security-home": "shield-home",
	"shield-house": "shield-home",
	"shield-house-outline": "shield-home-outline",
	"security-lock": "shield-lock",
	"alarm-arm-away": "shield-lock",
	"shield-unlocked": "shield-lock-open",
	"shield-unlocked-outline": "shield-lock-open-outline",
	"alarm-arm-away-outline": "shield-lock-outline",
	"security-lock-outline": "shield-lock-outline",
	"alarm-arm-night": "shield-moon",
	"alarm-arm-night-outline": "shield-moon-outline",
	"security-off": "shield-off",
	"shield-add": "shield-plus",
	"shield-add-outline": "shield-plus-outline",
	"badge": "shield-star",
	"shield-favorite": "shield-star",
	"badge-outline": "shield-star-outline",
	"shield-favorite-outline": "shield-star-outline",
	"sun-protection": "shield-sun",
	"sun-protection-outline": "shield-sun-outline",
	"moderator": "shield-sword",
	"moderator-outline": "shield-sword-outline",
	"voyager": "ship-wheel",
	"helm": "ship-wheel",
	"slippers-ballet": "shoe-ballet",
	"footprints": "shoe-print",
	"shoe-running": "shoe-sneaker",
	"local-mall": "shopping",
	"marketplace": "shopping",
	"local-mall-outline": "shopping-outline",
	"marketplace-outline": "shopping-outline",
	"gardening": "shovel",
	"bathtub": "shower",
	"bathroom": "toilet",
	"ninja-star": "shuriken",
	"summation": "sigma",
	"milestone-minus": "sign-direction-minus",
	"milestone-plus": "sign-direction-plus",
	"sign-direction-add": "sign-direction-plus",
	"milestone-add": "sign-direction-plus",
	"milestone-remove": "sign-direction-remove",
	"give-way": "sign-yield",
	"signal-cellular-0": "signal-cellular-outline",
	"farm-outline": "silo-outline",
	"local-dining": "silverware",
	"restaurant-menu": "silverware",
	"local-restaurant": "silverware",
	"cutlery": "silverware",
	"silverware-shimmer": "silverware-clean",
	"cutlery-clean": "silverware-clean",
	"cutlery-fork": "silverware-fork",
	"restaurant": "table-chair",
	"fortnite": "silverware-fork-knife",
	"cutlery-fork-knife": "silverware-fork-knife",
	"place-setting": "silverware-fork-knife",
	"cutlery-spoon": "silverware-spoon",
	"cutlery-variant": "silverware-variant",
	"sim-card": "sim",
	"subscriber-identity-module": "sim",
	"subscriber-identification-module": "sim",
	"sim-warning": "sim-alert",
	"sim-card-alert": "sim-alert",
	"signal-cellular-no-sim": "sim-off",
	"sim-card-outline": "sim-outline",
	"subscriber-identity-module-outline": "sim-outline",
	"subscriber-identification-module-outline": "sim-outline",
	"current-ac": "sine-wave",
	"wave": "sine-wave",
	"analog": "sine-wave",
	"workflow": "sitemap",
	"flowchart": "sitemap",
	"workflow-outline": "sitemap-outline",
	"flowchart-outline": "sitemap-outline",
	"size-large": "size-l",
	"size-medium": "size-m",
	"size-small": "size-s",
	"size-extra-large": "size-xl",
	"size-extra-small": "size-xs",
	"size-extra-extra-large": "size-xxl",
	"size-extra-extra-small": "size-xxs",
	"ice-skate": "skate",
	"human-skateboarding": "skateboarding",
	"skew-decrease": "skew-less",
	"skew-increase": "skew-more",
	"human-ski": "ski",
	"nordic-walking": "ski-cross-country",
	"human-ski-cross-country": "ski-cross-country",
	"human-ski-water": "ski-water",
	"title-backward": "skip-backward",
	"previous-title": "skip-backward",
	"title-forward": "skip-forward",
	"next-title": "skip-forward",
	"jolly-roger": "skull-crossbones",
	"jolly-roger-outline": "skull-crossbones-outline",
	"x-ray": "skull-scan",
	"radiology": "skull-scan",
	"x-ray-outline": "skull-scan-outline",
	"radiology-outline": "skull-scan-outline",
	"microsoft-skype": "skype",
	"divide": "slash-forward",
	"division": "slash-forward",
	"divide-box": "slash-forward-box",
	"division-box": "slash-forward-box",
	"human-sledding": "sledding",
	"playground-slide": "slide",
	"casino": "slot-machine",
	"gambling": "slot-machine",
	"casino-outline": "slot-machine-outline",
	"gambling-outline": "slot-machine-outline",
	"smog": "smoke",
	"fire": "smoke",
	"nest-protect": "smoke-detector",
	"subwoofer": "smoke-detector",
	"cigarette": "smoking",
	"smoking-area": "smoking",
	"smoking-rooms": "smoking",
	"no-smoking": "smoking-off",
	"cigarette-off": "smoking-off",
	"smoke-free": "smoking-off",
	"gastropod": "snail",
	"reptile": "turtle",
	"human-snowboard": "snowboard",
	"power-hibernate": "snowflake",
	"cold-alert": "snowflake-alert",
	"snow-advisory": "snowflake-alert",
	"freeze-advisory": "snowflake-alert",
	"snowflake-approve": "snowflake-check",
	"defrost": "snowflake-melt",
	"frost-point": "snowflake-thermometer",
	"freezing-point": "snowflake-thermometer",
	"snowflake-temperature": "snowflake-thermometer",
	"football": "soccer",
	"football-pitch": "soccer-field",
	"couch": "sofa-single",
	"living-room": "sofa-single",
	"family-room": "sofa-single",
	"couch-outline": "sofa-single-outline",
	"living-room-outline": "sofa-single-outline",
	"family-room-outline": "sofa-single-outline",
	"loveseat": "sofa-single",
	"love-seat": "sofa-single",
	"loveseat-outline": "sofa-single-outline",
	"love-seat-outline": "sofa-single-outline",
	"solar-energy": "solar-power-variant",
	"solar-electricity": "solar-power-variant",
	"solar-panel-energy": "solar-panel-large",
	"solar-panel-electricity": "solar-panel-large",
	"solar-energy-outline": "solar-power-variant-outline",
	"solar-electricity-outline": "solar-power-variant-outline",
	"sony-playstation": "sony-playstation",
	"playstation-network": "sony-playstation",
	"sort-by-alpha": "sort-alphabetical-variant",
	"sort-alphabetically": "sort-alphabetical-variant",
	"sort-checkbox-ascending": "sort-bool-ascending-variant",
	"sort-checkbox-descending": "sort-bool-descending-variant",
	"sort-date-ascending": "sort-calendar-ascending",
	"sort-date-descending": "sort-calendar-descending",
	"sort-time-ascending": "sort-clock-ascending",
	"sort-time-ascending-outline": "sort-clock-ascending-outline",
	"sort-time-descending": "sort-clock-descending",
	"sort-time-descending-outline": "sort-clock-descending-outline",
	"sort-numerically": "sort-numeric-variant",
	"speaker-bar": "soundbar",
	"source-repositories": "source-repository-multiple",
	"soya-sauce": "soy-sauce",
	"flower-lotus": "spa",
	"flower-lotus-outline": "spa-outline",
	"speakers": "speaker-multiple",
	"staff": "spear",
	"fishing": "spear",
	"arachnid": "spider",
	"bug": "spider-thread",
	"arachnid-outline": "spider-outline",
	"arachnid-thread": "spider-thread",
	"cobweb": "spider-web",
	"arachnid-web": "spider-web",
	"aerosol": "spray",
	"cleaning": "spray-bottle",
	"irrigation": "sprinkler-variant",
	"sprinkler-mist": "sprinkler-fire",
	"mister": "sprinkler-fire",
	"sprinkler-head": "sprinkler-fire",
	"seedling": "sprout",
	"ecology": "sprout",
	"environment": "sprout",
	"seedling-outline": "sprout-outline",
	"plant-outline": "sprout-outline",
	"ecology-outline": "sprout-outline",
	"environment-outline": "sprout-outline",
	"vegetarian": "square-circle",
	"lacto-vegetarian": "square-circle",
	"square-transparent": "square-opacity",
	"push-notification": "square-rounded-badge",
	"push-notification-outline": "square-rounded-badge-outline",
	"stackexchange": "stack-exchange",
	"stackoverflow": "stack-overflow",
	"arena": "stadium-variant",
	"arena-outline": "stadium-outline",
	"grade": "star",
	"star-rate": "star",
	"favorite-box": "star-box",
	"favorite-box-multiple": "star-box-multiple",
	"favorite-box-multiple-outline": "star-box-multiple-outline",
	"favorite-box-outline": "star-box-outline",
	"favorite-check": "star-check",
	"favorite-check-outline": "star-check-outline",
	"favorite-circle": "star-circle",
	"feature-highlight": "star-circle-outline",
	"favorite-circle-outline": "star-circle-outline",
	"favorite-cog": "star-cog",
	"favorite-cog-outline": "star-cog-outline",
	"religion-islamic": "star-crescent",
	"religion-muslim": "star-crescent",
	"jewish": "synagogue",
	"religion-judaic": "star-david",
	"judaism": "star-david",
	"magen-david": "star-david",
	"favorite-face": "star-face",
	"emoji-star": "star-face",
	"emoticon-star": "star-face",
	"auto-box": "star-four-points-box",
	"auto-box-outline": "star-four-points-box-outline",
	"auto-circle": "star-four-points-circle",
	"auto-circle-outline": "star-four-points-circle-outline",
	"favorite-half": "star-half",
	"favorite-half-full": "star-half-full",
	"favorite-minus": "star-minus",
	"favorite-minus-outline": "star-minus-outline",
	"favorite-off": "star-off",
	"favorite-off-outline": "star-off-outline",
	"star-border": "star-outline",
	"favorite-plus": "star-plus",
	"star-add": "star-plus",
	"favorite-add": "star-plus",
	"star-add-outline": "star-plus-outline",
	"favorite-plus-outline": "star-plus-outline",
	"favorite-add-outline": "star-plus-outline",
	"favorite-remove": "star-remove",
	"favorite-remove-outline": "star-remove-outline",
	"favorite-settings": "star-settings",
	"favorite-settings-outline": "star-settings-outline",
	"favorite-shooting": "star-shooting",
	"favorite-shooting-outline": "star-shooting-outline",
	"search-hands-free": "steering",
	"search-hands-free-off": "steering-off",
	"frame-backward": "step-backward-2",
	"frame-forward": "step-forward-2",
	"propane-tank": "storage-tank",
	"gas-tank": "storage-tank",
	"propane-tank-outline": "storage-tank-outline",
	"gas-tank-outline": "storage-tank-outline",
	"shop": "store",
	"store-mall-directory": "store",
	"local-convenience-store": "store-24-hour",
	"shop-24-hour": "store-24-hour",
	"shop-alert": "store-alert",
	"shop-alert-outline": "store-alert-outline",
	"shop-check": "store-check",
	"shop-complete": "store-check-outline",
	"store-complete": "store-check",
	"store-complete-outline": "store-check-outline",
	"shop-check-outline": "store-check-outline",
	"store-schedule": "store-clock",
	"store-hours": "store-clock",
	"shop-clock": "store-clock",
	"shop-hours": "store-clock",
	"shop-schedule": "store-clock",
	"store-time": "store-clock",
	"shop-time": "store-clock",
	"shop-clock-outline": "store-clock-outline",
	"store-hours-outline": "store-clock-outline",
	"shop-hours-outline": "store-clock-outline",
	"store-time-outline": "store-clock-outline",
	"shop-time-outline": "store-clock-outline",
	"store-schedule-outline": "store-clock-outline",
	"shop-schedule-outline": "store-clock-outline",
	"store-settings": "store-cog",
	"shop-settings": "store-settings",
	"store-settings-outline": "store-cog-outline",
	"shop-settings-outline": "store-settings-outline",
	"shop-cog-outline": "store-cog-outline",
	"shop-edit": "store-edit",
	"shop-edit-outline": "store-edit-outline",
	"store-location": "store-marker",
	"shop-marker": "store-marker",
	"shop-location": "store-marker",
	"store-location-outline": "store-marker-outline",
	"shop-marker-outline": "store-marker-outline",
	"shop-location-outline": "store-marker-outline",
	"shop-minus": "store-minus",
	"shop-minus-outline": "store-minus-outline",
	"shop-off": "store-off",
	"shop-off-outline": "store-off-outline",
	"shop-outline": "store-outline",
	"store-mall-directory-outline": "store-outline",
	"shop-plus": "store-plus",
	"shop-plus-outline": "store-plus-outline",
	"shop-remove": "store-remove",
	"store-delete": "store-remove",
	"shop-delete": "store-remove",
	"shop-remove-outline": "store-remove-outline",
	"store-delete-outline": "store-remove-outline",
	"shop-delete-outline": "store-remove-outline",
	"shop-search": "store-search",
	"store-find": "store-search",
	"shop-find": "store-search",
	"store-locator": "store-search",
	"shop-locator": "store-search",
	"store-look-up": "store-search",
	"shop-look-up": "store-search",
	"store-find-outline": "store-search-outline",
	"shop-search-outline": "store-search-outline",
	"shop-find-outline": "store-search-outline",
	"store-locator-outline": "store-search-outline",
	"shop-locator-outline": "store-search-outline",
	"store-look-up-outline": "store-search-outline",
	"shop-look-up-outline": "store-search-outline",
	"awning": "storefront-outline",
	"cooker": "stove",
	"oven": "stove",
	"football-play": "strategy",
	"italian-lights": "string-lights",
	"christmas-lights": "string-lights",
	"fairy-lights": "string-lights",
	"italian-lights-off": "string-lights-off",
	"christmas-lights-off": "string-lights-off",
	"fairy-lights-off": "string-lights-off",
	"metro": "subway",
	"tube": "subway",
	"underground": "subway",
	"subway-warning-variant": "subway-alert-variant",
	"metro-variant": "subway-variant",
	"tube-variant": "subway-variant",
	"underground-variant": "subway-variant",
	"directions-subway": "subway-variant",
	"directions-transit": "subway-variant",
	"peak": "summit",
	"solar-angle": "sun-angle",
	"solar-angle-outline": "sun-angle-outline",
	"sun-schedule": "sun-clock",
	"sun-time": "sun-clock",
	"time-of-day": "sun-clock",
	"sun-schedule-outline": "sun-clock-outline",
	"sun-time-outline": "sun-clock-outline",
	"time-of-day-outline": "sun-clock-outline",
	"sun-azimuth": "sun-compass",
	"solar-compass": "sun-compass",
	"solar-asimuth": "sun-compass",
	"hot-cold": "sun-snowflake-variant",
	"heat-cool": "sun-snowflake-variant",
	"heat-index": "sun-thermometer-outline",
	"sun-temperature": "sun-thermometer",
	"day-temperature": "sun-thermometer-outline",
	"external-temperature": "sun-thermometer-outline",
	"outdoor-temperature": "sun-thermometer",
	"outside-temperature": "sun-thermometer-outline",
	"weather-sun-wireless": "sun-wireless",
	"illuminance": "sun-wireless",
	"uv-ray": "sun-wireless",
	"ultraviolet": "sun-wireless",
	"weather-sun-wireless-outline": "sun-wireless-outline",
	"illuminance-outline": "sun-wireless-outline",
	"uv-ray-outline": "sun-wireless-outline",
	"ultraviolet-outline": "sun-wireless-outline",
	"stereo": "surround-sound-2-0",
	"arrow-left-right": "swap-horizontal",
	"transfer": "swap-horizontal",
	"exchange": "swap-horizontal",
	"arrow-left-right-bold": "swap-horizontal-bold",
	"import-export": "swap-vertical",
	"arrow-up-down": "swap-vertical",
	"arrow-up-down-bold": "swap-vertical-bold",
	"import-export-bold": "swap-vertical-bold",
	"swap-calls": "swap-vertical-variant",
	"writing-system-hangul": "syllabary-hangul",
	"writing-system-hiragana": "syllabary-hiragana",
	"writing-system-katakana": "syllabary-katakana",
	"writing-system-katakana-half-width": "syllabary-katakana-halfwidth",
	"shul": "synagogue",
	"temple": "synagogue",
	"temple-outline": "synagogue-outline",
	"shul-outline": "synagogue-outline",
	"jewish-outline": "synagogue-outline",
	"sync-warning": "sync-alert",
	"sync-problem": "sync-alert",
	"sync-disabled": "sync-off",
	"tab-add": "tab-plus",
	"tab-find": "tab-search",
	"table-user": "table-account",
	"table-download": "table-arrow-down",
	"table-import": "table-arrow-left",
	"table-share": "table-arrow-right",
	"table-export": "table-arrow-right",
	"table-upload": "table-arrow-up",
	"dining": "table-chair",
	"dining-room": "table-furniture",
	"table-settings": "table-cog",
	"table-column-add-after": "table-column-plus-after",
	"table-column-add-before": "table-column-plus-before",
	"table-favorite": "table-star",
	"table-large-add": "table-large-plus",
	"toc": "table-of-contents",
	"table-add": "table-plus",
	"table-help": "table-question",
	"table-row-add-after": "table-row-plus-after",
	"table-row-add-before": "table-row-plus-before",
	"ping-pong": "table-tennis",
	"whiff-whaff": "table-tennis",
	"mobile-devices": "tablet-cellphone",
	"tablet-mobile-phone": "tablet-cellphone",
	"tablet-smartphone": "tablet-cellphone",
	"local-offer": "tag",
	"tag-approve": "tag-check",
	"tag-approve-outline": "tag-check-outline",
	"tag-emoji": "tag-faces",
	"tag-emoticon": "tag-faces",
	"loyalty": "tag-heart",
	"tags": "tag-multiple",
	"tag-add": "tag-plus",
	"tag-find": "tag-search",
	"tag-find-outline": "tag-search-outline",
	"counting-1": "tally-mark-1",
	"one": "tally-mark-1",
	"counting-2": "tally-mark-2",
	"two": "tally-mark-2",
	"counting-3": "tally-mark-3",
	"three": "tally-mark-3",
	"counting-4": "tally-mark-4",
	"four": "tally-mark-4",
	"counting-5": "tally-mark-5",
	"five": "tally-mark-5",
	"puzzle": "tangram",
	"fuel-truck": "tanker-truck",
	"oil-truck": "tanker-truck",
	"water-truck": "tanker-truck",
	"tanker": "tanker-truck",
	"measuring-tape": "tape-measure",
	"registration-mark": "target-variant",
	"crosshairs-account": "target-account",
	"target-user": "target-account",
	"local-taxi": "taxi",
	"cab": "taxi",
	"child-toy": "teddy-bear",
	"children-toy": "teddy-bear",
	"kids-room": "teddy-bear",
	"childrens-room": "teddy-bear",
	"play-room": "teddy-bear",
	"tv": "television",
	"tv-box": "television-box",
	"tv-guide": "television-box",
	"tv-classic": "television-classic",
	"tv-classic-off": "television-classic-off",
	"tv-off": "television-off",
	"television-clean": "television-shimmer",
	"temperature-centigrade": "temperature-celsius",
	"tennis-racquet": "tennis",
	"tennis-racket": "tennis",
	"biography": "text-account",
	"text-user": "text-account",
	"drive-document": "text-box",
	"file-document-box": "text-box",
	"file-document-box-tick": "text-box-check",
	"file-document-box-check": "text-box-check",
	"file-document-box-tick-outline": "text-box-check-outline",
	"file-document-box-check-outline": "text-box-check-outline",
	"file-document-box-minus": "text-box-minus",
	"file-document-box-minus-outline": "text-box-minus-outline",
	"file-document-boxes": "text-box-multiple",
	"file-document-box-multiple": "text-box-multiple",
	"file-document-boxes-outline": "text-box-multiple-outline",
	"file-document-box-multiple-outline": "text-box-multiple-outline",
	"file-document-box-outline": "text-box-outline",
	"file-document-box-plus": "text-box-plus",
	"file-document-box-plus-outline": "text-box-plus-outline",
	"file-document-box-remove": "text-box-remove",
	"file-document-box-remove-outline": "text-box-remove-outline",
	"file-document-box-search": "text-box-search",
	"file-document-box-search-outline": "text-box-search-outline",
	"text-subject": "text-long",
	"notes-search": "text-search",
	"notes-search-variant": "text-search-variant",
	"surface-area": "texture-box",
	"cinema": "theater",
	"sun-moon-stars": "theme-light-dark",
	"temperature": "thermometer",
	"thermometer-warning": "thermometer-alert",
	"temperature-alert": "thermometer-alert",
	"temperature-warning": "thermometer-alert",
	"temperature-auto": "thermometer-auto",
	"temperature-bluetooth": "thermometer-bluetooth",
	"thermometer-approve": "thermometer-check",
	"temperature-check": "thermometer-check",
	"temperature-approve": "thermometer-check",
	"temperature-chevron-down": "thermometer-chevron-down",
	"temperature-decrease": "thermometer-minus",
	"thermometer-decrease": "thermometer-minus",
	"temperature-chevron-up": "thermometer-chevron-up",
	"temperature-increase": "thermometer-plus",
	"thermometer-increase": "thermometer-plus",
	"temperature-high": "thermometer-high",
	"temperature-lines": "thermometer-lines",
	"temperature-low": "thermometer-low",
	"temperature-minus": "thermometer-minus",
	"temperature-off": "thermometer-off",
	"thermometer-add": "thermometer-plus",
	"temperature-plus": "thermometer-plus",
	"temperature-add": "thermometer-plus",
	"dew-point": "water-thermometer",
	"water-temperature": "water-thermometer",
	"boiling-point": "thermometer-water",
	"nest": "thermostat",
	"comic-bubble": "thought-bubble",
	"thinking": "thought-bubble",
	"comic-thought-bubble-outline": "thought-bubble-outline",
	"thinking-outline": "thought-bubble-outline",
	"think-outline": "thought-bubble-outline",
	"dislike": "thumb-down",
	"thumbs-down": "thumb-down",
	"dislike-outline": "thumb-down-outline",
	"thumbs-down-outline": "thumb-down-outline",
	"like": "thumb-up",
	"thumbs-up": "thumb-up",
	"like-outline": "thumb-up-outline",
	"thumbs-up-outline": "thumb-up-outline",
	"like-dislike": "thumbs-up-down",
	"like-dislike-outline": "thumbs-up-down-outline",
	"local-activity": "ticket",
	"local-play": "ticket",
	"local-attraction": "ticket",
	"ticket-user": "ticket-account",
	"confirmation-number": "ticket-confirmation",
	"confirmation-number-outline": "ticket-confirmation-outline",
	"coupon": "ticket-percent",
	"voucher": "ticket-percent",
	"coupon-outline": "ticket-percent-outline",
	"voucher-outline": "ticket-percent-outline",
	"timeline-help": "timeline-question",
	"timeline-help-outline": "timeline-question-outline",
	"stopwatch": "timer",
	"timer-ten": "timer-10",
	"timer-three": "timer-3",
	"stopwatch-alert": "timer-alert",
	"stopwatch-alert-outline": "timer-alert-outline",
	"stopwatch-cancel": "timer-cancel",
	"stopwatch-cancel-outline": "timer-cancel-outline",
	"stopwatch-check": "timer-check",
	"timer-tick": "timer-check",
	"stopwatch-tick": "timer-check",
	"timer-tick-outline": "timer-check-outline",
	"stopwatch-check-outline": "timer-check-outline",
	"stopwatch-tick-outline": "timer-check-outline",
	"timer-settings": "timer-cog",
	"timer-settings-outline": "timer-cog-outline",
	"stopwatch-edit": "timer-edit",
	"stopwatch-edit-outline": "timer-edit-outline",
	"stopwatch-lock": "timer-lock",
	"timer-secure": "timer-lock",
	"stopwatch-secure": "timer-lock",
	"stopwatch-lock-open": "timer-lock-open",
	"stopwatch-lock-open-outline": "timer-lock-open-outline",
	"stopwatch-lock-outline": "timer-lock-outline",
	"stopwatch-secure-outline": "timer-lock-outline",
	"timer-secure-outline": "timer-lock-outline",
	"stopwatch-marker": "timer-marker",
	"timer-location": "timer-marker",
	"stopwatch-location": "timer-marker",
	"stopwatch-marker-outline": "timer-marker-outline",
	"timer-location-outline": "timer-marker-outline",
	"stopwatch-location-outline": "timer-marker-outline",
	"timer-subtract": "timer-minus",
	"stopwatch-minus": "timer-minus",
	"stopwatch-subtract": "timer-minus",
	"timer-subtract-outline": "timer-minus-outline",
	"stopwatch-minus-outline": "timer-minus-outline",
	"stopwatch-subtract-outline": "timer-minus-outline",
	"stopwatch-music": "timer-music",
	"stopwatch-music-outline": "timer-music-outline",
	"stopwatch-off": "timer-off",
	"stopwatch-off-outline": "timer-off-outline",
	"stopwatch-outline": "timer-outline",
	"stopwatch-pause": "timer-pause",
	"stopwatch-pause-outline": "timer-pause-outline",
	"timer-start": "timer-play",
	"stopwatch-play": "timer-play",
	"stopwatch-start": "timer-play",
	"timer-start-outline": "timer-play-outline",
	"stopwatch-play-outline": "timer-play-outline",
	"stopwatch-start-outline": "timer-play-outline",
	"timer-add": "timer-plus",
	"stopwatch-plus": "timer-plus",
	"stopwatch-add": "timer-plus",
	"timer-add-outline": "timer-plus-outline",
	"stopwatch-plus-outline": "timer-plus-outline",
	"stopwatch-add-outline": "timer-plus-outline",
	"stopwatch-refresh": "timer-refresh",
	"stopwatch-refresh-outline": "timer-refresh-outline",
	"stopwatch-remove": "timer-remove",
	"stopwatch-remove-outline": "timer-remove-outline",
	"hourglass": "timer-sand",
	"hourglass-complete": "timer-sand-complete",
	"hourglass-empty": "timer-sand-empty",
	"hourglass-full": "timer-sand-full",
	"hourglass-paused": "timer-sand-paused",
	"timer-favorite": "timer-star",
	"stopwatch-star": "timer-star",
	"stopwatch-favorite": "timer-star",
	"timer-favorite-outline": "timer-star-outline",
	"stopwatch-star-outline": "timer-star-outline",
	"stopwatch-favorite-outline": "timer-star-outline",
	"stopwatch-stop": "timer-stop",
	"stopwatch-stop-outline": "timer-stop-outline",
	"stopwatch-sync": "timer-sync",
	"stopwatch-sync-outline": "timer-sync-outline",
	"tyre": "tire",
	"wheel": "tire",
	"light-switch-on": "toggle-switch-variant",
	"light-switch-off": "toggle-switch-variant-off",
	"lavatory": "toilet",
	"bidet": "toilet",
	"service-toolbox": "toolbox-outline",
	"wrench": "tools",
	"screwdriver": "tools",
	"tooltip-user": "tooltip-account",
	"tooltip-person": "tooltip-account",
	"account-location": "tooltip-account",
	"tooltip-add": "tooltip-plus",
	"tooltip-outline-plus": "tooltip-plus-outline",
	"tooltip-add-outline": "tooltip-plus-outline",
	"tooltip-help": "tooltip-question",
	"tooltip-help-outline": "tooltip-question-outline",
	"dentist": "toothbrush-paste",
	"oral-hygiene": "toothbrush-paste",
	"olympics": "torch",
	"turtle": "tortoise",
	"optical-audio": "toslink",
	"bracket": "tournament",
	"auto-towing": "tow-truck",
	"truck": "tow-truck",
	"school": "town-hall",
	"lego": "toy-brick-search-outline",
	"plugin": "toy-brick-search-outline",
	"lego-location": "toy-brick-marker",
	"toy-brick-location": "toy-brick-marker",
	"lego-location-outline": "toy-brick-marker-outline",
	"toy-brick-location-outline": "toy-brick-marker-outline",
	"plugin-outline": "toy-brick-marker-outline",
	"lego-outline": "toy-brick-marker-outline",
	"agriculture": "tractor-variant",
	"tm": "trademark",
	"traffic-signal": "traffic-light",
	"stop-light": "traffic-light",
	"traffic-signal-outline": "traffic-light-outline",
	"stop-light-outline": "traffic-light-outline",
	"directions-railway": "train",
	"locomotive": "train",
	"railroad": "train",
	"commute": "train-car",
	"transportation": "train-car",
	"travel": "train-car",
	"locomotive-variant": "train-variant",
	"railroad-variant": "train-variant",
	"transfer-within-a-station": "transit-transfer",
	"animation": "transition",
	"motion": "transition",
	"translate": "transition",
	"masked-transitions": "transition-masked",
	"language": "web",
	"spoken-language": "translate-variant",
	"pylon": "transmission-tower",
	"powerline": "transmission-tower",
	"grid": "transmission-tower",
	"power-from-grid": "transmission-tower-export",
	"energy-from-grid": "transmission-tower-export",
	"electricity-from-grid": "transmission-tower-export",
	"power-to-grid": "transmission-tower-import",
	"energy-to-grid": "transmission-tower-import",
	"electricity-to-grid": "transmission-tower-import",
	"return-to-grid": "transmission-tower-import",
	"powerline-off": "transmission-tower-off",
	"pylon-off": "transmission-tower-off",
	"grid-off": "transmission-tower-off",
	"delete": "trash-can",
	"trashcan": "trash-can",
	"delete-outline": "trash-can-outline",
	"trashcan-outline": "trash-can-outline",
	"printer": "tray-remove",
	"inbox": "tray-remove",
	"tray-download": "tray-arrow-down",
	"tray-upload": "tray-arrow-up",
	"jewelry-box": "treasure-chest",
	"jewel-case": "treasure-chest",
	"jewel-case-outline": "treasure-chest-outline",
	"jewelry-box-outline": "treasure-chest-outline",
	"trending-flat": "trending-neutral",
	"trending-down-variant": "triangle-small-down",
	"trending-up-variant": "triangle-small-up",
	"zelda": "triforce",
	"achievement": "trophy",
	"achievement-award": "trophy-award",
	"achievement-outline": "trophy-outline",
	"achievement-variant": "trophy-variant",
	"achievement-variant-outline": "trophy-variant-outline",
	"lorry": "truck",
	"local-shipping": "truck",
	"courier": "truck",
	"truck-error": "truck-alert",
	"truck-error-outline": "truck-alert-outline",
	"truck-shipping": "truck-cargo-container",
	"truck-tick": "truck-check",
	"lorry-check": "truck-check",
	"courier-check": "truck-check",
	"lorry-delivery": "truck-delivery",
	"lorry-fast": "truck-fast",
	"courier-fast": "truck-fast",
	"truck-flatbed-tow": "truck-flatbed",
	"truck-subtract": "truck-minus",
	"truck-subtract-outline": "truck-minus-outline",
	"truck-add": "truck-plus",
	"truck-add-outline": "truck-plus-outline",
	"truck-refrigerator": "truck-snowflake",
	"truck-freezer": "truck-snowflake",
	"t-shirt-crew": "tshirt-crew",
	"t-shirt-crew-outline": "tshirt-crew-outline",
	"t-shirt-v": "tshirt-v",
	"t-shirt-v-outline": "tshirt-v-outline",
	"laundry-room": "washing-machine",
	"laundry-room-alert": "washing-machine-alert",
	"laundry-room-off": "washing-machine-off",
	"mixer-settings": "tune",
	"equaliser": "tune",
	"equalizer": "tune-variant",
	"slider": "tune-variant",
	"equaliser-vertical": "tune-vertical",
	"instant-mix": "tune-vertical",
	"settings-vertical": "tune-vertical-variant",
	"mixer-settings-vertical": "tune-vertical",
	"equalizer-vertical": "tune-vertical-variant",
	"slider-vertical": "tune-vertical-variant",
	"jet-engine": "turbine",
	"wind-turbine": "turbine",
	"uplay": "ubisoft",
	"unidentified-flying-object": "ufo",
	"alien": "ufo-outline",
	"unidentified-flying-object-outline": "ufo-outline",
	"uhd": "ultra-high-definition",
	"briefs-outline": "underwear-outline",
	"chevron-down-up": "unfold-less-horizontal",
	"collapse-horizontal": "unfold-less-horizontal",
	"chevron-right-left": "unfold-less-vertical",
	"collapse-vertical": "unfold-less-vertical",
	"chevron-up-down": "unfold-more-horizontal",
	"expand-horizontal": "unfold-more-horizontal",
	"chevron-left-right": "unfold-more-vertical",
	"expand-vertical": "unfold-more-vertical",
	"fantasy": "unicorn",
	"fantasy-variant": "unicorn-variant",
	"unreal-engine": "unreal",
	"clockwise": "update",
	"file-upload": "upload",
	"uploads": "upload-multiple",
	"file-upload-outline": "upload-outline",
	"vacuum-cleaner": "vacuum",
	"vacuum-cleaner-outline": "vacuum-outline",
	"van-candy": "van-utility",
	"bezier": "vector-curve",
	"vector-point-add": "vector-point-plus",
	"mdi": "vector-square",
	"vector-square-subtract": "vector-square-minus",
	"vector-square-add": "vector-square-plus",
	"vector-square-delete": "vector-square-remove",
	"video-home-system": "vhs",
	"vhs-cassette": "vhs",
	"vhs-tape": "vhs",
	"vibration": "vibrate",
	"videocam": "video",
	"4k": "video-4k-box",
	"video-user": "video-account",
	"settings-input-antenna": "video-input-antenna",
	"video-input-composite": "video-input-component",
	"settings-input-component": "video-input-component",
	"settings-input-composite": "video-input-component",
	"video-input-ypbpr": "video-input-component",
	"rca": "video-input-component",
	"settings-input-hdmi": "video-input-hdmi",
	"settings-input-svideo": "video-input-svideo",
	"video-location": "video-marker",
	"video-location-outline": "video-marker-outline",
	"video-remove": "video-minus",
	"videocam-off": "video-off",
	"videocam-off-outline": "video-off-outline",
	"videocam-outline": "video-outline",
	"video-call": "video-plus",
	"video-add": "video-plus",
	"video-stabilisation": "video-stabilization",
	"video-sd": "video-standard-definition",
	"video-quality-sd": "video-standard-definition",
	"switch-video": "video-switch",
	"video-film": "video-vintage",
	"video-classic": "video-vintage",
	"view-grid-add": "view-grid-plus",
	"vr": "virtual-reality",
	"eruption": "volcano",
	"eruption-outline": "volcano-outline",
	"speaker": "volume-medium",
	"speakerphone": "volume-high",
	"volume-decrease": "volume-minus",
	"mute": "volume-off",
	"audio-off": "volume-off",
	"speaker-off": "volume-off",
	"speakerphone-off": "volume-off",
	"volume-increase": "volume-plus",
	"how-to-vote": "vote",
	"how-to-vote-outline": "vote-outline",
	"virtual-private-network": "vpn",
	"vue-js": "vuejs",
	"directions-walk": "walk",
	"walker": "walk",
	"walking": "walk",
	"human-walk": "walk",
	"bricks": "wall",
	"firewall": "wall-fire",
	"ceiling-light-flat": "wall-sconce-flat",
	"pot-light-flat": "wall-sconce-flat",
	"pot-light-flat-variant": "wall-sconce-flat-variant",
	"pot-light-round": "wall-sconce-round",
	"pot-light-round-variant": "wall-sconce-round-variant",
	"account-balance-wallet": "wallet",
	"card-giftcard": "wallet-giftcard",
	"redeem": "wallet-giftcard",
	"card-membership": "wallet-membership",
	"account-balance-wallet-outline": "wallet-outline",
	"wallet-add": "wallet-plus",
	"wallet-add-outline": "wallet-plus-outline",
	"card-travel": "wallet-travel",
	"wide-area-network": "wan",
	"closet-outline": "wardrobe-outline",
	"laundrette": "washing-machine",
	"local-laundry-service": "washing-machine",
	"washer": "washing-machine",
	"washer-alert": "washing-machine-alert",
	"washer-off": "washing-machine-off",
	"drop": "water",
	"water-drop": "water",
	"trans-fat": "water",
	"ink": "water",
	"drop-alert": "water-alert",
	"blood-alert": "water-alert",
	"ink-alert": "water-alert",
	"drop-alert-outline": "water-alert-outline",
	"blood-alert-outline": "water-alert-outline",
	"ink-alert-outline": "water-alert-outline",
	"water-heater": "water-boiler",
	"gas-water-boiler": "water-boiler",
	"electric-water-boiler": "water-boiler",
	"gas-water-heater": "water-boiler",
	"electric-water-heater": "water-boiler",
	"water-heater-alert": "water-boiler-alert",
	"water-boiler-error": "water-boiler-alert",
	"water-heater-error": "water-boiler-alert",
	"water-heater-auto": "water-boiler-auto",
	"water-heater-off": "water-boiler-off",
	"drop-check": "water-check",
	"blood-check": "water-check",
	"ink-check": "water-check",
	"drop-check-outline": "water-check-outline",
	"blood-check-outline": "water-check-outline",
	"ink-check-outline": "water-check-outline",
	"drop-circle": "water-circle",
	"blood-circle": "water-circle",
	"ink-circle": "water-circle",
	"drop-minus": "water-minus",
	"blood-minus": "water-minus",
	"ink-minus": "water-minus",
	"drop-minus-outline": "water-minus-outline",
	"blood-minus-outline": "water-minus-outline",
	"ink-minus-outline": "water-minus-outline",
	"format-color-reset": "water-off",
	"trans-fat-off": "water-off",
	"blood-off": "water-off",
	"ink-off": "water-off",
	"drop-off-outline": "water-off-outline",
	"blood-off-outline": "water-off-outline",
	"trans-fat-off-outline": "water-off-outline",
	"ink-off-outline": "water-off-outline",
	"water-transparent": "water-opacity",
	"water-saver": "water-opacity",
	"blood-saver": "water-opacity",
	"blood-transparent": "water-opacity",
	"oil-saver": "water-opacity",
	"oil-transparent": "water-opacity",
	"drop-transparent": "water-opacity",
	"drop-saver": "water-opacity",
	"drop-outline": "water-outline",
	"blood-outline": "water-outline",
	"water-drop-outline": "water-outline",
	"ink-outline": "water-outline",
	"ink-percent": "water-percent",
	"humidity-alert": "water-percent-alert",
	"ink-percent-alert": "water-percent-alert",
	"drop-plus": "water-plus",
	"blood-plus": "water-plus",
	"ink-plus": "water-plus",
	"drop-plus-outline": "water-plus-outline",
	"blood-plus-outline": "water-plus-outline",
	"ink-plus-outline": "water-plus-outline",
	"tap": "water-pump",
	"faucet": "water-pump",
	"tap-off": "water-pump-off",
	"kitchen-tap-off": "water-pump-off",
	"faucet-off": "water-pump-off",
	"drop-remove": "water-remove",
	"blood-remove": "water-remove",
	"ink-remove": "water-remove",
	"drop-remove-outline": "water-remove-outline",
	"blood-remove-outline": "water-remove-outline",
	"ink-remove-outline": "water-remove-outline",
	"water-recycle": "water-sync",
	"water-reuse": "water-sync",
	"boil-point": "water-thermometer",
	"dew-point-outline": "water-thermometer-outline",
	"water-temperature-outline": "water-thermometer-outline",
	"boil-point-outline": "water-thermometer-outline",
	"watering-pot": "watering-can",
	"watering-pot-outline": "watering-can-outline",
	"branding-watermark": "watermark",
	"ocean": "waves",
	"lake": "waves",
	"flood": "waves",
	"tide-in": "waves-arrow-left",
	"water-flow": "waves-arrow-right",
	"tide-out": "waves-arrow-right",
	"water-evaporation": "waves-arrow-up",
	"sea-level-rise": "waves-arrow-up",
	"ocean-level-rise": "waves-arrow-up",
	"climate-change": "waves-arrow-up",
	"weather-history": "weather-cloudy-clock",
	"weather-time": "weather-cloudy-clock",
	"weather-date": "weather-cloudy-clock",
	"dust-storm": "weather-dust",
	"windy": "weather-dust",
	"weather-mist": "weather-fog",
	"cyclone": "weather-hurricane",
	"cyclone-outline": "weather-hurricane-outline",
	"weather-storm": "weather-lightning-rainy",
	"weather-thunder": "weather-lightning",
	"weather-flash": "weather-lightning",
	"weather-thunder-rainy": "weather-lightning-rainy",
	"moonrise": "weather-moonset-up",
	"moon-and-stars": "weather-night",
	"night-sky": "weather-night",
	"weather-night-outline": "weather-night",
	"weather-partlycloudy": "weather-partly-cloudy",
	"weather-heavy-rain": "weather-pouring",
	"weather-drizzle": "weather-rainy",
	"weather-spitting": "weather-rainy",
	"flurries": "weather-snowy-heavy",
	"weather-sleet": "weather-snowy-rainy",
	"heat-alert": "weather-sunny-alert",
	"heat-advisory": "weather-sunny-alert",
	"sun-advisory": "weather-sunny-alert",
	"sunrise": "weather-sunset-up",
	"internet": "web",
	"world-wide-web": "web",
	"language-box": "web-box",
	"internet-box": "web-box",
	"web-camera": "webcam",
	"weight-kg": "weight-kilogram",
	"crossfit": "weight-lifter",
	"human-barbell": "weight-lifter",
	"weight-lb": "weight-pound",
	"accessible": "wheelchair-accessibility",
	"isa": "wheelchair",
	"international-symbol-of-access": "wheelchair",
	"wb-auto": "white-balance-auto",
	"wb-incandescent": "white-balance-incandescent",
	"wb-iridescent": "white-balance-iridescent",
	"wb-sunny": "white-balance-sunny",
	"wifi-location": "wifi-marker",
	"wifi-favourite": "wifi-star",
	"network-favourite": "wifi-star",
	"wifi-favorite": "wifi-star",
	"network-favorite": "wifi-star",
	"wifi-strength-1-warning": "wifi-strength-1-alert",
	"wifi-strength-2-warning": "wifi-strength-2-alert",
	"wifi-strength-3-warning": "wifi-strength-3-alert",
	"wifi-strength-4-warning": "wifi-strength-4-alert",
	"wifi-strength-warning-outline": "wifi-strength-alert-outline",
	"wifi-strength-0-alert": "wifi-strength-alert-outline",
	"wifi-strength-0-warning": "wifi-strength-alert-outline",
	"wifi-strength-0-lock": "wifi-strength-lock-outline",
	"wifi-strength-0": "wifi-strength-outline",
	"wind-energy": "wind-power",
	"wind-electricity": "wind-turbine",
	"wind-energy-outline": "wind-power-outline",
	"wind-electricity-outline": "wind-power-outline",
	"wind-power": "wind-turbine",
	"wind-power-alert": "wind-turbine-alert",
	"wind-turbine-warning": "wind-turbine-alert",
	"wind-power-check": "wind-turbine-check",
	"wind-turbine-success": "wind-turbine-check",
	"wind-power-success": "wind-turbine-check",
	"close": "window-close",
	"window-shutter-settings": "window-shutter-cog",
	"wiper-fluid": "wiper-wash",
	"washer-fluid": "wiper-wash",
	"wiper-fluid-alert": "wiper-wash-alert",
	"washer-fluid-alert": "wiper-wash-alert",
	"wiper-fluid-low": "wiper-wash-alert",
	"washer-fluid-low": "wiper-wash-alert",
	"unwrap": "wrap-disabled",
	"build": "wrench",
	"spanner": "wrench",
	"scheduled-maintenance": "wrench-clock",
	"wrench-time": "wrench-clock",
	"tool-time": "wrench-clock",
	"tool-clock": "wrench-clock",
	"wrench-settings": "wrench-cog",
	"wrench-settings-outline": "wrench-cog-outline",
	"build-outline": "wrench-outline",
	"spanner-outline": "wrench-outline",
	"microsoft-xamarin": "xamarin",
	"code": "xml",
	"taoism": "yin-yang",
	"video-youtube": "youtube",
	"youtube-play": "youtube",
	"youtube-creator-studio": "youtube-studio",
	"zwave": "z-wave",
	"compressed-file": "zip-box",
	"compressed-file-outline": "zip-box-outline",
	"horoscope-aquarius": "zodiac-aquarius",
	"horoscope-aries": "zodiac-aries",
	"horoscope-cancer": "zodiac-cancer",
	"horoscope-capricorn": "zodiac-capricorn",
	"horoscope-gemini": "zodiac-gemini",
	"horoscope-leo": "zodiac-leo",
	"horoscope-libra": "zodiac-libra",
	"horoscope-pisces": "zodiac-pisces",
	"horoscope-sagittarius": "zodiac-sagittarius",
	"horoscope-scorpio": "zodiac-scorpio",
	"horoscope-taurus": "zodiac-taurus",
	"horoscope-virgo": "zodiac-virgo"
};
